webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/S0O1Bz/%3F1726755969783&title=Lanny%20Budd%20Novels%20Volume%20Two%2C%20The%20Lanny%20Budd%20Novels&summary=Books%20four%20through%20six%20in%20the%20Pulitzer%20Prize%26ndash%3Bwinning%20series%20of%20historical%20novels%20about%20an%20international%20spy%20in%20the%20first%20half%20of%20the%20twentieth%20century.%26%23160%3B%20%20%26%23160%3B%20An%20ambitious%20and%20entertaining%20mix%20of%20history%2C%20adventure%2C%20and%20rom&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/S0O1Bz/%3F1726755969783",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Books%20four%20through%20six%20in%20the%20Pulitzer%20Prize%26ndash%3Bwinning%20series%20of%20historical%20novels%20about%20an%20international%20spy%20in%20the%20first%20half%20of%20the%20tw%0Dhttps://textcafe.co/books/S0O1Bz/%3F1726755969783&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/S0O1Bz/%3F1726755969783&posttype=link&caption=Books%20four%20through%20six%20in%20the%20Pulitzer%20Prize%26ndash%3Bwinning%20series%20of%20historical%20novels%20about%20an%20international%20spy%20in%20the%20first%20half%20of%20the%20twentieth%20century.%26%23160%3B%20%20%26%23160%3B%20An%20ambitious%20and%20entertaining%20mix%20of%20history%2C%20adventure%2C%20and%20rom",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/S0O1Bz/%3F1726755969783&description=Books%20four%20through%20six%20in%20the%20Pulitzer%20Prize%26ndash%3Bwinning%20series%20of%20historical%20novels%20about%20an%20international%20spy%20in%20the%20first%20half%20of%20the%20twentieth%20century.%26%23160%3B%20%20%26%23160%3B%20An%20ambitious%20and%20entertaining%20mix%20of%20history%2C%20adventure%2C%20and%20rom&media=https://textcafe.co/books/S0O1Bz/tc-custom/9781504052757.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781504052757&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=Af1UDwAAQBAJ&amp;rdid=book-Af1UDwAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781504052757').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/S0O1Bz/tc-custom/9781504052757.jpg?1726755969783',
        alt: 'Lanny Budd Novels Volume Two, The Lanny Budd Novels'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "bundle_content", "Book1/xhtml/cover", "Book1/xhtml/title", "Book1/xhtml/dedication", "Book1/xhtml/part01", "Book1/xhtml/chapter001", "Book1/xhtml/chapter002", "Book1/xhtml/chapter003", "Book1/xhtml/chapter004", "Book1/xhtml/part02", "Book1/xhtml/chapter005", "Book1/xhtml/chapter006", "Book1/xhtml/chapter007", "Book1/xhtml/chapter008", "Book1/xhtml/chapter009", "Book1/xhtml/part03", "Book1/xhtml/chapter010", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/S0O1Bz/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bundle_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bundle_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_bundle_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ebb__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ebb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ebb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mm__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_mm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_love_1__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_bundle_title__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_bundle_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_bundle_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_bundle_content__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_bundle_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_bundle_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_cover__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_title__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_dedication__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_part01__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_part01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_part01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_chapter001__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_chapter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_chapter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_chapter002__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_chapter002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_chapter002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_chapter003__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_chapter003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_chapter003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_chapter004__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_chapter004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_chapter004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_part02__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_part02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_part02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_chapter005__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_chapter005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_chapter005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_chapter006__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_chapter006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_chapter006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_chapter007__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_chapter007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_chapter007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_chapter008__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_chapter008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_chapter008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_chapter009__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_chapter009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_chapter009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_part03__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_part03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_part03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_chapter010__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_chapter010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_chapter010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Book1_xhtml_chapter011__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Book1_xhtml_chapter011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Book1_xhtml_chapter011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Book1_xhtml_chapter012__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Book1_xhtml_chapter012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Book1_xhtml_chapter012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Book1_xhtml_chapter013__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Book1_xhtml_chapter013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Book1_xhtml_chapter013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Book1_xhtml_part04__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Book1_xhtml_part04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Book1_xhtml_part04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Book1_xhtml_chapter014__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Book1_xhtml_chapter014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Book1_xhtml_chapter014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Book1_xhtml_chapter015__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Book1_xhtml_chapter015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Book1_xhtml_chapter015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Book1_xhtml_chapter016__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Book1_xhtml_chapter016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Book1_xhtml_chapter016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Book1_xhtml_chapter017__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Book1_xhtml_chapter017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Book1_xhtml_chapter017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Book1_xhtml_part05__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Book1_xhtml_part05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_Book1_xhtml_part05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Book1_xhtml_chapter018__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Book1_xhtml_chapter018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_Book1_xhtml_chapter018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Book1_xhtml_chapter019__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Book1_xhtml_chapter019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Book1_xhtml_chapter019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Book1_xhtml_chapter020__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Book1_xhtml_chapter020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_Book1_xhtml_chapter020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Book1_xhtml_chapter021__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Book1_xhtml_chapter021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_Book1_xhtml_chapter021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Book1_xhtml_part06__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Book1_xhtml_part06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_Book1_xhtml_part06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Book1_xhtml_chapter022__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Book1_xhtml_chapter022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_Book1_xhtml_chapter022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Book1_xhtml_chapter023__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Book1_xhtml_chapter023___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_Book1_xhtml_chapter023__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Book1_xhtml_chapter024__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Book1_xhtml_chapter024___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Book1_xhtml_chapter024__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Book1_xhtml_chapter025__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Book1_xhtml_chapter025___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_Book1_xhtml_chapter025__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Book1_xhtml_part07__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Book1_xhtml_part07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_Book1_xhtml_part07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Book1_xhtml_chapter026__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Book1_xhtml_chapter026___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_Book1_xhtml_chapter026__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Book1_xhtml_chapter027__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Book1_xhtml_chapter027___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_Book1_xhtml_chapter027__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Book1_xhtml_chapter028__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Book1_xhtml_chapter028___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_Book1_xhtml_chapter028__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Book1_xhtml_part08__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Book1_xhtml_part08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_Book1_xhtml_part08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Book1_xhtml_chapter029__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Book1_xhtml_chapter029___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_Book1_xhtml_chapter029__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Book1_xhtml_chapter030__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Book1_xhtml_chapter030___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_Book1_xhtml_chapter030__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Book1_xhtml_chapter031__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Book1_xhtml_chapter031___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_Book1_xhtml_chapter031__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Book1_xhtml_chapter032__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Book1_xhtml_chapter032___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_Book1_xhtml_chapter032__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Book2_xhtml_cover__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Book2_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_Book2_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Book2_xhtml_title__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Book2_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_Book2_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Book2_xhtml_dedication__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Book2_xhtml_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_Book2_xhtml_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Book2_xhtml_frantmatter01__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Book2_xhtml_frantmatter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_Book2_xhtml_frantmatter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Book2_xhtml_part01__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Book2_xhtml_part01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_Book2_xhtml_part01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Book2_xhtml_chapter001__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Book2_xhtml_chapter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_Book2_xhtml_chapter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Book2_xhtml_chapter002__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Book2_xhtml_chapter002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_Book2_xhtml_chapter002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Book2_xhtml_chapter003__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Book2_xhtml_chapter003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_Book2_xhtml_chapter003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Book2_xhtml_chapter004__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Book2_xhtml_chapter004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_Book2_xhtml_chapter004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Book2_xhtml_part02__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Book2_xhtml_part02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_Book2_xhtml_part02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Book2_xhtml_chapter005__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Book2_xhtml_chapter005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_Book2_xhtml_chapter005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Book2_xhtml_chapter006__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Book2_xhtml_chapter006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_Book2_xhtml_chapter006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Book2_xhtml_chapter007__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Book2_xhtml_chapter007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_Book2_xhtml_chapter007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_Book2_xhtml_chapter008__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_Book2_xhtml_chapter008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_Book2_xhtml_chapter008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Book2_xhtml_part03__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Book2_xhtml_part03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_Book2_xhtml_part03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Book2_xhtml_chapter009__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Book2_xhtml_chapter009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_Book2_xhtml_chapter009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Book2_xhtml_chapter010__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Book2_xhtml_chapter010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_Book2_xhtml_chapter010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Book2_xhtml_chapter011__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Book2_xhtml_chapter011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_Book2_xhtml_chapter011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Book2_xhtml_chapter012__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Book2_xhtml_chapter012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_Book2_xhtml_chapter012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Book2_xhtml_chapter013__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Book2_xhtml_chapter013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_Book2_xhtml_chapter013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Book2_xhtml_part04__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Book2_xhtml_part04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_Book2_xhtml_part04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Book2_xhtml_chapter014__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Book2_xhtml_chapter014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_Book2_xhtml_chapter014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Book2_xhtml_chapter015__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Book2_xhtml_chapter015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_Book2_xhtml_chapter015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Book2_xhtml_chapter016__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Book2_xhtml_chapter016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_Book2_xhtml_chapter016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_Book2_xhtml_chapter017__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_Book2_xhtml_chapter017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_Book2_xhtml_chapter017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Book2_xhtml_part05__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Book2_xhtml_part05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_Book2_xhtml_part05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Book2_xhtml_chapter018__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Book2_xhtml_chapter018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_Book2_xhtml_chapter018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Book2_xhtml_chapter019__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Book2_xhtml_chapter019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_Book2_xhtml_chapter019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_Book2_xhtml_chapter020__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_Book2_xhtml_chapter020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_Book2_xhtml_chapter020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_Book2_xhtml_chapter021__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_Book2_xhtml_chapter021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_Book2_xhtml_chapter021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_Book2_xhtml_chapter022__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_Book2_xhtml_chapter022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_Book2_xhtml_chapter022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_Book2_xhtml_part06__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_Book2_xhtml_part06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_Book2_xhtml_part06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_Book2_xhtml_chapter023__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_Book2_xhtml_chapter023___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_Book2_xhtml_chapter023__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_Book2_xhtml_chapter024__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_Book2_xhtml_chapter024___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__components_Book2_xhtml_chapter024__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_Book2_xhtml_chapter025__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_Book2_xhtml_chapter025___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__components_Book2_xhtml_chapter025__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_Book2_xhtml_chapter026__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_Book2_xhtml_chapter026___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__components_Book2_xhtml_chapter026__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_Book2_xhtml_part07__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_Book2_xhtml_part07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__components_Book2_xhtml_part07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_Book2_xhtml_chapter027__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_Book2_xhtml_chapter027___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__components_Book2_xhtml_chapter027__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_Book2_xhtml_chapter028__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_Book2_xhtml_chapter028___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__components_Book2_xhtml_chapter028__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_Book2_xhtml_chapter029__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_Book2_xhtml_chapter029___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__components_Book2_xhtml_chapter029__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_Book2_xhtml_chapter030__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_Book2_xhtml_chapter030___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__components_Book2_xhtml_chapter030__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_Book2_xhtml_chapter031__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_Book2_xhtml_chapter031___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__components_Book2_xhtml_chapter031__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_Book3_xhtml_cover__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_Book3_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__components_Book3_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_Book3_xhtml_title__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_Book3_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__components_Book3_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_Book3_xhtml_dedication__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_Book3_xhtml_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__components_Book3_xhtml_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_Book3_xhtml_part01__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_Book3_xhtml_part01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__components_Book3_xhtml_part01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_Book3_xhtml_chapter001__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_Book3_xhtml_chapter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__components_Book3_xhtml_chapter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_Book3_xhtml_chapter002__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_Book3_xhtml_chapter002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__components_Book3_xhtml_chapter002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_Book3_xhtml_chapter003__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_Book3_xhtml_chapter003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__components_Book3_xhtml_chapter003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_Book3_xhtml_chapter004__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_Book3_xhtml_chapter004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__components_Book3_xhtml_chapter004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_Book3_xhtml_part02__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_Book3_xhtml_part02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__components_Book3_xhtml_part02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_Book3_xhtml_chapter005__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_Book3_xhtml_chapter005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__components_Book3_xhtml_chapter005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_Book3_xhtml_chapter006__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_Book3_xhtml_chapter006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__components_Book3_xhtml_chapter006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_Book3_xhtml_chapter007__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_Book3_xhtml_chapter007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__components_Book3_xhtml_chapter007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_Book3_xhtml_chapter008__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_Book3_xhtml_chapter008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__components_Book3_xhtml_chapter008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_Book3_xhtml_chapter009__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_Book3_xhtml_chapter009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__components_Book3_xhtml_chapter009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_Book3_xhtml_part03__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_Book3_xhtml_part03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__components_Book3_xhtml_part03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_Book3_xhtml_chapter010__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_Book3_xhtml_chapter010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__components_Book3_xhtml_chapter010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_Book3_xhtml_chapter011__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_Book3_xhtml_chapter011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__components_Book3_xhtml_chapter011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_Book3_xhtml_chapter012__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_Book3_xhtml_chapter012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__components_Book3_xhtml_chapter012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_Book3_xhtml_chapter013__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_Book3_xhtml_chapter013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__components_Book3_xhtml_chapter013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_Book3_xhtml_part04__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_Book3_xhtml_part04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__components_Book3_xhtml_part04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_Book3_xhtml_chapter014__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_Book3_xhtml_chapter014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__components_Book3_xhtml_chapter014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_Book3_xhtml_chapter015__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_Book3_xhtml_chapter015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__components_Book3_xhtml_chapter015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_Book3_xhtml_chapter016__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_Book3_xhtml_chapter016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__components_Book3_xhtml_chapter016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_Book3_xhtml_part05__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_Book3_xhtml_part05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__components_Book3_xhtml_part05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_Book3_xhtml_chapter017__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_Book3_xhtml_chapter017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__components_Book3_xhtml_chapter017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_Book3_xhtml_chapter018__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_Book3_xhtml_chapter018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__components_Book3_xhtml_chapter018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_Book3_xhtml_chapter019__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_Book3_xhtml_chapter019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__components_Book3_xhtml_chapter019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_Book3_xhtml_chapter020__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_Book3_xhtml_chapter020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__components_Book3_xhtml_chapter020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_Book3_xhtml_chapter021__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_Book3_xhtml_chapter021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__components_Book3_xhtml_chapter021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_Book3_xhtml_part06__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_Book3_xhtml_part06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__components_Book3_xhtml_part06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_Book3_xhtml_chapter022__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_Book3_xhtml_chapter022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__components_Book3_xhtml_chapter022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_Book3_xhtml_chapter023__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_Book3_xhtml_chapter023___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__components_Book3_xhtml_chapter023__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_Book3_xhtml_chapter024__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_Book3_xhtml_chapter024___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__components_Book3_xhtml_chapter024__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_Book3_xhtml_chapter025__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_Book3_xhtml_chapter025___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__components_Book3_xhtml_chapter025__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_Book3_xhtml_part07__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_Book3_xhtml_part07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__components_Book3_xhtml_part07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_Book3_xhtml_chapter026__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_Book3_xhtml_chapter026___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__components_Book3_xhtml_chapter026__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_Book3_xhtml_chapter027__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_Book3_xhtml_chapter027___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__components_Book3_xhtml_chapter027__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_Book3_xhtml_chapter028__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_Book3_xhtml_chapter028___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__components_Book3_xhtml_chapter028__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_Book3_xhtml_part08__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_Book3_xhtml_part08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__components_Book3_xhtml_part08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_Book3_xhtml_chapter029__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_Book3_xhtml_chapter029___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__components_Book3_xhtml_chapter029__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_Book3_xhtml_chapter030__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_Book3_xhtml_chapter030___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__components_Book3_xhtml_chapter030__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_Book3_xhtml_chapter031__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_Book3_xhtml_chapter031___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__components_Book3_xhtml_chapter031__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_Book3_xhtml_chapter032__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_Book3_xhtml_chapter032___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__components_Book3_xhtml_chapter032__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_love_2__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__components_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_Comon_Preview__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_Comon_Preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__components_Comon_Preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_Comon_Preview_cover__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_Comon_Preview_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__components_Comon_Preview_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_Comon_Preview_1__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_Comon_Preview_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__components_Comon_Preview_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_Comon_Preview_2__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_Comon_Preview_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__components_Comon_Preview_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_Comon_Preview_3__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_Comon_Preview_3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__components_Comon_Preview_3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_Comon_author__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_Comon_author___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__components_Comon_author__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_Comon_copyright__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_Comon_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__components_Comon_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_Comon_backad_1__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_Comon_backad_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__components_Comon_backad_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_ORIMad__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_ORIMad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147__components_ORIMad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_last__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148__components_last__);
/*jshint esversion: 6 */























































































































































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/bundle_content",
    "name": "bundle_content",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_bundle_content___default.a
  }, {
    "path": "/Book1/xhtml/cover",
    "name": "Book1/xhtml/cover",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_cover___default.a
  }, {
    "path": "/Book1/xhtml/title",
    "name": "Book1/xhtml/title",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_title___default.a
  }, {
    "path": "/Book1/xhtml/dedication",
    "name": "Book1/xhtml/dedication",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_dedication___default.a
  }, {
    "path": "/Book1/xhtml/part01",
    "name": "Book1/xhtml/part01",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_part01___default.a
  }, {
    "path": "/Book1/xhtml/chapter001",
    "name": "Book1/xhtml/chapter001",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_chapter001___default.a
  }, {
    "path": "/Book1/xhtml/chapter002",
    "name": "Book1/xhtml/chapter002",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_chapter002___default.a
  }, {
    "path": "/Book1/xhtml/chapter003",
    "name": "Book1/xhtml/chapter003",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_chapter003___default.a
  }, {
    "path": "/Book1/xhtml/chapter004",
    "name": "Book1/xhtml/chapter004",
    "component": __WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_chapter004___default.a
  }, {
    "path": "/Book1/xhtml/part02",
    "name": "Book1/xhtml/part02",
    "component": __WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_part02___default.a
  }, {
    "path": "/Book1/xhtml/chapter005",
    "name": "Book1/xhtml/chapter005",
    "component": __WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_chapter005___default.a
  }, {
    "path": "/Book1/xhtml/chapter006",
    "name": "Book1/xhtml/chapter006",
    "component": __WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_chapter006___default.a
  }, {
    "path": "/Book1/xhtml/chapter007",
    "name": "Book1/xhtml/chapter007",
    "component": __WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_chapter007___default.a
  }, {
    "path": "/Book1/xhtml/chapter008",
    "name": "Book1/xhtml/chapter008",
    "component": __WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_chapter008___default.a
  }, {
    "path": "/Book1/xhtml/chapter009",
    "name": "Book1/xhtml/chapter009",
    "component": __WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_chapter009___default.a
  }, {
    "path": "/Book1/xhtml/part03",
    "name": "Book1/xhtml/part03",
    "component": __WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_part03___default.a
  }, {
    "path": "/Book1/xhtml/chapter010",
    "name": "Book1/xhtml/chapter010",
    "component": __WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_chapter010___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_148__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Upton Sinclair\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Upton Sinclair (1878–1968) was a Pulitzer Prize–winning author, activist, and politician whose novel "), _c('I', [_vm._v("The Jungle ")]), _vm._v("(1906) led to the passage of the Federal Meat Inspection Act and the Pure Food and Drug Act. Born into an impoverished family in Baltimore, Maryland, Sinclair entered City College of New York five days before his fourteenth birthday. He wrote dime novels and articles for pulp magazines to pay for his tuition, and continued his writing career as a graduate student at Columbia University. To research "), _c('I', [_vm._v("The Jungle")]), _vm._v(", he spent seven weeks working undercover in Chicago’s meatpacking plants. The book received great critical and commercial success, and Sinclair used the proceeds to start a utopian community in New Jersey. In 1915, he moved to California, where he founded the state’s ACLU chapter and became an influential political figure, running for governor as the Democratic nominee in 1934. Sinclair wrote close to one hundred books during his lifetime, including "), _c('I', [_vm._v("Oil! ")]), _vm._v("(1927), the inspiration for the 2007 movie "), _c('I', [_vm._v("There Will Be Blood")]), _vm._v("; "), _c('I', [_vm._v("Boston ")]), _vm._v("(1928), a documentary novel revolving around the Sacco and Vanzetti case; "), _c('I', [_vm._v("The Brass Check")]), _vm._v(", a muckraking exposé of American journalism, and the eleven novels in Pulitzer Prize–winning Lanny Budd series.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/S0O1Bz/tc-custom/9781504052757.jpg?1726755969783",
      "alt": "This image is the cover for the book Lanny Budd Novels Volume Two, The Lanny Budd Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lanny Budd Novels Volume Two, The Lanny Budd Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Books four through six in the Pulitzer Prize–winning series of historical novels about an international spy in the first half of the twentieth century.  ")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" An ambitious and entertaining mix of history, adventure, and romance, Upton Sinclair’s Pulitzer Prize–winning Lanny Budd novels are a testament to the breathtaking scope of the author’s vision and his singular talents as a storyteller. “Few works of fiction are more fun to read; fewer still make history half as clear, or as human” ("), _c('i', [_vm._v("Time")]), _vm._v("). In these three novels, as the threat of Nazism grows in the 1930s, Lanny progresses from international art dealer to international spy."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Wide Is the Gate")]), _vm._v(": When his arms dealer father strikes a business agreement with Hermann Göring, Lanny uses the opportunity and his art world reputation to move easily among the Nazi high command and gather valuable information he can transmit back to those who are dedicated to the destruction of Nazism and Fascism. He’s playing a dangerous—albeit necessary—game, which will carry him from Germany to Spain on a life-and-death mission on the eve of the Spanish Civil War."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("The Presidential Agent")]), _vm._v(": In 1937, Lanny’s boss from the Paris Peace Conference—now one of Roosevelt’s top advisors—connects him to the president. Appointed Presidential Agent 103, he embarks on a secret assignment that takes him back into the Third Reich as the Allied powers prepare to cede Czechoslovakia to Adolf Hitler in a futile attempt to avoid war. But Lanny’s motivations are not just political: The woman he loves has fallen into the brutal hands of the Gestapo, and Lanny will risk everything to save her."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Dragon Harvest")]), _vm._v(": Lanny has earned the trust of Adolf Hitler and his inner circle, who are convinced the American art dealer is a “true believer” committed to their Fascist cause. But when Roosevelt’s secret agent learns of the Führer’s plans for conquest, his dire warnings to Neville Chamberlain and other reluctant European leaders fall on deaf ears. The bitter seeds sown decades earlier with the Treaty of Versailles are now bearing fruit, and there will be no stopping the Nazi war machine as it rolls relentlessly on toward Paris.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/cover"
    }
  }, [_vm._v("WIDE IS THE GATE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/part01"
    }
  }, [_vm._v("Book One: Into the Lion’s Mouth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001"
    }
  }, [_vm._v("1 Dust to Dust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002"
    }
  }, [_vm._v("2 Indoctus Pauperiem Pati")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003"
    }
  }, [_vm._v("3 A Young Man Married")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004"
    }
  }, [_vm._v("4 When Duty Whispers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/part02"
    }
  }, [_vm._v("Book Two: Some Hidden Thunder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005"
    }
  }, [_vm._v("5 Des Todes Eigen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006"
    }
  }, [_vm._v("6 On Top of the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch13"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch14"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007"
    }
  }, [_vm._v("7 Spirits of Just Men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch13"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008"
    }
  }, [_vm._v("8 The Dusky Clouds Ascending")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009"
    }
  }, [_vm._v("9 Shape of Danger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/part03"
    }
  }, [_vm._v("Book Three: The Worst Is Yet to Come")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010"
    }
  }, [_vm._v("10 The Head That Wears a Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Farewell to Every Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Perilous Edge of Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 A Brand from Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Four: Truth Forever on the Scaffold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 When We Two Parted")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Need a Body Cry?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Survival of the Fittest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 A Fruitless Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Five: A Tide in the Affairs of Men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Fears of the Brave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Where Men Decay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Disastrous Twilight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Hazard of the Die")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Six: Through Slaughter to a Throne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Put Money in Thy Purse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Sic Transit Gloria")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 True Faith of an Armorer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 O Freude, Habe Acht!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Seven: A Hangman’s Whip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Perils Did Abound")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 The Way to Dusty Death")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 So Money Comes Withal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Eight: The World Turned Pale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 Ignorant Armies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 My Life Upon a Cast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Put It to the Touch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32 And Win or Lose it All")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRESIDENTIAL AGENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book One: Seats of the Mighty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Sweet Aspect of Princes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Wise as Serpents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Trust in Princes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Plus Triste Que Les Nuits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Two: Wrong Forever on the Throne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Forward Into Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Blondel Song")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Spain’s Chivalry Away")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 This Yellow Slave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Three: Most Disastrous Chances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 His Honor Rooted in Dishonor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Falsely True")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Time by the Forelock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Observe the Opportunity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 My Life on Any Chance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Four: In the Midst of Wolves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 The Jingling of the Guinea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 To Have a Giant’s Strength")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Fuming Vanities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Dangerous Majesty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Five: Extravagant and Erring Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Après Nous Le Déluge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Vaulting Ambition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Mohammed’s Mountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Der Führer Hat Immer Recht")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Foul Deeds Will Rise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Six: A Full Hot Horse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Les Beaux Yeux De Ma Casette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 God’s Footstool")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 Slings and Arrows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Pleasure Never Is at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Seven: The Things That Are Caesar’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 Fever of the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 The Stars in their Courses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 The Hurt That Honor Feels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 Hell’s Foundations Tremble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Courage Mounteth with Occasion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DRAGON HARVEST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book One: Regardless of their Doom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 The Little Victims Play")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Cherry Ripe, Ripe, Ripe!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Gold Will Be Master")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Portents of Impending Doom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Two: Who Sups with the Devil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The Pitcher to the Well")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Fighting the Devil with Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Heute Gehört Uns Deutschland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Face of Danger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Time Gallops Withal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Three: Let Joy Be Unconfined")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 When Fortune Favors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Trail of the Serpent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 T’Other Dear Charmer Away")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Where Duty Calls Me")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Four: The Brazen Throat of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 The Best-Laid Schemes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Fools Rush In")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Where Angels Fear to Tread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Five: Ancestral Voices Prophesying War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Oh, What a Tangled Web!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Grasp the Nettle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Double-Dyed Deceiver")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 They That Take the Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Auf den Bergen 1st Freiheit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Six: Let Slip the Dogs of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Mournful Midnight Hours")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Two’s Company, Three’s a Crowd")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 A House Divided")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 On with the Dance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Seven: The Winds Blew and Beat upon That House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Time Ambles Withal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 With Hell at Agreement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 The Sparks Fly Upward")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Eight: The Flinty and Steel Couch of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 Secret Dread and Inward Horror")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 Those in Peril on the Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Even in the Cannon’s Mouth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32 They That Worship the Beast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/Preview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("A World to Win")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "my-cover-image"
    }
  }), _c('img', {
    staticStyle: {
      "height": "100%",
      "text-align": "center"
    },
    attrs: {
      "alt": "image",
      "src": "Book1/images/MyCoverImage.jpg"
    }
  })])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "bk-title"
  }, [_c('span', [_vm._v("Wide Is the Gate")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', [_vm._v("TO")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("MY MILLIONS OF FRIENDS")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("IN THE SOVIET UNION, WHO,")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("WHILE THIS BOOK WAS BEING WRITTEN,")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("HAVE BEEN DEFENDING")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("OUR COMMON CAUSE.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1-1"
  }, [_c('span', [_vm._v("“Wide is the gate, and broad is the way, that leadeth to destruction.”")])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h"
  }, [_c('span', [_vm._v("BOOK ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "part-center"
  }, [_c('span', [_vm._v("Into the Lion’s Mouth")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("DUST TO DUST")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Freddi himself wouldn’t have wanted an elaborate funeral or any fuss made over his broken body; but funerals are not for the dead, only for the living. Here was his devoted Jewish mother, aged not so much in years as in feelings, and a prey to terror as well as grief. The calamities which had fallen upon her family and her race could not be blind accidents, they must have a cause; somebody must have done something, and what could it be save that her people had again departed from the ways of their faith and incurred the wrath of that most jealous of Gods, who visits the iniquity of the fathers upon the children unto the third and fourth generations of them that hate Him? It was Jahweh, Lord God of Sabaoth, it was El Shaddai, the Terrible One, thundering as He had done all down the centuries. Know therefore and see that it is an evil thing and bitter, that thou hast forsaken the Lord thy God, and that My fear is not in thee, saith the Lord of Hosts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Lord God of Hosts had given to Leah Robin, formerly Rabinowich, a husband and two tall sons, and to them two lovely wives, and to one of these a son; all blessings beyond price. But husband and sons and daughters-in-law all five had dared to treat with contumely the Law and the Prophets, to call themselves “modern” and to prate about “Reform,” presuming to decide for themselves what was good and proper, regardless of all those commands which the Lord God of Israel had laid down in His holy books. The mother, though anxious in soul, had permitted herself to be dragged along; trying to keep her family about her and to avoid dissension, she had seen one ancient custom after another dropped and forgotten in her home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("El Shaddai the Implacable had waited, for such is His way. The Lord is slow to anger, and great in power, and will not at all acquit the wicked: the Lord hath His way in the whirlwind and in the storm, and the clouds are the dust of His feet. He rebuketh the sea, and maketh it dry, and drieth up all the rivers.… The mountains quake at Him, and the hills melt, and the earth is burned at His presence, yea, the world, and all that dwell therein. Who can stand before His indignation? And who can abide in the fierceness of His anger? His fury is poured out like fire, and the rocks are thrown down by Him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beyond anything which had confounded Job were the calamities which had fallen upon this happiest of Jewish families. The dreadful Nazis seizing first the father and then the younger son and throwing them into prison; robbing the family of everything in the world, torturing the son in unspeakable ways and finally throwing him out of their land a piteous wreck. A mother who had been taught from earliest childhood that the fear of the Lord is the beginning of wisdom could draw only one conclusion from such a chain of events; Jahweh was behaving according to His nature: the Lord God Omnipotent, who had cast out Adam and Eve and pronounced His terrible dooms, that in sorrow shalt thou bring forth children, and cursed is the ground for thy sake!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The inheritor of these dooms was now fleeing back to the ark of her covenant. Her son had been a poor strayed sheep, a “pink” sheep, tinged with Marxist hues, and it was too late to help him in this life, but at least she could prepare him for that resurrection to which the Orthodox look forward. He must be buried according to sacred tradition, with no concession to those fatal delusions known as “Reform.” The stricken household was in a panic; and the estate upon which they lived was thrown into turmoil; for the mother believed that a Jewish corpse was dishonored if it was left above ground more than twenty-four hours, and it might not be buried after dark.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Rahel Robin, the young widow, had tended and watched over her husband for a couple of months; she had heard him pleading for death and had made up her mind that that was the way of mercy for him. She had no idea whatever that this so cruelly tortured body would ever rise from the grave, whether in its present distorted shape or restored to its original perfection. But there was no restraining the hysteria of the older woman. Mama wept and wrung her hands and tore her garments; at the same time she rushed hither and thither, trying to perform those offices which decency requires for Jewish dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were many of her race on the French Riviera, but they were for the most part rootless persons, parasites and pleasure-seekers, as much tainted with skepticism and exposed to the wrath of Jahweh as the Robin family. Who among the devotees of fashion would understand how the fingernails of a dead person have to be trimmed? Who among bridge-playing ladies would know how to prepare a “meal of condolence”? Who among tennis-playing gentlemen would see to it that the mourners returning to the home washed their hands and forearms in accordance with the Talmudic formula?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a synagogue in Cannes, but Mama would have none of it; it was “Reformed,” and the rabbi was so fashionable that he might as well have been an Episcopalian. But in the Old Town of the city there lived in direst poverty a few families from Russia and Poland, earning their bread by such labor as peddling, collecting rags, patching old clothes. They were real Jews, as Leah had once been; they had a sort of hole in the wall where they worshiped, and Leah had gone among them doing charity and had met the head of their synagogue. His name was Shlomo Kolodny, and he was no French rabbi of the Coast of Pleasure, wearing a big black armband at funerals, but a real scholar, a melamed, or teacher of the young; also he was the cantor, and the shammas, or sexton, and the shohet, or ritual butcher; in case of need he would be the undertaker according to the ancient code. After laborious days he spent his nights poring over sacred Hebrew texts and disputing in his imagination with learned ones whom he had known in Poland, concerning thousands of minute points of doctrine and practice which had been raised during twenty-five centuries of dealings between Jahweh and His Chosen People.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So now the chauffeur of Bienvenu drove in haste to the city and came back with this Shlomo of all trades, wearing a long black beard and a badly stained Prince Albert which he probably thought looked like an old-style caftan. In a Yiddish slightly mixed with French he assured the bereaved mother that he knew everything and would do it in style, and no “Reform” tricks whatever—“"), _c('i', [_vm._v("Pas de tout")]), _vm._v(", Frau Robin, "), _c('i', [_vm._v("niemals, niemals")]), _vm._v(" will I drain the blood from a good Jew or put any poisons into him.” He rubbed his hands together and purred, for he knew all about this lady whose husband had been one of the richest men in Germany and who was still important enough to be a guest on one of the finest estates of the Cap d’Antibes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A great consolation he was to Mama. He hastened to assure her that she need not worry because her dear one was buried so far from home; if she so desired, a little forked stick could be put in the grave, wherewith he could dig his way to Palestine when the last trumpet blew; and of course the screws in the coffin lid would be left loose for him. As for the mutilations which evil men had done upon his body, they would all be repaired, and a noble young Jew would arise, transformed into an angel shining like a star. His broken fingers would be mended and he could play his clarinet for the greater glory of the Most High. Meanwhile his soul was comfortable in a sort of dove-cot in Hades, with an immense number of tiny compartments for the containing of righteous souls. This wasn’t exactly accepted doctrine, but Shlomo had read it in some ancient text and Mama found it most comforting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are some of the old ways which are utterly impossible in modern days. The cemetery was up in the hills, and while city people have not forgotten how to walk, they have forgotten that it is possible to do so. The coffin and the mourners would have to be transported in automobiles, but the men would ride in separate cars, followed by the women, and when they came to the gates of the cemetery everybody would enter on foot. Tactfully the melamed mentioned that in his flock were a number of poor women who would make excellent mourners; they would expect to be paid only a few francs each, plus a meal, and they would weep copiously and make a truly impressive funeral. It was too much to expect that all the Jews of Cannes or even of the village of Juan-les-Pins would stop work and follow the cortege; alas, they wouldn’t even know that if they met it on the street they were in duty bound to turn and accompany it a distance of at least four cubits. Who could even tell them how much a cubit was?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was the question of the "), _c('i', [_vm._v("hesped")]), _vm._v(", the funeral eulogy. Shlomo was competent to pronounce it, but he had never met the deceased, and somebody would have to tell him what to say. At this point the young widow dried her tears and broke into the discussion. The person who should deliver the oration was the dead man’s dearest friend, the one who knew him best and had risked his life to get him out of Naziland. This friend was in Paris, and Rahel had telephoned to him; he had promised to hire a plane and arrive in Cannes before the day was over. Surely Mama must know that it would be Freddi’s wish to have the wonderful Lanny Budd speak the last words over his grave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was embarrassing to the master of ceremonies. To be sure, there was nothing in the Torah to forbid a "), _c('i', [_vm._v("goy")]), _vm._v(" to speak at a funeral; but it would seem very “modern,” and would trouble the Orthodox, into whose hands the mother wished to entrust her son’s fate. Nevertheless, Rahel insisted: not merely would it be Freddi’s wish, but also that of his father and his elder brother. They, alas, were in South America, and there was no way to consult them; but Rahel knew their minds, and Mama knew that they looked with disfavor upon her most cherished ideas. So there would have to be two orations; Shlomo would speak the proper conventional words and then dear kind Lanny Budd would say whatever came from his heart. Everyone who attended the funeral, Jew or Gentile, would know how much the two young men had meant to each other, how many clarinet and piano duets they had played, and for how many months Lanny had labored to get his friend out of the clutches of Adolf Hitler and Hermann Wilhelm Goring.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("It was a mild day in early October, and Lanny’s plane should arrive in time. The hour for the ceremonies was set as late as possible, and the bereaved women summoned friends by telephone. By various means word was spread among all Jews, rich and poor, who might be willing to attend; for it is necessary to the honor of the deceased that there shall be a procession, accompanied by convincing demonstrations of grief.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rahel took a step which came near to spoiling the occasion for her mother-in-law; she sent a message to a Spanish Socialist who was employed in Cannes and who ran the workers’ school which Freddi and Lanny had helped to finance. Yes, indeed, Raoul Palma would attend the funeral, and many of the comrades would find ways to leave their work and pay the last tribute to a brave and loyal soul. The funeral ought to have been delayed for several days so as to give the anti-Fascists of the Midi an opportunity to make a demonstration of it. But since Moses hadn’t known about refrigerants and formaldehyde, the comrades would do their best at short notice and later would hold a memorial meeting with music and Red speeches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Toward the middle of the afternoon the motor-cars began to assemble in the driveway which circled the pink stucco villa of Bienvenu. Some parked their cars and waited decorously outside the gates, ready to take their places in the procession, and not realizing how this would mix things up. It was hard for modern people to understand that the men must precede the hearse and women follow it. Such has been the fate of the most holy customs in these evil days—people don’t even know that they exist!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Six pallbearers carried the plain wooden coffin to the hearse and then took their places in a car preceding it. In front went the car with the melamed and the little five-year-old son of the deceased. His mother would have preferred to spare him this ordeal, but the grandmother insisted that duty required him to become familiar with grief, and on the way the melamed would teach him the words of a Hebrew prayer which would be helpful to his father’s soul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next rode the men friends, taking with them various Jewish males who were too poor to have cars of their own. Behind the hearse rode the mother and the widow, heavily veiled; no one would see their faces or that of Freddi, which had been distorted by pain beyond power of an undertaker’s art. Next rode the women friends of the family, these also taking a few poor women, to symbolize the fact that in the eyes of Jahweh all are the same; all are commanded to appear before Him in white grave-clothes of the same humble and unpretentious cut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slowly the cortege proceeded into the city of Cannes, and everywhere, according to the French custom, passers-by stopped and the men bared their heads respectfully. But apparently not one of them knew that he should walk four cubits, a distance of six feet, with the procession. It went by appointment to the school, where quite a company had assembled; at least fifty men and women, but they had no idea that the sexes should be separated. They were working people, with a few intellectuals; some were black-clad and others had armbands of crape; several carried wreaths, again being ignorant of ancient Jewish prejudices. They stood respectfully until the last car had passed, and then they fell in behind, carrying a red banner having two clasped hands and the initials E.T.M., Ecole des Travailleurs du Midi.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("So into the beautiful hills which line the Cote d’Azur. When they came to the gates of the cemetery the cortege stopped, and the pallbearers bore the coffin to the grave. Three wealthy and fashionable friends of the family did not enter the cemetery grounds, but watched the procedure from outside, reading the prayers which they could not hear. The reason was that they belonged to the tribe of the priests, the Cohanim, who are not permitted to enter a burial ground, a place contaminated and perhaps a haunt of evil spirits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frequently the pallbearers stopped and set down their burden; this was not because they were weary, but because it was a part of the ritual. As they walked, the melamed recited the Ninety-First Psalm, full of assurances to those who put their trust in the Most High. Surely He shall deliver thee from the snare of the fowler, and from the noisome pestilence. He shall cover thee with His feathers and under His wings shalt thou trust: His truth shall be thy shield and buckler. Thou shalt not be afraid for the terror by night; nor for the arrow that flieth by day; nor for the pestilence that walketh in darkness; nor for the destruction that wasteth at noonday. A thousand shall fall at thy side, and ten thousand at thy right hand; but it shall not come nigh thee. So spoke the psalmist; he mentioned plagues and stones and lions and adders and dragons—but nothing about Nazis!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several times male friends came forward at the pauses and replaced the pallbearers, for this is a way to do honor to the deceased. Lanny Budd had arrived at the cemetery in a taxicab and waited at the gates; when a friend of the family explained the custom in a whisper, Lanny stepped up and did his share. He had known the Robin family for twenty years, and had heard poor Mama wailing over her darling’s dreadful fate. He would have done whatever she wished, even if it had included the most ancient custom of having the pallbearers walk barefoot, lest they should stumble over the latchets of their sandals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bier arrived at the grave, and the rabbi recited the "), _c('i', [_vm._v("Zidduk ha-Din")]), _vm._v(", a Hebrew prayer; very few knew what it meant, but it had fine rolling sounds. When the coffin had been lowered to its appointed place the Orthodox ones came forward, plucking bits of grass-roots and earth from the ground and throwing them upon the coffin as a symbol of the resurrection. They said a Hebrew formula which means: “And they of the city shall flourish like the grass of the earth.” Some of the Gentiles threw flowers, and had to be excused because they didn’t understand the proprieties. The Jewish people wept loudly, because it was good form and also because they felt themselves at one with the bereaved women, exiles in a strange land and heirs of the man of Uz. When the dark-eyed, pale little son of the dead man stepped forward and with tears on his cheeks recited the "), _c('i', [_vm._v("Kaddish")]), _vm._v(", part Hebrew and part Aramaic, there were few dry eyes in the assembly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shlomo Kolodny delivered his "), _c('i', [_vm._v("hesped")]), _vm._v(". He said about the son of Johannes Robin the same things he had said about a thousand other Jewish men in the course of his long service. He laid stress upon the young man’s piety, a virtue in which Freddi had been lacking—unless you chose to give a modernized meaning to the word. He laid stress upon Freddi’s dutifulness to his parents and to his wife and child—virtues especially commanded by Jewish law. The melamed said another rolling Hebrew prayer, and then it was the turn of a young Gentile to speak for the Socialist portion of this oddly assorted procession.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny Budd at this time was thirty-four but looked much younger. He had pleasant and frank American features and well-tanned and well-nourished skin; he wore a neatly trimmed little brown mustache, and a brown tropical worsted suit of a fashionable cut. He had no claim to being an orator, but had talked to the workers at the school and to other groups and didn’t mind doing it when he had something to say. He understood clearly that funerals are for the living, and now his words were for Mama and Rahel and a few others who had really known the deceased; also for those workers for whom Freddi had often played music at the school.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The victim of the Nazis had been twenty-seven, and Lanny had corresponded with him since he was a little boy and had known him since he was a youth. In all those years Lanny had never known him to speak an unkind word or perform a dishonorable action. “He was as near to being perfectly good as one could ask of a human being; and I do not say that just because he is dead—I said it many times and to many people while he was living. He was an artist and a scholar. He knew the best literature of the land which he had made his own. He earned a doctoral degree at the University of Berlin, and he did this not for the honor nor yet for a livelihood, but because he wanted to know what the wisest men had learned about the causes and the cure of poverty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Freddi Robin had called himself a Socialist. This was not the place for a political speech, Lanny said, but those who had known and loved him owed it to his memory to study his ideas and understand them, not letting themselves be confused by calumny. Freddi had been done to death by cruel forces which he himself had understood and had refused to bow to. Others also would have to learn about them, and find out how to save the world from hatreds and delusions which are the root of wars. If we would do this, we would be serving this dead man’s memory and be worthy to meet him in whatever future abode the Creator of us all may have prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was all, and it wasn’t much of a speech. The Socialists had come expecting more, and some would have been glad to supply it if invited. But this was a Jewish funeral, centered upon two sobbing women. Those who knew the proper way to behave at funerals formed two parallel lines leading back to the cemetery gates, and as the chief mourners walked between these lines everyone recited a formula beginning “"), _c('i', [_vm._v("Hamokom yehanem")]), _vm._v(",” meaning: “May God comfort you in the midst of all those who mourn for Zion and Jerusalem.” Just inside the gates of the cemetery stood the melamed with a collection-plate, and no one failed to drop in a coin. This was for charity, of great importance to every Jew. “"), _c('i', [_vm._v("Tzedaka tatzil mimavet")]), _vm._v(",” recited Shlomo, meaning: “Charity delivereth from death.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny stepped into the waiting taxicab, and when he reached Bienvenu he found servants at the porte-cochere of the house with several basins of clean water and towels. It was necessary for every person who attended the funeral to cleanse the hands before entering. This was supposed to be done in a special ritual way, by letting the water run three times from fingertips to elbows, but only the melamed knew this, and the reason—that evil spirits cannot pass running water and so can be kept from entering the house of mourning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After that the family and their friends sat down with the melamed and recited seven times certain passages from the Book of Lamentations. Then they ate the “meal of condolence,” which consisted of any non-alcoholic beverage, with bread and hard-boiled eggs, the last being symbols of life. Leah and Rahel Robin would eat these meals and none others over a period of seven days; wearing slippers, and with their dresses cut in such a way as to indicate that they had torn them in grief, they would sit on the floor or a low stool and read from the Book of Job. This is known as the "), _c('i', [_vm._v("shiv’ah")]), _vm._v(", and during it they would receive consolatory visits and they and their friends would discuss only the virtues of the dear departed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For eleven months they would not dance or take part in any form of recreation. There was a Talmudic reason for this precise period—if you mourned a full year, it would imply that you thought the deceased had been a bad man and was in Gehenna, that is, hell; you didn’t quite wish to admit that, but you thought it wiser to take no chances, so you came as near to a year as propriety allowed. During this period the "), _c('i', [_vm._v("Kaddish")]), _vm._v(" must be recited every day for the benefit of the man’s soul, and there was only one member of this household who was expected to say it—the five-year-old son. The prayers of women do not count, so little Johannes must say this long prayer, of which he wouldn’t understand a single word.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny strolled about the grounds of Bienvenu, his home since he could remember. Always it seemed smaller after he had been visiting in chateaux and "), _c('i', [_vm._v("hotels particuliers")]), _vm._v(", but he loved it and brought his smartest friends to it with pride. Now it was his duty to look things over and see what repairs might be needed to any of the three villas on the estate. He must consult with Leese, the Provencal woman who had risen from the post of cook to an informal sort of steward. It would be his duty to report matters to his mother, who was visiting in England, but would be coming back after Christmas to take her part in the gaieties of a new Riviera season. He played with the dogs, of which there were always too many, because nobody could bear to dispose of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny had a visit from Raoul Palma, a handsome young Spaniard—at least Lanny thought of him as young, just as he thought of himself. Hard to realize that Lanny was going to be thirty-five next month and that Raoul was past thirty! He wanted to get up a meeting in memory of Freddi Robin and wanted Lanny to come and make a good Socialist speech about him. But Lanny explained that his father was in Paris on one of his brief flying trips; also, Lanny had a wife and child in England whom he had been neglecting for the greater part of a year while getting his Jewish friends out of the clutches of Hitler and Goering. Lanny wrote a check to pay the cost of a hall, and told the grateful and attentive schoolmaster some of the things to say about Freddi.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They talked about the progress of the school and about the political situation in France and other countries. That was the way a “parlor Pink” got his education and kept his contacts with the workers. Lanny apologized for his own way of life: as an art expert, advising the rich about the buying of paintings, he had a reason for traveling to all the cities and towns of this old and fear-tormented continent; as an American he was assumed to be a neutral in Europe’s quarrels, and it was the part of wisdom for him to keep that position. Thus he could meet the great ones, enjoy their confidence, and gain information which he could pass on quietly to working-class persons who could make use of it. The Spaniard was one of these; he had been born in a peasant hut and had been a humble clerk in a shoestore; but with a small subsidy from Lanny he had become a leader, attending conferences, making speeches, and furnishing news to the Socialist and labor press of the Midi.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Raoul talked for a while about events in his native land, from which he had fled, driven by a cruel despotism which lined working-class rebels against the wall and shot them without ceremony. But three years ago the wretched King Alfonso had been dethroned; Spain had become a republic and its government had received an overwhelming vote of support from the people. Raoul Palma had been so excited he had wanted to go back, but Lanny had persuaded him that his duty lay with the school he had helped to build.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now it was just as well, for the teacher was deeply discouraged about his own country. It was the old tragic story of party splits and doctrinal disputes; the factions couldn’t agree on what to do, and the amiable elderly college professors and lawyers who composed the new government found it fatally easier to do nothing. The Spanish people continued to starve; and for how long would they rest content with the most well-meaning “Liberalism” which gave them neither bread nor the means of producing it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny didn’t know Spain very well—only from stops on a yachting-cruise and a plane trip. But he knew the Spaniards here on the Riviera; they came to play golf and polo, to dance and gamble and flirt in the casinos, or to shoot pigeons, their idea of manly sport. They read no books, they knew nothing, but considered themselves far above the rest of mankind. Alfonso of the jimber-jaw and the unpleasant diseases liked to be amused, and when on holiday he had unbent with the rich Americans of this Coast of Pleasure. Lanny had played tennis with him, and wasn’t supposed to beat him, but had disregarded this convention. Now the ex-monarch was in Rome, intriguing with Mussolini to be restored to his throne.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You ought to go to Spain!” insisted Raoul. “You ought to know the Spanish workers—they haven’t all been killed. They have seen the light of modern ideas, and nothing will be able to blind them again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny replied that he had often thought of such a trip. “There are pictures there I want to see and study. But it might be better to wait till you have got through expropriating the landlords, and then I can pick up a lot of bargains.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He said this with a smile, knowing that his friend would understand. Whenever the young organizer came to him for funds, Lanny would say: “I’ve just sold a picture, so I can afford it.” Or he’d say: “Wait till next week; I’ve got an oil princess in tow and expect to sell her a Detaze.” Raoul knew that in a storeroom on this estate were a hundred or more of the paintings of Lanny’s former stepfather, and whenever a purchaser came along, the Ecole des Travailleurs du Midi could have a mass meeting or a picnic with refreshments and speeches. But don’t say anything about Lanny’s part in it!")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("This was in October of 1934, and Adolf Hitler had held power in Germany for not quite two years. He was the man who dominated Lanny Budd’s thoughts; he was the new center of reaction in Europe, dangerous not merely because of his fanaticism, but also because he had in his hands the industrial power of Germany and was proceeding to turn it into military power. “It isn’t only what he has done to the Jews,” said the art expert. “He has done things much worse to the Socialists and to the whole labor movement in the Fatherland; but you don’t hear so much about it in the capitalist press of France.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They talked about this on their way into Cannes, where Lanny was taking the evening train for Paris. He drove his friend in the family car, with the chauffeur in the back seat to bring the car back. Lanny, who had met Hitler and heard him talk, warned Raoul that he was only half a madman and no fool whatever, but on the contrary a trickster of infinite cunning, who had managed to get the German people behind him by a program of radical social changes which he had no slightest intention of carrying out. “We can’t ignore him and his purposes,” the American insisted. “We can’t shut our eyes to him and go ahead with our plans just as if he didn’t exist. He is a reactionary and a slave-driver, and he has said in his book that his program requires the annihilation of France.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was hard doctrine for Raoul Palma, an internationalist preaching disarmament and brotherhood. Here was his friend and patron insisting that the time for such ideas was past; nobody could trust Adolf Hitler in any agreement, and only prompt and united action could keep him from rearming Germany. Frenchmen of all parties had to get together on this program before it was too late. “But, Lanny,” objected the school director, “the French capitalists would rather have Hitler than have us!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s because they don’t know Hitler,” was the reply.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("They talked about the disquieting state of the country in which they lived. The head of the French government was a round elderly gentleman wearing an old-fashioned white imperial; a former President of the Republic who had become Premier during a crisis in which nobody would trust anybody else. The mainspring of his being was a childish vanity, and he took delight in addressing the people of France over the radio as if they were his own progeny. But they were a stubborn brood, and by loud clamor had managed to keep Premier Doumergue from interpreting the constitution of the nation so that he could act independently of the Cabinet. What he wanted to do with his power was suspected by Raoul and confirmed by Lanny, who knew that the Premier of France held secret conferences with Colonel de la Roque, head of the Croix de Feu, the leading organization of the French Fascists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The American felt less anxiety about the situation because of the Foreign Minister, Louis Barthou, a Frenchman of the old school who had learned to distrust any and every sort of German and therefore was not to be fooled by Adolf Hitler’s wiles. This was a new point of view to Raoul, who looked upon Barthou as just one more politician and pointed to his reactionary utterances on domestic affairs; but Lanny felt sure he knew what was in the little round head with the high dome and the gray mustache and beard beneath. “He has some fine pictures and showed them to me, and a shelf of the books he has written—including lives of Danton and Mirabeau. You see he really knows the old revolutionary traditions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They all learn about them,” replied the skeptical schoolman; “the better to fool the workers and sell them out—exactly as Mirabeau did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Barthou will never sell out France to Germany. When I met him was before Hitler took power, but the little Gascon realized exactly what the Fuhrer meant. He said: ‘Hitler is the man who is going to dominate our political life for as long as he lives.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny reminded his friend of the “grand tour” which Barthou had recently made in the Balkans, to rally Yugoslavia and other states to an alliance against the new German counter-revolution. His success had been made plain by the effort the Nazis had made to bomb his train in Austria. “That’s the way you tell your friends nowadays,” added the American, and went on to point out that the determined little lawyer had been willing to drop his antagonism to the Soviet Union in the face of a greater peril; he had helped to bring Russia into the League of Nations last month and was working hard to prepare public opinion for a military alliance between that country and France.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The American was in a somber mood, the funeral having brought back to his mind all the horrors he had witnessed since the Nazi Fuhrer had seized the mastery of Germany. Lanny told of his meeting with Freddi Robin in Berlin, a fugitive from the Nazis, sleeping in the Tiergarten in a shelter for the unemployed; then the broken and shuddering figure he had helped to carry across the boundary line between Germany and France, when at last it had pleased the fat General Goring to release his prey. Dreadful, unspeakably wicked men the Nazi chieftains were, and Lanny was haunted by the idea that it was his duty to give up all pleasures and all other duties and try to awaken the people of Western Europe to a realization of the peril in which they stood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So he spoke with repressed feeling; and then, when they reached the station, he bought an evening paper to read on the train. Glancing at its banner headlines he gave a cry. “LE ROI ALEXANDRE ET BARTHOU ASSASSINES!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quickly Lanny’s eyes ran over the story, and he read the salient details to his friend. The King of Yugoslavia had come for a visit of state to France, to celebrate the signing of their treaty of alliance; he had landed at Marseille, and the Foreign Minister had met him at the dock. They had been driven in an open car into the city, through cheering throngs. In front of the stock exchange a man had run out from the crowd, shouting a greeting to the king, and before the police could stop him he had leaped upon the running-board and opened fire with an automatic gun, killing the king and fatally wounding Barthou, who tried to shield his guest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The crowd had beaten the assassin to death, in spite of the efforts of the police to save him. He had been identified as one of a Croatian terrorist organization; but Lanny said: “You’ll find the Nazis were behind him!” So it proved, in due course. The reactionary conspirators had been publishing a paper in Berlin, with funds obtained from the head of the foreign policy department of the Hitler party. The assassin had been traveling on a forged passport, obtained in Munich, and the weapon he had used bore the trademark of Mauser, the German munitions firm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such was the new technique for the conquest of power. Fool those who were foolable, buy those who were buyable, and kill the rest. It was the third Nazi murder of foreign statesmen within a year. First, Premier Duca of Rumania had been shot to death. Then a band of gangsters had broken into the office of Chancellor Dollfuss of Austria, the Catholic statesman who had been responsible for the slaughter of the Socialist workers in Vienna and the bombardment of those blocks of model apartments which Lanny had so greatly admired. And now both signers of the Yugoslav-French agreement had been wiped out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good God!” exclaimed Raoul. “How much more will the people need to wake them up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A lot more, I’m afraid,” was Lanny’s heartsick reply. “You and I, Raoul, chose a bad time to be born!”")])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("INDOCTUS PAUPERIEM PATI")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In his youth Lanny had attended St. Thomas’s Academy in Connecticut, and one of the subjects forced upon him was Latin. He had got so far as to translate several of the odes of Horace, and in his mind there remained a simile about a merchant whose vessels were wrecked, and he, “untaught to bear poverty,” refitted them and sent them forth again. Lanny thought of that when he sat at luncheon in the Hotel Crillon with another merchant, a Roman though he did not know it, and heard him planning with eagerness a new expedition of his ships. In nineteen hundred years the world had changed and now they were ships of the air, but that made little difference in the psychology of the merchant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie Budd was entering his sixties, but was still driven by pride and ambition, still determined to prove that nothing could lick him. Five years ago the Wall Street crash had knocked him clean over the ropes, but he had picked himself up and wiped the blood out of his eyes and come in for round after round. The fact that his father had not named him as successor to the presidency of Budd Gunmakers Corporation, the fact that the great concern was no longer a Budd family affair, these blows might have finished a less sturdy fighter; but here was Lanny’s father ready to start all over again and show them the stuff he was made of. By “them” he meant his family, his friends, his business associates and rivals; more especially his older brother, who had fought him all his life for control of Budd’s, and the Wall Street banking crowd who had taken over the family name and the institution which for close to a century had been the family pride.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie’s contract as European representative of Budd Gunmakers still had more than a year to run, but Robbie was on the point of dropping it. He had been willing to work for his stern old Puritan father, but he couldn’t be happy serving a bunch of interlopers, no matter how greatly they valued his services and how careful they were of his feelings. Robbie was reviving the dream of his early years, of a magnificent new fabricating plant to be built on the Newcastle River above the Budd plant. The land was still there, and could be bought more cheaply than ever—for, whatever the New Deal had accomplished by the end of 1934, it hadn’t brought back land values and wasn’t likely to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sentimentalists and cranks had had their way, and America lay disarmed in the face of a world of enemies—so Robbie declared. Budd Gunmakers was producing mostly hardware and what Robbie called “notions,” meaning everything from hairpins to freight elevators. What the salesman now had in mind was the weapon of the future, and the means of transport of the future, the plane. All the world was taking to the air; the nations which wished to survive would be driven to it; and behind the sheltered and well-protected waters of Long Island Sound Robbie would erect an airplane factory. Before long he would make it into the greatest in the world, and give the name of Budd’s a new and better meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An expert in aerodynamics had showed up, and in an abandoned warehouse near the Newcastle docks had done a lot of experimenting; Robbie had helped him with a few thousand dollars, and they had got an important new design for an internally braced flying wing. Also Robbie had discovered a fellow with patents for an air-cooled radial engine that was going to add another hundred miles to the speed of planes, and if they could do that they would own the world. Robbie was on fire with enthusiasm about it; he had organized a company and gone the rounds among his friends, those who had put their money into New England-Arabian Oil with him and done very well. Business was picking up and people had money, but good investments were scarce, because the government was putting out most of the bonds. So Robbie had had no trouble in selling stock in Newcastle, and had taken an option on the land. Now he was in Paris to talk with Zaharoff and with Denis de Bruyne and some of Denis’s associates; later he was going to London to see investors there; he was doing it all privately—the Wall Street crowd wasn’t going to get a look-in. “Believe me, son, I’m not going to stay a poor man.” "), _c('i', [_vm._v("Indoctus pauperiem pati!")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Robbie sat at the well-appointed "), _c('i', [_vm._v("table a deux")]), _vm._v(", enjoying his "), _c('i', [_vm._v("sole meuniere")]), _vm._v(" and his Chablis, dry and well chilled. Business didn’t interfere with his appetite, quite the contrary; he had always taken the good things of life as they came along, and in spite of his graying hair and hard work he was robust and rosy. He enjoyed telling about his affairs; not exactly boasting, but speaking with quiet assurance, pointing out how he had been right and forgetting when he had been wrong. He had studied the field thoroughly and convinced himself that aviation was the industry of the future, the only one that wasn’t overbuilt. It held the advantage that it was both a peace and a war industry; you could turn out “flivver planes,” and then with only a few changes in design you could be turning out training planes and perhaps fighters. “Our country is asleep,” declared the ever-vigilant patriot; “but the day is coming when everybody will be grateful to a few men who have-learned to design high-speed planes and to make them in a hurry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The promoter had an appointment with the one-time munitions king of Europe for the following morning and he wanted to have his son come along. “You know how to handle that old spider better than I do,” he said, meaning it for a compliment. “You might sell him a Detaze; but don’t try it until I get through with my deal. If I get this thing going, you’ll never need for money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t need for it now,” said Lanny, amiably.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie didn’t notice this unhelpful remark, but went on to say that Denis de Bruyne and his elder son were to dine with them in the evening; he had taken the liberty of assuming that Lanny wouldn’t mind having the matter put before Denis. Robbie phrased it tactfully, as if the husband of Lanny’s former "), _c('i', [_vm._v("amie")]), _vm._v(" were Lanny’s own special property.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Denis is a business man,” the son replied. “If he puts his money into anything, he’ll look into it carefully.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie inquired about the funeral, and when Lanny described the ceremonies he couldn’t keep from smiling, even though he felt deeply for the bereaved family. “It’s hard to understand how people would want to go through such a rigmarole,” he commented. “But I suppose that when they suffer too much they lose their balance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s what Mama was brought up in,” replied Lanny. “It helped her in a crisis, so it’s all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No use expecting women to be rational,” added the father; it was one of his oft-repeated formulas. Following an obvious train of thought, he added: “Beauty’s coming over from London to see what she can do with some of her friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny knew what that meant without asking any questions. From boyhood he had watched this team at work on one sort of deal or another: his “go-getter” father and his lovely mother, who passed for the father’s divorced wife, working together so perfectly that nobody could understand why they should ever have separated. It was always something involving large sums of money, and also what most people would have called gossip, but which Robbie would refer to as psychology; it involved the rehearsing of conversations in advance—you say this and then I’ll say that, and so on; because even in the smartest society people want to believe that you are entertaining them because you like them and not just because you want them to invest in oil stock or to introduce you to a government official who is charged with the purchasing of light machine guns for his country. Most of the time the deal would be put through, and then Mabel Blackless, alias Beauty Budd, alias Madame Detaze, and now Mrs. Parsifal Dingle, would receive a present of a new car or a mink coat or perhaps a check for a couple of thousand dollars with which to do her own purchasing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why do you take so much trouble?” asked the son of this odd partnership. “Why don’t you put your plans before Irma?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want a lot of money this time—five millions, at least. I mean to build a model plant, and I don’t want to start on a shoestring.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s all right, Robbie, Irma’s got it, and you know how highly she thinks of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, son, but that’s one thing I never have been willing to do—to barge in on your marriage. If anything did go wrong with my enterprise—not that it possibly can—but I try to keep business apart from family.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny understood quite well that he was having an expert salesman’s tact applied to himself. Robbie fully meant to put the project before Irma, but he wanted to be told to do it. The younger man knew what he was expected to say and he didn’t mind saying it. “Irma’s doing her own deciding. She’s quite proud of her judgment, and if you have a good proposition she’ll expect you to put it before her; she wouldn’t like it if you left her out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right,” said the father. “You tell her what I’m doing, and tell her I don’t mean to approach her unless she asks for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The French practice of "), _c('i', [_vm._v("la vie a trois")]), _vm._v(", which seems so strange to Americans and so highly immoral to the orthodox, had made Denis de Bruyne and Robbie Budd into friends of some ten years’ standing. In the Anglo-Saxon parts of the world an elderly husband and "), _c('i', [_vm._v("pere de famille")]), _vm._v(" would hardly choose for a friend the father of his wife’s young lover; but in Paris it had come about, and two men of large affairs had discovered that business customs are more powerful than marital in the shaping of minds and manners. These two, who lived and operated three thousand miles apart, thought and felt in much the same way about their worlds. In return for Denis’s courtesy in listening while Robbie abused “that man Roosevelt” and his so-called “New Deal” which really was the rankest kind of Socialism, Robbie would listen while Denis applied the same phrases to Leon Blum and his Socialist party which really was the rankest kind of Communism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie Budd was a son of Puritan ancestors, but he was a rebel son and had gone out into the world prepared to take it as he found it. He had watched his boy as a happy lover, then through a period of widowerhood of an odd irregular sort, and now for a period of godfatherhood of the same sort. Lanny was only a few years older than Denis, "), _c('i', [_vm._v("fils")]), _vm._v(", and Charlot, but he had promised their dying mother to look after them, and when he was in Paris he seldom failed to meet them; he would inquire gravely about their affairs, and they in turn would dutifully report, and accept whatever admonitions he considered it proper to give—even though they had no intention of following them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie’s business brought him often to Paris, where he would meet Denis, and they would discuss the state of America and France, and those nations whose affairs were tied up with them. Each met a sensible man of the world, cherishing the same hopes and balked by the same evil forces. Each would have liked to have his own way, but could succeed only to a limited extent. Each was troubled by a vague sense of inadequacy, and each had sons who tried unsuccessfully to tell him what was wrong. When the fathers met together they comforted each other, forming a clan against both the demagogues and the younger generation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Denis was past seventy, a handsome gray-haired man with a thin aristocratic face. His vices, which had broken up his marriage, hadn’t seemed to injure his health. Lanny had been told that he had an unfortunate hankering for virgins; but Denis had never mentioned the subject. To his father Lanny had expressed a mild curiosity on the subject of an elderly Frenchman’s affliction. How did one find virgins? Were there, in the lush underworld of Paris, merchants who made a specialty of this commodity? Or did one advertise in the newspapers: “Wanted virgins; highest prices paid; references required”? Having lived most of his life in the "), _c('i', [_vm._v("beau monde")]), _vm._v(", Lanny had come to understand that a dignified and even austere appearance, the best "), _c('i', [_vm._v("tournure")]), _vm._v(" and the most gracious and benevolent manners did not exclude the possibility of secret practices, amusing or disgusting according as you chose to take such matters.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The dinner was served in the drawing-room of Robbie’s suite, in order that the four men might be able to talk privately. Denis was a hard-headed person, and it wasn’t necessary to use finesse with him. As soon as the waiter had departed Robbie said: “I have a project which I think will be of interest to you.” The other replied: “Tell me about it, by all means.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie launched on his “spiel,” an exposition to which he had given as much care and study as Daniel Webster or Jean Jaures would have devoted to an oration. He had practiced it many times, varying it to fit the audience. It wasn’t necessary to point out the importance of aviation in the modern world, for the Frenchman had more than once expressed himself on the subject; indeed, Robbie tactfully indicated that Denis’s opinion had been one of the factors causing him to take up this project. He had come to France because he knew how deep was his friend’s anxiety over the inadequacy of the country’s air defenses and what Lanny had told him of the rearmament campaign of General Goring, Commander of the German Air Force.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Said Robbie: “One thing you can be sure of, there will never be war between your country and mine; so, if I should succeed in building the world’s best airplane factory in a part of the world where Goring cannot get at it, that would be a good thing for "), _c('i', [_vm._v("la patrie")]), _vm._v(" as well as for the individual investors. It is possible that I could go to the Germans with my proposition; but you know my feelings for France and how much I would prefer helping her to helping her enemies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie didn’t say what he would do in the event that French capitalists didn’t back him. On the other hand he didn’t say that he wouldn’t under any circumstances go to Germany; that would have seemed to him sentimental, out of keeping with the character of a business man—and besides, Denis wouldn’t have believed him. Business men talked on the basis of the open market, which modern techniques had broadened to include the world. Budd-Erling—that was to be the name of the new concern—would make planes for the world market, and no favorites played. We have our price and our terms of payment, and the rule is, first come, first served; your money is as good as the next fellow’s, and we don’t ask about your nationality or your politics or your religion, the color of your flag or of your skin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The owner of Paris taxicabs said it seemed to him that Robbie had a sound proposition. He asked many questions and Robbie answered them fully. The American had the whole set-up in a folder, and the Frenchman said to leave it with him and he’d study it and decide what he could do. He offered to put it before some friends, and Robbie said he’d come back to Paris after he had got through in London. So everything was all right, and they went to talking politics—where a great many things were far from right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The killing of Barthou had thrown French affairs into turmoil. The Foreign Minister had been one of the few real patriots left in the country, and who was going to take his place? Conferences were under way and wires were being pulled; Denis explained that he would have to leave early because he had to do his share of the pulling. It was a time of real peril for France—the mad Hitler was rearming his country rapidly, and his agents were busy intriguing and stirring up revolts in every nation, big and little. Meanwhile France was torn by domestic strife, and where among politicians would she find a friend and protector?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once more Lanny Budd gazed down into the boiling pit of "), _c('i', [_vm._v("la haute politique;")]), _vm._v(" once more he smelled the rather nauseous odors which rose from it. Alas, Marianne, "), _c('i', [_vm._v("la douce, la belle")]), _vm._v(", no longer seemed to Lanny the shining, romantic creature he had imagined in his happy boyhood; then he had loved her, and all her children, rich and poor, on that lovely Azure Coast where stood his home. But now Marianne was taking on an aspect somewhat drab; her honor was sold in the market-place, and the clamor of the traffickers spoiled the day and the night. French politicians were creatures of the Comite des Forges, of the great banks, of the "), _c('i', [_vm._v("deux cents familles;")]), _vm._v(" the head of one of these ruling families poured out details as to what prices had been paid and what services were being rendered. He was full of bitterness against upstarts and demagogues—save those whom he himself had hired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Denis reported that the talk was of Pierre Laval as Barthou’s successor, and apparently this was a politician with whom de Bruyne had had experience. Like most of the pack, the innkeeper’s son had started far to the left, and as soon as he got power had set out to line his pockets. When he was in danger of being exposed in one of the ever-recurrent scandals, he had saved himself by turning informer on his fellows. He had purchased a chain of papers all over France, and now was getting radio stations, useful in support of his financial and political intrigues. He had become as conservative as even Denis could have wished; indeed, so eager to preserve his property that he was an easy mark for the Nazi blackmailers. A man so wealthy could no longer think about France, but only about his own fortune.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having told all this, and gone into detail about it, de Bruyne added: “I have to excuse myself now; I have an appointment with that "), _c('i', [_vm._v("fripon mongol")]), _vm._v("”—that Mongolian rascal.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Next morning Beauty Budd arrived on the night train from Calais and Lanny went to meet her at the Gare du Nord; he was a dutiful son, and adored his full-blooming mother, even while he laughed at her foibles. There she was, descending from a "), _c('i', [_vm._v("wagon-lit;")]), _vm._v(" pink and gold fluffiness in a gray traveling-dress with fur boa to match. When he kissed her she said: “Don’t muss me any worse—I look a fright.” But Lanny, unfrightened, replied: “You are the eternal rose, and not one petal out of place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Don’t ask how old she was—it would be too unkind. She was the mother of a son who would be thirty-five next month and she discouraged the celebration of these recurrent calamities. She was gradually reducing in her own mind the age at which she had borne him, and she had been cheered by reading in the newspapers about an Indian girl in Peru who had produced a son at the age of five. When you have been so beautiful that you have been named for it; when you have seen all the men in restaurants and hotel lobbies turn to stare at you; when you have been many times immortalized by the most celebrated painters—when you have enjoyed all these glories too long, you look into your mirror in the morning and the tears come into your eyes and you begin to work frantically with the tools of the cosmetician.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For one thing, you have to choose between "), _c('i', [_vm._v("embonpoint")]), _vm._v(" and wrinkles; and fate had chosen for Beauty Budd. The cream-pitcher remained her worst enemy; while a million women in London and Paris strove in vain to get enough food, she failed mournfully in her efforts not to get too much. She was always trying new diets, but the trouble was they left her dizzy, and she had to have a few chocolates in between meals of one lamb chop with pear and cucumber salad minus dressing. She told about it, and then asked about the funeral. She had to reach for her delicate "), _c('i', [_vm._v("mouchoir")]), _vm._v(", for Mama and Rahel had been her dear friends and yachting-companions, and she was the kindest of souls; if she had ever done harm to any human being it was because the social system was too complicated for her to understand the consequences of her actions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie Budd had supported her upon a lavish scale, ever since he had fallen in love with her as a very young artist’s model in this city of pleasure. He had acknowledged her son, in spite of the opposition of his Puritan family. So how could she fail to do everything she could for him? By her combination of beauty, kindness, and social charm she had won the friendship of rich and important persons; and if Robbie wanted to meet them and make deals with them, why shouldn’t she lend her aid? Robbie never cheated anybody; what he sold was what they wanted to buy. If it was guns and ammunition, how could he help that? If now it was going to be planes, well, he would give them their choice, for peace or for war. Nobody could hate death and destruction more than Lanny’s mother; she had spoken boldly and had made enemies by it, but had not been able to change the destiny of this old Continent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie was a married man, and a grandfather several times over. Beauty was a married woman, and a grandmother once, which was enough. She had her separate suite in the hotel, and when she met Robbie they shook hands as old friends and behaved with such propriety that the gossips had long ago lost interest in them. Beauty would have herself made presentable, and then she would get busy on the telephone, and soon would be in a round of events. Wives of retired capitalists and widows of elderly bankers would learn that Robbie Budd, the American munitions man, was in Paris, planning a new enterprise which might be of vital importance to French defense and incidentally might be paying dividends of twenty or thirty per cent in a year or two.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Meanwhile, Lanny was motoring his father to the Chateau de Balincourt, once the home of King Leopold, misruler of the Belgians, and now the retreat of Sir Basil Zaharoff, retired munitions king of Europe and not retired Knight Commander of the Bath of England and Grand Officer de la Legion d’Honneur de France. The old gentleman was in his middle eighties, and saw very few people, but Lanny Budd possessed the key to his castle and his heart. Not merely had he known the noble Spanish lady who had been the old man’s wife, but he had received her messages from the spirit world through a Polish medium whom he had discovered. Sir Basil would be most happy to see Mr. Budd and his son, so the secretary had said over the telephone; would they be able to bring Madame Zyszynski along with them?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie talked about the strategy of approach to one of the most wary of men. “Talk to him about the duquesa,” said the father. “Can’t you recall something that will get him warmed up?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Beauty has been getting some interesting messages purporting to come from the Caillards,” replied the son.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine! Tell him about them; and if you can say that the spirits are riding in airplanes, that would really fetch him!” Robbie said that with a grin. He didn’t exactly ask that his son should make up some story about Zaharoff’s dead wife in the other world, yet if Lanny had proposed doing that, his father wouldn’t have objected. It is all right to have scruples, but they should be used with discretion, and not while dealing with an old spider, an old wolf, an old devil, who for more than a generation had played with the nations of Europe as casually as other men play with chessmen on a board.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lodgekeeper came out and looked them over; evidently he had his orders, and the gates swung back, and they drove up a broad driveway to the stone chateau—two stories, rather squat, but with wide-spreading wings. A turbaned Hindu servant admitted them; all the servants were from Madras. It was a damp and chilly day, and the master, wearing a green smoking-jacket, sat before the fireplace in his very grand library, which went up the two stories and had a balcony with heavy bronze railings. All those books, at which Lanny gazed hungrily; he doubted if half a dozen of them were opened in the course of a year. The old man no longer had any hair on the top of his head, but still had the white imperial below it; his skin was drawn and yellowish brown like old parchment. He did not rise from his seat or offer one of his palsied hands, but put cordiality into his tone as he told them to take the seats which had been placed for them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sir Basil,” said Lanny, at once, “have you heard that ‘Birdie’ is coming through?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nobody troubles to tell me anything any more,” was the sad reply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My mother wishes me to tell you about it.” Beauty Budd and the Knight Commander of the Bath had both been guests of Lady Caillard in London not long before she had “passed over.” She had been an ardent spiritualist and had made the usual promises to communicate with her friends from the other side. She had lived surrounded by mediums, and of course it was inevitable that these would begin getting messages from her. “Birdie,” as she was known, had been strong on emotions but weak on brains; and it was to be expected that her words from the spirit world should bear that same character. “Vinnie” was Sir Vincent Caillard, who had been Zaharoff’s business partner in Vickers-Armstrong and had been no fool, even if he had thought himself a maker of music as well as of munitions. Zaharoff knew his mind and thousands of things that had been in it. Now he listened attentively while Lanny told what he could remember of the seances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, God, how I wish I could believe it!” exclaimed the lonely old man. His beard waggled as he talked, and he leaned forward, thrusting his hooked beak forward as if he thought he could smell the younger man’s real thoughts. Lanny knew the one idea that was in his mind: was he ever going to see his beloved duquesa, the only person for whom he had really cared in a long life? He wanted so to believe it—and yet he hated so to be fooled! He wanted to hear that Lanny believed it; and yet, even if he heard it, he wouldn’t be sure whether Lanny was being honest with him. When one had been outwitting other people for three-quarters of a century, how can one believe that anybody is being straightforward?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They sat close together, and their eyes met in a long stare. It was as near as they could ever come to intimacy. “Tell me, Sir Basil,” asked the younger man, “have you any religion?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“None, I fear,” was the reply. “I have wished that I might. But how can a God permit what I have seen in this world?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A God might be leaving men to work out their own destiny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A God who made them what they are?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You believe, then, that you are an accident?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That seems to me the politest supposition I can make about the universe.” It might have been humor, and it might have been tragedy; Lanny guessed that it was some of each.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Not for a large amount of money would Robbie Budd have interrupted this conversation. He listened and watched and thought, like the practical psychologist he was. He was interested not in the question of where Sir Basil was going to spend his future years, but only in what he was going to leave behind him. Anyone who didn’t like Robbie would have said that his motive was greed, but Robbie would have treated such a person with quiet contempt; he had his answer, which Lanny had known by heart from his earliest days: Robbie wanted to get things done, and money was the means of doing it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An engagement was made for Madame Zyszynski, the medium, to come to Balincourt for another visit, so that Sir Basil might find out if “Birdie” wished to talk to him. After which the old man must have realized that he wasn’t being quite polite to the older of his guests; he turned, saying: “Well, Mr. Budd, what are you doing these days?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was an opening, and Robbie was prompt to take it. He replied: “I have come to ask for advice, Sir Basil.” His host said that he would give it if he could, and Robbie went on: “I have been studying the world situation, on the basis of the best data I can get, and have come to the conclusion that the industry of the future is aviation. I believe it will be for the next generation what the automobile was for the last.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The older man listened and nodded now and then as Robbie elaborated this thesis. Yes, it was true; he wasn’t going to be here to see it, but it was bound to happen; any nation that didn’t take to the air might as well give up before the next war started. If Mr. Budd knew sound aviation shares, those were the things to buy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is not exactly what I am thinking of, Sir Basil.” Robbie went on to tell about his dream of a perfect place for a perfect fabricating plant. “Airplane factories have been scratch affairs so far, and their techniques are based on small-scale operations. What I have in mind is to apply the principles of mass production to this new job; I want to put airplanes on a belt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is a pretty large order, Mr. Budd.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course; but if the industry is to be large, the order must be the same. Sooner or later somebody is going to become the Henry Ford of the air. He tried it himself, but has given up—just when success had become possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was Lanny’s turn to listen and watch and think; he, too, was something of a psychologist, though hardly a “practical” one. This aged plutocrat took on suddenly the aspect of a white-bearded gnome, sitting on a heap of treasure and watching with fear-stricken eyes every creature that came near. He had by now made sure that Robbie Budd wanted his money, and a lot of it, and he had lost every trace of that expansiveness which conversation about Vinnie and Birdie had produced. This was danger!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But still he couldn’t quite bear to break off the interview. The visitor was talking about profits, dividends of old-time magnificence. The Knight Commander and Grand Officer had known Robbie Budd for thirty years, and judged him a solid and capable fellow; no speculator, no fly-by-night promoter, but one who put money to work and himself to work with it. At the Genoa Conference, where Robbie had been Zaharoff’s agent, he had acted with competence; later, when Zaharoff had gone in on New England-Arabian Oil, he had got the better of Robbie—but not enough so that he would look on his associate with contempt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You couldn’t ignore what a man like that was telling you. You couldn’t help but be aroused, even if only by the memories which his voice and manner recalled. Those had been the days, and Zacharias Basileos Sahar or Zahar, who had been born of Greek parents in a peasant hut in Turkey and had become the real behind-the-scenes master of Europe, he was one who could say with the ancient Greek hero that much had he seen and known: cities of men, and manners, climates, councils, governments; himself not least, but honored of them all. If he couldn’t exactly say that he had drunk delight of battle with his peers far on the ringing plains of windy Troy, at least he could claim to have sent a hundred thousand other men to drink that dubious delight. Those windy plains were near to the village of Mugla, where Zacharias Basileos had started his career, and also to the scene where twelve years ago his personally financed Greek army had been slaughtered by the Turks.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Robbie Budd expatiated upon the defenses of Montauk Point, and the safety of Long Island Sound and its tributary rivers as a nesting-place for war industries; he told about railroad connections, and steel that was brought from the Great Lakes through the Erie Canal and the Hudson River. He pictured the factory of steel and glass he was going to build, air-conditioned, a twenty-four-hour-a-day plant. He showed the drawings of his air-cooled radial engine to Zaharoff, who had owned tens of thousands of engines. In its lighter parts Robbie was going to use magnesium, a metal which the industry had slighted. Small shavings of it are explosive, but he had a method of gathering them up automatically. Instead of hammering the cast parts into place he was going to freeze them in liquid air and set them, and when they had returned to normal temperature they were there for life. When he was running tests on his engines he was going to hitch them up to generators and so make electricity for his plant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So many new ideas this hard-driving Yankee had, and the retired munitions king watched him as a fascinated cobra watches its Hindu charmer. “I am an old man, Mr. Budd,” he pleaded, pathetically. “My doctors tell me that I must avoid the slightest strain. I have my safe investments, and find that it disturbs me to think about shifting them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Sir Basil,” agreed the promoter; “but this is the sort of thing that comes only a few times in a long life. Here is the one really live industry, the one that is going to shove everything out of its way. We shall make our turnover every few months—I don’t want to exaggerate, but I have studied the field thoroughly, and I cannot see how we can fail to make enormous profits.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The operation of greed in this aged Greek trader’s psychology was something automatic. He was like some old toper who has sworn off, but cannot resist the sight and smell of his favorite beverage; like Rip Van Winkle: “This time don’t count!” Lanny, watching him, saw a light gleaming in the cold pale-blue eyes; the palsied fingers seemed reaching out for the treasure and the old white imperial seemed waggling with excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What did he want with more money? What could he imagine himself doing with it? Here he was, with all but one or two toes in the grave, and, whatever else he might believe about the future, he couldn’t expect to take Budd-Erling stock with him. He had no one to inherit it but his two married daughters, and what could they do with it? Lanny’s mother had met them in society, and reported them as entirely undistinguished persons. They would inherit several billions of francs—nobody knew the real figure. Yet Zaharoff had to have more; it was the nature of his being.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie had him at a disadvantage, because he knew so much about the old man’s affairs: his staff, his attorneys, the advisers he trusted. Robbie had already talked to one of them, and perhaps—who could say?—promised him a "), _c('i', [_vm._v("douceur")]), _vm._v(", a “sweetener.” He knew how easy it would be for Zaharoff to order the sale of a million dollars’ worth of bonds, and the buying of Budd-Erling preferred, with an equal number of common shares for bait. Robbie waved this bait in front of Sir Basil’s prominent nose, and it followed this way and that. Lanny saw that there was going to be a “killing,” and the procedure made him faintly sick, but he decided that this was sentimentality. Who would worry about the fate of an old spider, an old wolf, an old devil?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After all, Zaharoff would get real value for his money. There was really going to be this wonderful building, with a long line of objects moving along slowly and being constantly added to by parts taken from overhead conveyors, until each in turn became recognizable as an airplane and finally rolled off on its own wheels, ready to mount upon the air. All this would continue, long after Sir Basil had gone to his duquesa; as long as civilization endured, with its paper titles of ownership, his descendants would be entitled to dividend checks payable at the First National Bank of Newcastle, Connecticut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The upshot was that Sir Basil took a copy of Robbie’s “set-up,” promising to study it, and if he found it according to Robbie’s statements, to come in on the deal; he wouldn’t say for how much, but would let Robbie know in a couple of days. The promoter was in high spirits on the drive back to Paris. It was the best day’s work he had done since the depression, he said; you can’t keep a good man down!")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny ought to have been a true son of his father and done his share in the making of this new Budd glory. Robbie had cherished that hope for many years, but had had to give it up. He had two sons by his wife in Connecticut; solid fellows, nearing thirty, they would be his right hand and his left. Lanny would sell a block of his securities and put the money into his father’s enterprise, and then he would go back to playing the piano, advising purchasers of art works, and dreaming of seeing the world a less cruel place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What he did now was to go for an afternoon stroll along the pleasant streets of Paris in the pleasantest season of the year. There was a visit he wanted to pay, and he wasn’t going to tell his father about it. His mother, perhaps—she couldn’t very well object to his visiting her brother, who had befriended her and had never done her the least harm. But with Robbie it would mean the starting of an argument, and what was the use? Lanny wouldn’t tell his wife, either, for that would mean another argument, and of even less use.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny Budd, good-looking, rich, and called a darling of fortune, was a man with a secret vice; and like many such unfortunates, having learned what other people thought of his weakness, he had evolved subtle devices to protect himself. He didn’t enjoy lying, so when he stole away to practice his vice he would include in his journey some innocent occupation such as looking at pictures; then when Irma asked him what he had been doing, he would answer: “Looking at pictures.” He would learn to keep silent on all subjects that might possibly be connected with his vice and bring it to his wife’s mind. What you don’t know won’t hurt you—such is the maxim of erring husbands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fact that he refused to recognize his vice for what it was made a difference to him, but, alas, it made none to Irma; and he had had to learn the lesson that if what you do brings unhappiness to someone you love, the question of vice or virtue is a mere matter of words. They had said all the words it was possible to say on the subject, and it hadn’t made any difference; so now Lanny had walled off a portion of his life and mind from most of his friends, including the woman who was dearest to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny’s vice was that he liked to talk to “Reds”; he liked to meet them, and hear them discuss the state of the world and what they were proposing to do about it. Whenever he expressed his own opinion, he got into an argument with them, too, but he took that as part of the fun. He didn’t mind if they denounced the system under which he enjoyed a delightful leisure; he didn’t even mind if they denounced him, calling him an idler, a playboy, a parasite. He didn’t mind if they got his money, and then refused to pay the tribute of gratitude, saying that it wasn’t really his money, he had no right to it, it belonged to the wage-slaves, the disinherited of the earth—in other words, to themselves. These things infuriated Irma, but Lanny took them all with a grin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was some kind of queer streak in him which Irma and her friends couldn’t make out; some called it “yellow,” though not often in Irma’s hearing. The grandson of Budd’s had somehow got fixed in his mind the notion that he wasn’t entitled to his money and, worse yet, that Irma wasn’t entitled to hers. It was like a thorn buried deeply in his conscience; it festered there, and no surgery had been able to extract it. This caused him to take an apologetic attitude toward disturbers of the social peace and made him their predestined victim; a soft-shell crab in an ocean full of hard-shell creatures. Irma had her own ideas about “parasites”; she thought they were the grumblers and soreheads, the crackpots and cranks who wrote letters to her husband and laid siege to his home, in the effort to dump their sorrows into his heart and their burdens onto his shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma had tried to be good-natured about these annoyances, up to the last year or two; but the episode of the Robin family had broken her patience. She blamed all the misfortunes of that family upon the doings of the Red Hansi and the Pink Freddi and the failure of the head of the family to control his wayward sons. She went further and blamed all the troubles of Europe upon the activities of the Bolsheviks. It was their threats of class war and wholesale robbery which were responsible for the development, first of Fascism in Italy and then of Nazism in Germany. When the well-to-do classes found they could no longer sleep safely in their beds, naturally they hired someone to protect them. Hadn’t Irma and Lanny themselves done it, for the safety of their “twenty-three-million-dollars baby”? Irma was quite willing to admit that Mussolini and Hitler and Goring were not the most agreeable types of people, but perhaps they were the best the well-to-do classes had been able to find in the emergency. Thus spoke, vigorously and frequently, the daughter and heiress of J. Paramount Barnes, one-time utilities king.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Uncle Jesse Blackless still resided in the apartment in the working-class neighborhood where Lanny had grown used to visiting him. The fact that he had become a deputy of the French Republic hadn’t made any difference in his life—except that it might have had something to do with his decision to marry the French Communist who had been his “companion” for ten years or more. The living-room of his apartment was still a studio, one corner of it packed solid with his paintings; he was busy making another when Lanny knocked on the door. He had a little "), _c('i', [_vm._v("gamin")]), _vm._v(" for his model, and when he saw his nephew he gave the youngster a few francs and sent him along, then lighted his old pipe and settled back in his old canvas chair to “chew the rag.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They had plenty to talk about: family affairs, the news that Beauty was in Paris and that Robbie was going to become a millionaire all over again; the news about pictures, what Lanny had bought and what was to be seen in the autumn Salon; then political events, the killing of Barthou, and the chances of Laval’s taking his place—Lanny told what Denis de Bruyne had said about this "), _c('i', [_vm._v("fripon mongol")]), _vm._v(", and it was data that Jesse would use in his next Red tirade in the Chamber. Of course without hinting at the source of his information.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bald, lean, and wrinkled Jesse Blackless was what is called a “character”; perhaps he was born one, but now he clung to it as a matter of principle. The income he enjoyed from the States was sufficient to have enabled him to wear a clean new smock, but he chose to be satisfied with one which revealed all the different colors he had had on his palette for several years. And it was the same with many of his habits; elegance was a sign of caste, and he chose to be one of the “workers”—although he had never worked at anything but making pictures and speeches. He chose to believe that everything the workers did was right and that everything the rich did was wrong, this being in accordance with the doctrine of economic determinism as he understood it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny hadn’t been able to find many formulas which satisfied him, and it amused him to pick flaws in his Red uncle’s. They would wrangle, both taking if as a sort of mental boxing-match. Jesse sounded quite fierce, but basically he was a kind-hearted man who would and frequently did give his last franc to a comrade in distress. What he wanted was a just world, and the preliminary to this was for the rich to get off the backs of the poor. Since dialectical materialism demonstrated that they wouldn’t, the thing to do was to throw them off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The funeral of Freddi Robin had been reported in both "), _c('i', [_vm._v("Le Populaire")]), _vm._v(" and "), _c('i', [_vm._v("L’Humanite")]), _vm._v(", the former celebrating it as a Socialist event and the latter treating it as an anti-Nazi event. This provoked the painter to declare the futility of attempting to overthrow the Nazis except by Communism; which in turn made it necessary for Lanny to declare the futility of attempting to achieve the goal without the co-operation of the middle classes. Jesse said that the middle classes were being ground to pieces by the economic process, and to hell with them. Lanny said statistics showed the middle classes increasing in America, despite all Marxist formulas. And so on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If Irma Barnes had heard her husband arguing she might have imagined that she had converted him; but no, if she had been here, he would have been driven to take the side against her. This wasn’t perversity, he would insist; he was trying to see the problem from all of its many sides, and argued against all persons who wanted to see only one side. He dreamed of a just social order which might come without violence; but apparently everything in this old Europe had to be violent!")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The newly established mistress of this household came in, and the argument was dropped, for Francoise, hard-working party member, lacked the American sense of humor and would be annoyed by Lanny’s seeming-flippant attitude to the cause which constituted her religion. Lanny chatted for a polite interval and then excused himself, saying that he had an engagement to dine with his father. He went out to walk in the pleasant streets of Paris at the most pleasant hour of sunset, and stopped in a couple of art-shops whose dealers were acquainted with him and were pleased to show him new things. This would keep his record clean—he had been “looking at pictures.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ladies of the "), _c('i', [_vm._v("trottoir")]), _vm._v(" manifested an interest in a handsome; well-dressed, and young-looking man. In fact, walking alone on the streets of "), _c('i', [_vm._v("la Ville Lumiere")]), _vm._v(" was no easy matter on this account. Lanny liked women; he had been brought up among them and was sorry for them all, the rich as well as the poor; he knew that nature had handicapped them, and this was no world in which to be weak or dependent. He would look at the thin pinched faces of those who sought to join him; their paint did not deceive him as to the state of their nutrition, nor their artificial smiles as to the state of their hearts. He saw their pitiful attempts at finery, and his own heart ached for the futility of these efforts at survival.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There came one, more "), _c('i', [_vm._v("petite")]), _vm._v(" and frail than usual, and with a manner showing traces of refinement. She put her arm in Lanny’s, saying: “May I walk with you, Monsieur?” He answered: “"), _c('i', [_vm._v("S’il vous plait, Mademoiselle")]), _vm._v("—"), _c('i', [_vm._v("vous serez mon garde du corps")]), _vm._v(".” One would keep the others away!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took out his purse and gave her a ten-franc note, which she crammed hurriedly into her sleeve. She didn’t know what he meant, but it sufficed for a start, and as they strolled along he asked her where she came from, how she lived, and how much she earned. Like so many others she was a "), _c('i', [_vm._v("midinette")]), _vm._v(" by day; but work was uncertain in these terrible times and one couldn’t earn enough to pay for food and shelter, to say nothing of clothes. She perceived that this was a kind gentleman; and Lanny understood that if she wasn’t sticking exactly to the facts, this also could be explained by the formulas of economic determinism. Anyhow, she was a woman, and the tones of her voice and the pressure of her hand on his arm told him a good deal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their stroll brought them to where the Rue Royale debouches onto the Place de la Concorde. Lanny said: “We have to part now. I have an engagement.” She replied, this time doubtless with entire truth: “"), _c('i', [_vm._v("Je suis desolee, Monsieur")]), _vm._v(".” She watched him enter the Hotel Crillon, and knew that a big fish had got away. However, the ten francs would buy her a dinner and leave enough over for a scanty breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny went into the hotel, in whose red-carpeted and marble-walled lobby great events had happened during the Peace Conference of fifteen years ago. For the grandson of Budd’s the place would be forever haunted by the ghosts of statesmen, diplomats, functionaries of all sorts, some in splendid uniforms, others in austere black coats. Many were now dead and buried in far corners of the earth, but the evil they had done lived after them; they had sowed the dragon’s teeth, and already the armed men were beginning to rise out of the ground, in Italy, Germany, Japan; in other places the ground was trembling and one saw the round tops of steel helmets breaking through. Lanny and others who thought they understood dragon agriculture predicted a bumper crop, perhaps the biggest in history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He went to the desk for his mail. There was a letter, a poor-looking letter in a cheap envelope, not usual in this haven of the rich. But it was common enough in Lanny’s life, he and his wife being targets for begging letters. This one was postmarked London and addressed to Bienvenu, from which place it had been forwarded; the handwriting was foreign, apparently German, and Lanny didn’t recognize it. He opened the envelope as he walked toward the "), _c('i', [_vm._v("ascenseur")]), _vm._v(", and found a note and also a little sketch on a card the size of a postcard. He looked at it and saw the face of the dead Freddi Robin; it caused him to stop in his tracks, for it was extraordinarily well done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He glanced at the signature, “Bernhardt Monck,” and did not know the name. He read:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal"
  }, [_vm._v("Dear Mr. Budd:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("I have a communication which I am sure will be of interest to you. I came to England because I understood that you were here. I hope this letter will find you and I thank you kindly to reply promptly, because the circumstances of the writer are not permitting of a long wait. It is a matter not of myself but of others, as you will understand quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The stranger signed himself, “Respectfully,” and had put in the envelope this little password, this shibboleth or countersign, which had the power to send cold chills up and down Lanny’s spine. To an art expert this simple pencil drawing, which bore not even an initial on it, was the surest means of identification and the most secret message that could be contrived. Every line of the drawing cried aloud to him: “Trudi Schultz!” The date on it, October 1934, with a black line drawn around it, said to him: “I have learned of Freddi’s dying condition, and have sent a messenger to see you.” The young artist Trudi had been one of the teachers at Freddi’s school in Berlin, and her style was not to be mistaken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If Lanny had been a discreet person, if he had learned thoroughly the lessons which life was apparently trying to teach him, he would have put this little drawing away in a portfolio with other art treasures, including a sketch of himself by Jacovleff and several by John Sargent; as for the letter, he would have torn it into small pieces and sent them down into those sewers of Paris which have been so vividly described in "), _c('i', [_vm._v("Les Miserables")]), _vm._v(". He thought of these prudent actions, to be sure; he thought of his wife and what she would make of this situation. He argued with her in his mind. He hadn’t promised her that he would never have anything more to do with Reds or Pinks; he hadn’t said that he wouldn’t receive any more messages from Germany or give any more thought to the struggle against the Nazis. All he had said was: “I will never again get into trouble with the Nazis, or cause you unhappiness because of my anti-Nazi activities.” Surely it couldn’t do harm if he saw a messenger from a young artist of talent and found out what had happened to her, and to her husband, and to the other friends of himself and Freddi Robin in Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So the toper says to himself: “I am reformed now; everything is settled and safe; I will never again touch liquor in any form; but of course a glass of beer now and then, or a little light wine at mealtimes, cannot do me any harm!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny had the sketch framed and carefully packed, and sent it by registered mail to Mme. Rahel Robin, Juan-les-Pins, Alpes-Maritimes. Also he wrote a note on the stationery of the Hotel Crillon to the mysterious Mr. Bernhardt Monck, stating that he expected to be in London in two or three days and would get in touch with him. Without mentioning the matter, he enclosed a one-pound banknote with the letter, thus making sure that Mr. Monck wouldn’t perish of starvation in the meantime.")])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("A YOUNG MAN MARRIED")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Bidding temporary farewell to his parents, Lanny Budd set out early on a damp and chilly morning to motor to England. Not far off the route lay the Chateau les Forets, home of Emily Chattersworth, and he detoured to pay a duty call on her. This old friend of the family was not so well or so happy; the leading art critic who had been her "), _c('i', [_vm._v("ami")]), _vm._v(" for a quarter of a century had decided that a younger woman was necessary to his welfare, and when that happens the older woman does not find joy in even the finest landed estate. Emily had stood by Beauty Budd when her son was born out of wedlock, and she had been a sort of informal godmother to Lanny; having helped to make his match with a famous heiress, she was always interested to hear how it was coming along. After the fashion of this free and easy world of wealthy expatriates, she discussed the troubles of her heart with the young man, and he kept no secrets from her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was news to be exchanged concerning the people they knew and what they were doing. Lanny told about Freddi’s funeral, and about Lady Caillard’s “coming through,” and about the success of the concert tour which Hansi Robin and Lanny’s half-sister Bess were making in the Argentine. He told about the Salon at which he had spent the previous day, and described a painting he had bought for one of his clients. Emily wanted to know about Robbie’s affairs, and he advised her: “Keep away from him; he’s in one of his high-pressure moods.” That always awakens the curiosity of the rich—they are used to being run after and are impressed when they are run from. Emily talked about the state of the market, and said it was shocking the way her income had fallen off; however, she couldn’t bear to think of changing her investments while the prices of all her holdings were so low. Lanny said there was no use remembering that they had ever been higher.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She really wanted to hear about Robbie’s project, so Lanny reported on it. He perceived that a white-haired chatelaine was a victim of the same tropism as an aged Levantine trader; he teased her about it, and she made the answer which the rich always make—they have so many taxes, so many dependents, such a variety of expenses which cannot be cut down; whatever their income, they are always “strapped.” Lanny said: “You know I’m no promoter, but it looks as if Robbie’s going to make a lot of money.” Emily responded: “Do you suppose he’ll come out to see me if I phone him?”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("On to Calais, the town full of memories never to be erased; it was there that Lanny had waited for the Robin family to arrive on their yacht, and had learned that the Nazis had seized them. He drove his car onto the packet-boat, and paced the deck watching the busy stretch of water which he had crossed with Marie de Bruyne, then with Rosemary, Countess of Sandhaven, and of late with Irma Barnes; he thought of each in turn, experiencing those delicate thrills which accompany the recollection of happy loves. Here, too, he had crossed with his father in wartime, through a lane made by two lines of steel nets held up by buoys, with destroyers patrolling them day and night. People of Lanny’s sort now spent much time discussing the question whether such things were likely to be seen again, and if so, how soon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were no fields of clover when Lanny went up from Dover. The green was beginning to fade from the landscapes, and a soft drizzling rain veiled every scene, making it look like an old painting whose varnish has turned brown. Lanny enjoyed this season of mist and mellow fruitfulness, and observed with the eyes of an art connoisseur the thatched cottages and moldy-looking roofs, the hedges, the winding roads—but watch your reactions, for it’s tricky when you drive one-half the day on the right and the other half on the left! He by-passed London bound for Oxfordshire and home; he had wired Irma, and Mr. or “Comrade” Monck would have to wait a day or two longer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were living in a villa which Irma had rented from the Honorable Evelina Fontenoy, aunt of Lord Wickthorpe. It was called “small,” but was large, also modern and comfortable, in contrast to Wickthorpe Castle, whose estate it adjoined. It had a high hedge for privacy, and very lovely lawns; the drive made a turn when it entered, so that passers-by couldn’t see the house at all. When Lanny came up the drive at twilight he heard a shout, and here came a small figure with brown hair streaming—little Frances, dressed in a raincoat and overshoes, and let out in care of a groom to await the arrival of that wonderful father, almost as rare as Santa Claus. He stopped the car and she clambered in beside him, to drive a hundred feet or so; there was a present for her in the seat, but she mustn’t unwrap it until she got her wet things off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The “twenty-three-million-dollar baby” so much publicized by the newspapers was now four and a half years old, and wise care had averted most of the evils which might have been predicted for one in her position. She hadn’t been kidnaped, and hadn’t been too badly spoiled, in spite of two rival grandmothers. A trained scientist had had the final say about her, and had said it with effect. Frances Barnes Budd was a fine sturdy child, and was going to grow up a young Juno like her mother. She had been taught to do things for herself, and nobody had been permitted to tell her that she would some day be abnormally wealthy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma came to the head of the stairs when she heard the child’s excited cries. Lanny ran up, two steps at a time, and they embraced; they were in love with each other, and a week’s absence seemed long. She wore an embroidered red silk kimono in honor of his coming—her blooming brunette beauty could stand such adornment. She led him into her sitting-room, and the child took a perch upon his knee and unwrapped his present, a picture book with pastel drawings of that gaiety which the French achieve by instinct. She wanted it read to her right away, but Irma said that she and Lanny had much to talk about, and sent the little one off to the governess, whose accomplishments included French.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then they were alone, and there was the light of welcome in Irma’s eyes, and they were happy together, as they had been so many times, and might be forever, if only he would let it happen. At least, so it seemed to Irma; but even while she still lay in his arms, fear crept into her soul like a cloud over a blue sky. She whispered. “Oh, Lanny, do let us be happy for a while!” He answered: “Yes, darling, I have promised.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But his tone meant that the cloud was still there. When lovers have had a clash of wills and unkind words have been spoken, these words are not forgotten; they sink into the back of the mind and stay there, having a secret life of their own, generating fear and doubt. Especially is this so when the cause of the disagreement has not been removed; when the clash of wills is fundamental, a difference of temperaments. The lovers may try to deny it, they may cry out against it, but the difference goes on working in their hearts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A duel carried on in secrecy and darkness! Lanny thought: “She is trying to put chains upon me; she has no right to do it.” Irma thought: “He will think I am trying to put chains upon him; he has no right to think that.” But then, in her fear, she thought: “Oh, I must not let him get that idea!” Lanny, in his love, thought: “I must not let her know that I think that! I have caused her too much unhappiness already.” So it went, back and forth, and each watched for the signs of stress in the other, and suspected them where they were not actually present, resenting them even while resolving not to cause them. So it is when a ray of light is caught between two almost parallel mirrors and is reflected back and forth an endless number of times, or when a wave of sound is thrown into a tangle of rocky hills and echoes are set rolling back and forth as if evil spirits were mocking the source of the sound.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny talked about his trip. Not much about the funeral, for Irma wanted to forget all that as quickly as she could. But she was interested in Robbie and his project, and in the visit of Zaharoff and its outcome. She said: “Lanny, that ought to prove a big thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I believe it will,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Doesn’t Robbie want me to come in on it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know how he is—he’s shy about putting it up to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But that’s silly. If he has a good thing, why shouldn’t I have a chance at it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, he said he wouldn’t mention it unless you asked him to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He ought to know that I have confidence in him, and that it’s a family matter. I would be hurt if he left me out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll tell him,” said Lanny; and so that was settled most agreeably. Would that it had all been as easy!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m glad you got home early,” remarked Irma. “Wickthorpe is having the Albanys to dinner and asked us over in the evening. I said we would come if you got back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine,” replied the husband. “And by the way, would you like to run up to town with me tomorrow? I have a letter from a man in Ohio, asking if I can find him a good Sir Joshua. I think I know where there’s one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What the art expert had said was true; he was determined never to lie to his wife. If Irma had asked: “Did you see Uncle Jesse?” he would have answered “Yes” and told her what they had talked about. But she didn’t ask; she knew that she didn’t have the right to expect him not to meet Beauty’s brother. He, for his part, knew that she must have known that he would go there, and perhaps meet other Reds, and perhaps make them promises of the sort they always tried to get from him. They would unsettle his thoughts, make him discontented with his life, cause him to be moody and to make sarcastic remarks to his wife’s friends. The wild echoes were set flying in their hearts again; but neither spoke of them.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Gerald Albany was a colleague of Lord Wickthorpe in the British Foreign Office; they had been through Winchester together and were close friends. Albany was the son of a country clergyman and had to make his own way; perhaps for that reason he was more proper and reticent than other members of the diplomatic set whom Lanny had met. He was a tall lean man with a long serious face, and had found a wife who matched him perfectly, a large-boned lady wearing a dark-blue evening costume which was doubtless expensive but looked extremely plain. The half-starved little "), _c('i', [_vm._v("fille de joie")]), _vm._v(" with whom Lanny had strolled on the boulevards had more "), _c('i', [_vm._v("chic")]), _vm._v(" than Vera. Albany could ever have or perhaps wish to have.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The husband was a carefully studied model of a British diplomat, cold in manner and precise in utterance; yet, when you knew him, you discovered that he was a sentimental person, something of a mystic, knowing long stretches of Wordsworth by heart—he had even read the "), _c('i', [_vm._v("Ecclesiastical Sonnets")]), _vm._v(", not once, but many times, and was prepared to defend them as poetry. He was conservative in his opinions, but tried hard to be open-minded or at least to believe that he was; he would permit Lanny to voice the most unorthodox ideas, and discuss them in such a carefully tolerant way, with so much suavity, that unless you knew his type of mind you might think he half agreed with you. Yes, of course, we are all Socialists now; we are enlightened men and we understand that the world is changing. The ruling classes must be prepared to give way and permit the people to have a larger say about their affairs; but not in India or Central Africa, in Hong Kong or Singapore. Above all, not in too much of a hurry; right now only the Conservatives understand the situation and are able to guide the ship of state in perilous seas!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma was deeply impressed by this conscientious functionary, and wished that her husband might be; she tried in a way which she thought was tactful to bring this about. But Lanny, the impatient one, thought that the world ought to be changed right away. He said that the difference between a Bolshevik and a Tory was mainly one of timing; the toughest old die-hard in the Carlton Club could be got to admit that maybe in a few thousand years from now the dark-skinned races might be sufficiently educated to manage their own affairs both political and industrial. But, meanwhile, we have to carry the white man’s burden, placed upon our shoulders by that God of our fathers so intimately known of old.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny had been on a scouting expedition, as it were. His friends were pleased to hear what a French financier thought about political prospects in his country and what an ex-munitions king, a Knight Commander of the Bath, had to say about the state of Europe. Pierre Laval had just become Foreign Minister of France, and Lanny told what he had heard about him; speaking in the privacy of the home, the Englishmen agreed that he was an unscrupulous and undependable fellow. That was the difficulty in relations with France; the governments changed so rapidly, and policies changed with them; you could never be sure where you stood. British foreign policy, on the other hand, changed very slowly; in fundamentals it never changed at all. Britain had a Prime Minister who was a Socialist, yet everything remained as it had been. Politicians may come and politicians may go but the old school tie goes on forever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These friends knew all about Lanny’s misadventures in Germany and made allowances for his extreme views on the subject of Nazism. But they were not prepared to change the fixed bases of their empire’s policy because an American playboy with a pinkish tinge to his mind had got thrown into the dungeons of the Gestapo—nor yet because a family of wealthy German Jews had been blackmailed and plundered. Wickthorpe was prepared to admit that the Nazis were tough customers; an irruption from the gutter, he called them; but they were the government of Germany, "), _c('i', [_vm._v("de facto")]), _vm._v(" and "), _c('i', [_vm._v("de jure")]), _vm._v(", and one had to deal with them. They might be made to serve very useful purposes; for one thing, as a counterweight to French political upstarts who had a tendency to become extremely arrogant, on account of their country’s great store of gold; and for a second thing, as a check upon Russia. “Oh, yes!” exclaimed Lanny. “Hitler is to put down, the Bolsheviks for you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wherever an American art expert traveled, in Europe, in England, in America, he found the privileged classes, his own kind of people, hypnotized by the Fuhrer’s flaming denunciations of Communism and the Red Menace. The ex-painter of postcards voiced their thoughts completely on this subject; he was their man and promised to do their job. In vain Lanny tried to make them realize that no slogan meant anything to Hitler, except the gaining and keeping of power; political opinions were an arsenal of weapons from which he picked up those which served his need at a certain moment of conflict. When conscientious, God-fearing English gentlemen stood upon a platform and made promises to their electorate, they meant at least part of what they said; and how could they imagine that Hitler, Goring, and Goebbels would change their entire “line” overnight if it suited their political or military purposes?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny was frightened about it, and sad about the state of opinion in all the countries he knew. But there is a limit to the amount of arguing and protesting you can do in the drawing-room of even your best friends; if you keep it up, they will stop inviting you; and long before that happens, your wife will be pointing out to you that you are making yourself socially impossible. Lanny, well trained from childhood and now provided with a thoroughly competent wife, had to sit and listen while Lord Wickthrope proceeded to “adumbrate”—so he said—the future of world history in accord with the best interests of the British Empire. “Good God, man, don’t you suppose that Hitler knows what you are expecting? And why should he oblige you?”—so Lanny wanted to cry out; but he knew that if he did he would get a scolding on his way home.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The master of this ancient chilly castle, a sight for tourists and a home for bats, was slightly older than Lanny, but, like Lanny, appeared younger than his age. He had pink cheeks, fair wavy hair, and a tiny pale-brown mustache; how he had managed to remain a bachelor had been a mystery to Irma since the first day she had met him at the Lausanne Conference. He had elegant manners and an assured mode of speech. His was a civil service job, and he had had to pass very stiff examinations, so he knew what to do and say in every eventuality. He would listen courteously to what you had to report, and then, if he thought it worth while, would explain to you where you were mistaken. If he didn’t think it worth while, he would turn and talk to someone else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma thought him one of the best-informed men she had ever met, and sometimes she cited him to her husband as an authority. Irma loved the romantic gray-stone castle, in spite of its portable bathtubs which she called “tin.” She loved the respectful tenants who always tipped their hats to her if they were men and “bobbed” if they were women. She liked English reserve, as contrasted with French volubility. She liked living in a world where all the people knew their places and everything had been happening just so for hundreds of years. She wished that Lanny could be dignified, instead of bohemian, meeting all sorts of riffraff, rubbing elbows with “radicals” in smoke-filled cafes and letting them argue with and even ridicule him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In short, Irma liked a world without confusion whether domestic or intellectual. She had seen, first in Russia and then in Germany, that if you played with dangerous ideas you presently began to witness dangerous actions. She thought that Lanny was old enough to have sowed his cultural wild oats, and she yearned for him to settle down and take care of her and her fortune and her child. She found in Lord Wickthorpe the perfect model of what she would like her husband to be; and while she was too tactful to put it in plain words, Lanny could gather it without difficulty. He wasn’t in the least jealous, but he couldn’t help thinking now and then how pleasant it would be if his wife could agree with him about the things he considered important. His effort to keep his annoying thoughts to himself was resulting in a sort of split personality, and as time passed the hidden part of him was becoming the larger and more active.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Emily Chattersworth had persuaded Irma that it was important for her to take a serious interest in her husband’s occupation and to let him have the manly sensation of earning his own money, however small the amount. So Irma would go with him to look at old masters and would gravely offer her opinion upon their merits and prices. She wanted to be cultured, and this was a part of it. Many of the paintings really were beautiful, and now and then when Lanny came upon a bargain Irma would buy it herself and have it stored until the time when she had her own palace, either in England or France, she wasn’t sure which.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sir Joshua was an especially interesting master, because he had done so many beautiful aristocratic ladies and their children. Irma herself was such a lady, and Lanny had told her that he was looking for the right man to do a life-size portrait of her. So now she saw herself in these duchesses and countesses, and studied poses and costumes, in order that when the time came she would be able to tell the artist exactly what she wanted. That is the way to meet life, she had decided: know how to spend your money, say what is your pleasure, and hold the respect of those you deal with, from the humblest slavey who brings in your coal-scuttle to the proudest nobleman who invites you to grace his drawing-room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny was conscientious about serving his clients. When the owner of a ball-bearing plant in Ohio wrote that he wanted a good Sir Joshua for his collection, Lanny didn’t pick up the first one the fashionable dealers offered; he didn’t say: “That fellow has so much money it doesn’t matter what he pays.” No, he would consult his card-file and list all the Sir Joshuas of which he had been able to learn; he would get photographs of each, and send them to his client, with a long letter detailing the qualities of each and discussing the possible prices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I advise you to let the matter rest for a few weeks,” he would write, “until word has got round about the inquiries I have made. You understand that the market for old masters is a small world, full of busy and eager traders, and they gossip among themselves like a hive of bees. They regard Americans as their proper prey, and invariably ask fifty per cent more than they would ask of an Englishman. I have succeeded in impressing them with the view that I am not an easy mark; I worry them with the idea that my client prefers some other picture, and usually in a few days they call up and invite me to dicker, and try to get me to set a price, which I refuse to do until I hear from some other dealer on some other picture. All this is very sordid, but it’s the way paintings are bought, and there’s no use letting yourself be plucked.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such a letter would impress the manufacturer, for it was the way he would proceed when placing an order for steel ingots. When he got his painting at last he would appreciate it much more because he had had to worry obout it. He would say to his friends: “That chap Lanny Budd got it for me—you know, Budd Gunmakers; he’s married to Irma Barnes, the heiress, so it’s really a labor of love with him.” The arrival of the painting would be celebrated in the local newspapers, and not merely would the painting be reproduced, but also a photograph of the proud owner; so the other steel men of the district would learn that art pays, and the wife of one of them would get Lanny’s address and inquire if there was anything really first class now on the market. Lanny would get his ten per cent out of all this, and it provided him with pocket money and made an amusing sort of life.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("After Irma had looked at several paintings she always got tired, and remembered various things which ladies have to do when they visit a great city; hairdressers, manicurists, masseuses, milliners, dressmakers, furriers, jewelers—all sorts of shrewd purveyors who are busy day and night thinking up schemes to persuade them that it is impossible to live worthily and romantically without such services. After lunch Irma said: “I want to go to So-and-so’s,” and they made an appointment for later in the afternoon to have tea and dance for a while. Lanny, having known that this would happen, had telegraphed Mr. or “Comrade” Monck at what hour he would call upon him, in a very poor neighborhood in Limehouse, near the docks. Here were rows and rows of two-story slum dwellings, laid end to end and exactly alike, each with its two chimneys emitting wisps of soft-coal smoke. With the help of hundreds of factory chimneys they formed a pall which had enveloped the district for a hundred years and brought it to the appearance of a vast dustbin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In such a neighborhood a fancy sport-car would be a phenomenon; so Lanny, taught by his experience in Germany, spotted the house and then drove around the corner and parked. When he knocked on the door there came a slattern old woman, in features and voice completely Cockney. When he asked for Mr. Monck she said: “Ow, yuss,” and as she led him up the narrow stairs she said it was a nice dye, sir; he was quite sure that, whatever Nazi or anti-Nazi plotting might be going on here, the lydy of the ’ouse ’ad nuffin to do wiv it. Lanny hadn’t failed to consider the possibility that he might be dealing with the Gestapo; they might have got Trudi Schultz in their clutches and be using one of her sketches as a means of trapping her friends and getting information. He had read of their kidnaping persons from Austria and Switzerland; the brother of Gregor Strasser had been one of their near-victims; but he didn’t think it likely they would go that far in London—not quite yet!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman, grumbling about her rheumatism, didn’t really have to climb the stairs and knock on the door of the rear room; Lanny guessed that she was curious about her foreign lodger and the “toff” who had come to see him. A man inside answered the knock, took one glance, and said, quickly: “"), _c('i', [_vm._v("Bitte, keinen Namen!")]), _vm._v("” Lanny said not a word, but stepped in. The lodger shut the door in the landlady’s face and carefully hung a coat over the knob so as to cover the keyhole; he sighed Lanny to the sole chair in the small and dingy room, and said, in a low voice: “"), _c('i', [_vm._v("Besser wirsprechen Deutsch")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny had been imagining some sort of “intellectual,” but a single glance told him that this was an outdoor man, used to hard and tough labor. His frame was stocky and filled out like a boxer’s, and his neck went up straight and solid in the back. His face was weatherbeaten, his hands gnarled; his clothes were those of a laborer and his dark hair was cropped short in Prussian style. Lanny thought: “A sailor or perhaps a longshoreman.” He had met the type among the Socialists in Bremen as well as on the Riviera: the man who has labored by day and read at night. His education is narrow, but he has forged it into a sharp sword for his purposes. He knows what he wants, and his speech is direct. If he is middle-aged, he is probably a Socialist; if he is young, he is more likely to be a Communist.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The stranger seated himself on the edge of the narrow bed, not more than three feet from Lanny, and, gazing straight into his face, began, in a voice with a strong North German accent: “The name I gave you is not my real name, so there is no harm in your speaking it; but I will try not to speak your name, and let us not name any of our friends or any places. There are, you understand, extremely important reasons.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you reason to believe that you are being watched here?” inquired the visitor, speaking low, as the other had done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to assume it always. That is the only way to survive. I sent you something in the way of credentials. Did you recognize it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I believe I did,” replied Lanny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let us refer to the woman in the case as Frau Mueller. Let that be for both speaking and writing in the future.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny nodded. He thought: “A miller instead of a village magistrate,” that being the meaning of the name Schultz.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The stranger continued: “Frau Mueller and I are associated with others in some work of the utmost importance, and we have one rule, we do not reveal anything about it except in case of absolute necessity. I hope that you will not question me too much, and will not take offense if I say: I cannot answer this or that. It is not merely our own lives that are at stake.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand,” replied Lanny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We do not under any circumstances name any other person. I know the names of those with whom I deal, she knows the names of those with whom she deals, but I do not know her associates, and so on. We keep nothing in writing, anywhere. So, if we are captured, our enemies have only us; and even if they torture us, and we should break down and wish to betray others, we cannot do much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand,” responded Lanny, again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is my hope that you will trust me on the basis of what you know about Frau Mueller, who gave me your name and sent me to you. She has told me about you, and assured me that you are a comrade and a man of honor; also that you have had experiences which enable you to know what our enemies are and how serious a matter it is to us if we are betrayed or even talked about in a careless way. I ask that you will not mention this meeting to anyone under any circumstances. May I count upon that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You may do so. Of course I can’t say how far I might go along with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We need friends outside our own country, and we hope that you will help us and perhaps find others to help us. We can accomplish very important work if we can get help. We represent a people’s movement, for the deliverance of our people from a slavery which is intolerable to them and at the same time is a deadly danger to the outside world. I take it you agree with that, and do not require any proofs or discussion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quite so, Herr Monck.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know what Frau Mueller was in the old days. I was the same and still am. Secrecy and intrigue are not of our choice; they are forced upon us by brutal tyranny. Our work is educational; we are not terrorists, and are determined not to become such under any circumstances. A great civilized people is being blindfolded, and we are trying to strip the bandages from their eyes. We take that as our duty, and are willing if need be to give our lives, and to risk torture in order to do it. What methods we are using to spread information is our secret, and we are sure you will understand that we do not speak any unnecessary word about them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand everything that you say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know Frau Mueller and trust her as a comrade. There are reasons why she could not come. My position is such that I can enter and leave the country, and so I am serving as her messenger. I hope you will accept me as you would accept her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny had been studying the face so close to his own, weighing every tone of the voice and trying to make up his mind concerning the personality behind them. He said: “It will be necessary for us to speak with entire frankness, now and in our future dealings, if we are to have any.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quite so, Herr—what shall I say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Schmidt,” suggested Lanny—adding one more occupation to the miller and the village magistrate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Einverstanden. Herr Schmidt")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The woman you speak of is one I would trust without question. But I cannot forget the possibility that cunning enemies might have seized her and her papers, and might have sent one of their well-trained agents to me, knowing exactly how to pose as a member of her group.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are entirely right, and I expect you to question me and do whatever you find necessary to satisfy yourself. But if I prefer not to answer some questions, do not take it as a sign of guilt. If I were an agent of the enemy, I would answer freely.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny couldn’t help smiling. “An enemy might be more subtle,” he remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The grandson of Budd’s didn’t fail to realize that this was an important moment in his life. He had been expecting something like this ever since he had come out of Germany, and he had thought hard about how he was going to meet it. Now he said: “There are many things already known to me about Frau Mueller, and if you possess detailed knowledge about these, it will help to convince me that you really know her well and are her friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will tell you all that I can think of,” replied the stranger. Speaking slowly and carefully, like one searching his memory, he began: “Frau Mueller is what is called a blond Aryan. She is, I should say, under thirty, and rather tall for a woman. Her voice is deep in tone. I have only known her about a year, and do not know how she used to look, but she is now thin and pale; her features are extremely delicate and you feel that she is a consecrated person. She has a strong sense of duty, and lays more stress upon personal qualities than most Marxists do. She has fair hair, rather wavy—naturally so, for she concerns herself very little with her appearance. She draws quickly and with accuracy; since I know nothing about art, I can only wonder at it. Also I might mention that she has a strawberry mark just above her right knee.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am sorry, I do not know her well enough to confirm that.” Again Lanny couldn’t keep from smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other replied, gravely: “Last summer her friends perceived that she was working and worrying too hard, and would persuade her to go to one of the lakes for a few days, and go in swimming; that is how I came to see the mark. She is utterly devoted to the memory of her husband and clings stubbornly to the idea that he is still alive and that she will some day help to set him free.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have not been able to find out about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one has heard a word since he was taken away. We are all sure that he was murdered and secretly disposed of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You might tell me about this arrest, if you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was arrested with the young relative of yours, the Jew who played the clarinet and who had come to the Mueller home because of sudden illness—he had eaten some food which must have poisoned him. Frau Mueller went out to do some marketing, and when she returned she found that the home had been raided and her husband and your relative had been taken away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is in accord with what she told me. Let me ask, did she tell you about her last meeting with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She was coming out of a tailor-shop carrying a bundle of clothing, when you came up to her and insisted on recognizing her in spite of her not wishing to be known. You told her that your relative was in Dachau and promised to try to find out whether her husband was there also. But she never heard from you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did she tell you how she expected to communicate with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You were to come to a certain street corner, and she went there at noon every Sunday for quite a while, but you did not appear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did she say I gave her anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You gave her six one-hundred-mark notes, and she wishes you to know that they were turned over to the group and used for our work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I never had any doubts about that,” replied the American. “That is all convincing, Herr Monck; and now tell me what you wish me to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We need more of those notes, Herr Schmidt. You understand that in the old days the workers’ movements were strong because they could collect dues from millions of members; but now our group is small, and every time we make a new contact we risk our lives. It is hard for workers in our country now to earn enough to buy food, to say nothing of saving anything for literature. We must have help from comrades abroad, and it is the hope of Frau Mueller that you will consent to act as our collection agency.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny hadn’t needed to ask his last question; he had known what was coming, and his conscience had begun to ache, as it had done many times before. People expected so much of Mr. Irma Barnes, who drove expensive cars, dressed in the height of fashion, and lived in elegant villas in the most delightful parts of the earth!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doubtless Comrade Monck also knew what was going on in that well-shaped and well-cared-for head. He went on quickly: “We have a cause, for which we are risking not merely death, but the most cruel torture which fiends in human form have been able to devise. It is not merely our cause, but yours; for if these fiends whom you know well are able to turn the resources of the country to armaments, you will be in just as great danger as we. Therefore we have a right to claim the support of decent and right-thinking men. I have taken a long and dangerous journey here and I do not feel embarrassed to put it up to you. I am not a beggar, I am a comrade, and I present it as a matter of honor, of duty which a man cannot refuse without shame. You have seen innocent blood shed, and the blood of your murdered friend calls-out to you—not for vengeance, but for justice, for the truth to be spoken, for a long and hard and dangerous job of truth-telling to be done.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("There it was: a voice from outside Lanny Budd, speaking the same words which his inner voice had been speaking day and night, haunting him and tormenting him, not letting him rest even in the most fashionable society, even in the arms of the ardent young Juno who influenced him so deeply. It was a commanding voice, and he thought: “If this rough working-man is an agent of the Gestapo, they certainly have a first-class school of elocution and dramatics!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poor Lanny! He had to begin the “spiel” which he had repeated so many times that he had got tired of hearing himself. “Genosse Monck, I don’t know whether Tru—that is, Frau Mueller realizes it or not, but my money resources are not what people think. I have to earn what I spend; and while I spend a good deal, it is because I earn my money from the rich, and there is no way to go among them unless you live as they do. I have a wealthy wife, but I do not have the spending of her money; she does not share my political beliefs, and it is a matter of pride with me to keep my independence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I accept what you say, Genosse; but I cannot have any pride, because I am a hunted man, and I have not only my own fears, but those of millions of working people, whose need is so great that no one can exaggerate it. I am not using wild words, but telling you the plain truth when I say that to take my country out of the hands of the bandits is the most important cause in all the world today. Nothing else matters; literature, art, civilization itself—everything is gone if we fail. Surely what you have been through and seen must make it impossible for you to escape that truth!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you know what I have seen?” asked Lanny, with sudden curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is one of the questions I ought not answer. People wear masks in my country today, and they speak in whispers, but these whispers keep going all the time, and news spreads with great speed. That is why a few pieces of flimsy paper, which cost so little in money, can do such a tremendous work; they can start a fire which will never be put out. Believe me, I know the state of mind of our workers, and what can be done. Give us what money you can spare, and go out and help raise more for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have many rich friends”—Lanny was continuing his “spiel”—but few who would put up money for the cause we are talking about. I fear that what I give you I shall first have to earn.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do what you can—that is all we ask. We balance our lives against your time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is what I will do,” said Lanny. “I will give you five hundred dollars today—it is all I can spare at the moment; but I will give you a thousand or two now and then, as I am able to earn it by selling pictures. I ask only one condition as to future amounts: I shall have to see your friend Frau Mueller and hear her tell me that this is what she wishes me to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That will be very hard to arrange, Genosse.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not so hard, I believe. I am willing to come to your country. An hour ago I would have said that nothing could induce me to re-enter it; but I will come for the sake of this work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will you be permitted to enter?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I feel quite sure there will be no interference with my movements. I have my business, which is "), _c('i', [_vm._v("bevorzugt")]), _vm._v("—it brings foreign exchange to your country. I have been careful to preserve my status, and I know important and influential persons. Let me add this: I am keeping your secrets, and I expect you to keep mine. You may tell Frau Mueller about me, but no one else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would not think of doing otherwise.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Sehr gut, abgemacht!")]), _vm._v(" Let Frau Mueller write me a little note; in her handwriting, which I think I know, and signed ‘Mueller.’ Let her set a time, day or night, to be at the place where she was previously to meet me. I remember it well and have no doubt that she does. Tell her to set it a week ahead, which will give me time to make my plans and arrive there. You may assure her that I will take every precaution and make certain that no one is following me. She does not have to walk or drive with me, if she thinks it unwise; it will suffice if I see her clearly, to be sure of her identity, and hear her voice say two words: ‘Trust Monck.’ Surely that is not an excessive demand.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Das wird sich tun lassen!")]), _vm._v("” declared the visitor, with decision. “And let me add, Herr Schmidt, that I admire your way of doing business.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("So here was Lanny “putting his foot in it” again; indulging that vice, displaying that weakness which was the despair of his three families; that inability to say No to persons who prated about “social justice” and promised compensation to the poor at the expense of the rich. What did Lanny really know about this tough-looking customer? He used the language of revolutionary idealism with genuine-seeming eloquence; but what did that mean? The British Museum contained thousands of books filled with such language, and any day you might see bespectacled individuals, drably dressed and in need of haircuts, poring over these volumes, storing these ideas in their minds. They were repeated in thousands of pamphlets which might be bought for a few pence at bookstalls in working-class districts. Anybody could learn this lingo—just as anybody could learn to make explosives and to construct bombs!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny argued the question with his wife and his mother—a silent, mental argument as he drove away from the rendezvous in Limehouse. Lanny wasn’t at all sure of his own position, and was exposed to the assaults of these two persons and others who had claims upon him: Irma’s mother, Emily Chattersworth, Sophie, Margy, all the other fashionable friends. “Why on earth should you give your trust to this man?” they would demand. “He says he isn’t a terrorist; but what a small lie that would seem to him if he was! You say that Trudi Schultz is a Socialist; but a year and several months have passed since you saw her, and how do you know she hasn’t changed under the stress of persecution? You say you wouldn’t die of grief if they made a bomb and killed Hitler; but would you be prepared to have the Gestapo wring the truth out of them, and have the newspapers of the whole world publish the story that the grandson of Budd Gunmakers, otherwise known as Mr. Irma Barnes, had put up the money for the bomb? And what do you think will be our feelings when we are named as the mother, the wife, the mother-in-law, the friend, of this starry-eyed comrade of assassins? Have the rich no rights that a young Pink is bound to respect?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus the ladies who surrounded Lanny; and then the men, better informed as to politics, would take up the argument. “Even granting that this powerful self-educated sailor or roustabout who calls himself your "), _c('i', [_vm._v("‘Genosse,’")]), _vm._v(" your devoted comrade in Socialism, is really what you believe, what then? Maybe he will be the Ebert of the coming revolution, but again, maybe he’ll be the Kerensky—the Socialist lawyer who took power in Russia, but couldn’t hold it and was ousted by the Bolsheviks. Are you prepared to see that pattern repeated in Germany? If so, let us know, so that we may understand what sort of son, or half-brother, or in-law we have got!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All this clamor, this tumult in Lanny’s mind while he drove to the fashionable hotel where he had stayed on various occasions. It was after banking-hours, but the hotel management knew that his check was good and had no hesitation in handing him out ten ten-pound and two one-pound banknotes. From there he went to a near-by establishment which offered European and American currencies at a slight discount, and changed the notes for twelve one-hundred-mark and five ten-mark notes. With these rolled up and safely stowed in his breast pocket he went for a stroll along the Strand, where presently he was approached by a roughly dressed working-man who walked by his side and might have been saying: “Please, Mister, will yer give a poor bloke tuppence for a bite to eat?”—but he wasn’t. Lanny slipped him something which might have been a pack of cigarettes, but wasn’t. Genosse Monck presumably set out for Germany, and Lanny set out for the nearest art dealer’s, so that he would be able to say to his wife with perfect truth: “Well, I saw another Sir Joshua, and it can be bought for something less than ten thousand pounds.”")])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("WHEN DUTY WHISPERS")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The day after Lanny’s return from London he drove to the home of the Pomeroy-Nielsons to tell a lame ex-aviator as much as he was free to tell about his plans and his uncertainties. The Reaches, as the place was called; was on the Thames River, a small stream at an early stage of its career, but good for swimming and punting, and for-tow-boats on the other side where there was a path. The Pomeroy-Nielson home was old, and built of red brick, added to through the years, with many gables and dormer windows and one battery after another of chimney-pots. Even so it was chilly, and American visitors shivered from early autumn to late spring. Lanny, having been raised in Europe, didn’t mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The head of the household was Sir Alfred, a crotchety but sociable old baronet with white hair, and mustaches still dark, who had difficulty in paying his debts but was happy collecting materials on the twentieth-century English drama. (This, he said, was something everybody else would overlook until it was too late.) His children had gone out into the world, all except the eldest son, whose family lived in his parents’ home; an arrangement not always successful, but this was a big rambling place, difficult to keep up, and Rick’s mother, who wasn’t well, leaned more and more on his wife for help in carrying the burden. The crippled son had had his parents’ support through the years while he was struggling to be a writer, and now that he had made good as a dramatist he helped pay the family debts and tried to keep his father from spending more than he would ever have.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another day of mist and light rain, and Lanny sat in his friend’s study in front of one of those delightful fires such as they have in English grates, made of chunks of soft coal which sputter and emit oily juices and burn with large varicolored flames. The door was shut, and there was no chance of spies in this Englishman’s castle, but even so, Lanny spoke low, because it was becoming an instinct. “Rick,” he said, “I’ve got a contact with the underground movement in Germany.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Indeed?” said his friend, his interest awakened at once. “Tell me about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I had to give my word not to reveal any details. It’s a message from some of the people I used to know there; you can guess if you choose. They want money, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure it’s the real thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pretty nearly; but I mean to make absolutely sure before I give much. I think I’ll be going into Germany.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The devil you do!” exclaimed his friend; then right away: “What’s Irma going to make of that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’ll have to be on some picture deal; or maybe you could ask me to get some material for an article.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look here, Lanny, you’re not going to find it so pleasant living a double life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, but there’re a lot of unpleasant things going on. I can’t turn those comrades down flat, can I? After all it’s our fight, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Irma’s bound to find out about it; and she’ll raise bally hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know; but I’ll try to spare her as long as I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A smile broke over the older man’s face. How characteristic of Lanny—trying to spare Irma, not himself! Being an Englishman, Rick wouldn’t say all that he felt, but his heart ached for this friend of his boyhood who was so kind and generous and had chosen such a very bad time to be born. Also, of course, Rick was interested professionally, for he had used Lanny’s problem as the basis for a drama of class conflict, and the way things were going he might do it again. One cannot be a writer without thinking about “copy.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("What Lanny wanted to talk about was not his marital situation, which Rick had known for a long time, but the services he might render to the cause they both had at heart. He enjoyed an exceptional position for several reasons. Being an American, he was supposed to be neutral in the quarrels of old Europe; also, being the type which Hollywood has chosen for its heroes, he carried to many people some of the glamour of the screen. His rich wife gave him access to the great and powerful, and his genuine occupation of art expert provided him with reasons for traveling from one capital to the next. Such a man ought to be able to give real help to the cause of social justice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m no writer or speaker,” he said; “I guess I’ve had too easy a life, and I’ll never be anything but an amateur. But I can get information, and there ought to be some place where I could bring it and have it put to use.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wickthorpe and Albany would give you a liberal expense account,” declared the Englishman, with a bit of mischief in his eye.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No doubt,” said Lanny; “they’ve already sounded me out. But what use would they make of the information I brought them? All they want to do with Hitler is to set him to fighting Russia, and I can think of better uses for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What, for example?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, let him fight Mussolini over Austria.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have Robbie get you a diplomatic post,” suggested Rick, “and you can enjoy yourself setting all your enemies at one another’s throats!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In the first place, my father will be the last man in America to have any influence in Washington; and as for our State Department, from what I hear it’s going ahead just like your Foreign Office—business as usual. I want to take my information to some place where it will serve our cause.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Up to this time the best Lanny had been able to think of was to help Eric Vivian Pomeroy-Nielson to write plays, and occasional articles for those few newspapers and weeklies which were open to ideas of a pinkish tinge. That was the tragedy of both men’s position: when you adopted such ideas you condemned yourself to futility; you became a voice crying in the wilderness, and you might as well have been crying to the hawks and the buzzards, for all the attention you got.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had become worse than ever since Adolf Hitler had seized power in Germany, nearly two years ago. Before that time Lanny and Rick had had a party they could believe in and a press they could help: the Socialist party of France and the Labor party of Britain, groups which stood for peace and international understanding, the cutting down of exploitation and the power of financial oligarchies. But how could anybody be for peace, with the Nazis turning all the power of Germany to armaments, with General Goring setting out to build an air force that would terrorize Europe? Lanny and Rick, pointing this out, were scolded by their former comrades and told that they were crazy. Rick found himself, to his great embarrassment, on the side with Winston Churchill, resonant imperialist, while Lanny Budd found himself agreeing with the Army and Navy League!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rick said: “Do you still have the idea that you can go into Germany and pose as a friend of Goring?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know,” Lanny said. “It won’t do any harm to try. He can only order me out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Surely he must know your record by now, Lanny!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I kept thinking that the last time; but you know how it is—every bureaucracy commits boners. Also, you must remember, the fat Hermann is so corrupt it’s hard for him to believe that anybody is honest. The offers he made to me must seem to him irresistible. He may be thinking: ‘Well, if the fellow has accepted, and is going ahead, he’d have to be posing as a Leftist in England and France.’ That’s the way the game is played; wheels within wheels and treachery piled on treachery.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re poorly equipped for it, Lanny,” warned the friend who knew him best.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not so sure,” was the reply. “The honest man may be very successful as a liar when nobody believes a word he says. The Nazis may be convinced that I’m deep, and they won’t ever be quite sure how deep I am—how many levels there are to my tricks! All I want is to have one person who knows what I’m really up to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It seems to me you’re starting on a darned uncomfortable career,” declared the playwright.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("It was a Friday afternoon, and Rick’s eldest son came home for the weekend. Alfy, as he was called, was nearly ready for his career as an undergraduate at Magdalen College, which the English so unaccountably pronounce Maudlin; he had taken a bus from Oxford, and had had to walk quite a distance, so he arrived with shoes muddy and trousers wet, but with the glow of good health in his cheeks; he was just seventeen, tall and slender like his father, also his grandfather for whom he was named; dark eyes, dark wavy hair, a thin serious face. He was precocious, as he had to be in such a family; a conscientious student, much more to the left than his father had been at seventeen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Topping!” he said when Lanny asked how he was, and “Righto!” when his father suggested that he change to something dry. Lanny had promised to drive him some forty miles to the fashionable school where Marceline Detaze was a boarder, to bring the girl over for Sunday. Lanny didn’t mind dashing about the country like that, regardless of weather. He was fond of this eager intelligent youth and ready to do his share in helping along the match which he had suggested when the two babies had made their appearance in a world torn by universal war. Beauty’s daughter had been left fatherless a few months after her birth, and Rick’s son had very nearly become a half-orphan before his eyes saw the light. Now it seemed to both Rick and Lanny that the dark shadow of conflict was looming over the world again; but no use to say it, for people didn’t want to believe it and they knew how to believe what they chose. Perhaps some deep-hidden instinct guided the young people, causing them to pair off early and fulfill their chief function before it was too late.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It amused Lanny to discover that he was an elder; he didn’t feel it, but Alfy did and looked up to him with great respect, as a person who had traveled widely, met the great ones of the earth, and had adventures concerning which it perhaps wasn’t sporting to question him too closely. Was it really true that he had been taken into the dungeons of the Nazis and seen them beating a poor old Jewish banker to make him give up his money? “Do you think we’ll have to fight those beggars some day? And is it a fact that we are letting them outbuild us in planes?” Lanny realized that here was somebody who took his statements seriously and didn’t regard him as slightly daffy. “I’m taking more mathematics than I properly should,” revealed the baronet’s grandson. “I’ve an idea it’ll be needed in our air service. But don’t speak of that when the mater’s around because you know how it would trouble her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poor Nina! Something shivered inside Lanny Budd at the thought that she might some day have to go through that agony again. One time was enough for any woman’s life! He was moved to repeat to this lad the story of the strange experience which had befallen him when he was just at Alfy’s age, living with the Robbie Budd family in Connecticut while Rick was flying in the battle of France; how Lanny had awakened at dawn, at the very hour that Rick had crashed and all but died, and Lanny had seen what he thought was his friend standing at the foot of the bed, with a red gash across his forehead—the same scar which the ex-aviator bore to this hour. “Your mother nursed him back to life,” said Lanny. “It’ll be deuced hard on her if she has to do it again.” That was as far as English good form permitted you to go.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Here came Marceline, dancing; she always seemed to be dancing, so happy, so young, so full of energy. She was a month or two younger than Alfy, but, after the way of the female, she had left him far behind; she was a full-blooming young lady while he was a gawky boy—so he felt himself, and was helpless in her hands. The daughter of Beauty Budd couldn’t fail to be something special to look at, and this had been made doubly certain when her father had been so handsome a man as Marcel Detaze. The child had been well provided with mirrors and had listened to the talk of the ladies and the women servants of her household, so she knew what she had and what she was going to do with it. A slender, graceful figure, in accord with the fashions of the time; lovely blond hair with glints of gold; and that feature with which Lanny had been familiar in her father, eyebrows much darker than her hair, lending an unusual touch to her bold, high-colored charms. She was half American and half French, having the vivacious temperament of her father’s people and the self-reliance she had got from a mother who had run away from a Baptist preacher’s home and become an artist’s model when no older than Marceline now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, indeed; poor Alfy, very much in love; and with a lack of worldly graces, was going to be hard put to it to hold her. She was the only child of a great painter whom everybody talked about, who, indeed, was on his way to becoming an “old master”; out of the proceeds of his toil Marceline was going to enjoy comfort and perhaps luxury. She knew there was London and Paris, she knew there were palaces and yachts, and that all such delights were within her reach. That was the way she had been brought up. Lanny, who would have had it different if he could, had to take the position of a spectator, here as in so many other places in that "), _c('i', [_vm._v("beau monde")]), _vm._v(" which enveloped and conditioned him, he was forced to remain silently acquiescent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This Beauty-in-the-Budd, as Rick called her, sat wedged in the front seat between the two men, and Lanny drove and listened to her chatter. Words poured out in floods, because life was so wonderful it could not be restrained. Her talk was all about persons: about girls in the school whom Alfy knew or should know, about boys who were coming to The Reaches for the weekend dances and parties. When they got together they all chattered like this, at least the girls did. They remembered what they had said in other places and repeated what they had heard others say, and it was like the conversation of a family of chickadees in the hedge. Quite a contrast between this and the talk which Lanny had been carrying on with Alfy; he wondered: “Did women all have to be chickadees or was it simply the way they were trained?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This young couple were in love with each other, but in their own competitive way which outsiders could not regulate. Marceline resented having her destiny decided, and insisted upon starting all over again on her own terms. She said that Alfy was as solemn as an old owl, and persisted in teasing him into activity and making him miserable in the process. She hadn’t the slightest interest in such matters as politics and only the vaguest notion as to what mathematics might be; but there was nothing she didn’t know about the arts of coquetry, and she practiced them on every personable young man who came in sight—generally those who were older than Alfy and therefore more likely to throw him into a panic. It was all rather cruel, but it was nature, and doubtless it was better to settle these affairs with quips and teasing than for the young men to butt each other like the stags in the forest.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Back at The Reaches they had dinner, and afterward young friends from the neighborhood came in. Things were just the way they had been in Lanny’s boyhood, when he had first visited here and met Rick’s playmates, including Rosemary, who had become his first sweetheart and had sat out in the moonlight while Kurt Meissner played the piano and they dreamed wonderful dreams. Now it was a new generation, sons and daughters of Lanny’s playmates, but they seemed exactly the same. Fashions hadn’t changed much—they came in cycles; skirts were short, and then they were longer, and the same with haircuts. Love was the same, only they talked about it more freely; laughter was the same and no less of it, in spite of wars past and others on the way. Lanny’s first visit to this home had been in the spring of 1914, and nobody had been worrying; he wondered now, in the autumn of 1934, would they be worrying next summer or the one after that?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They moved the rugs and furniture from the center of the drawing-room, and put on phonograph records and danced. “Hot jazz” had come from America, and now a new thing called “swing,” and the young people shivered with delight, cherishing their favorite records and raving over them endlessly. They had forgotten that the old dances existed—all but a few like Marceline, to whom Lanny had taught everything he knew. When he danced with her, the others were apt to stop and watch; this had happened in many a drawing-room and even on the floor of a casino; they could have got engagements and made their living that way if they had cared to. When Marceline danced, something arose inside and possessed her; she became a creature of music and motion, expressing delight and at the same time knowing that she was doing so, exulting in the attention she was getting. Joy and pride in equal measure, each stimulated the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had been that way from earliest childhood, the first toddling steps that Lanny had watched her discovering for herself; he had praised and encouraged her, and others had done the same, and so they had made a dancer. She would dance alone for the pure delight of it, but she would find a mirror to practice before, and would be thinking of those who would be watching her later on. She came by this honestly, for her mother had loved to be looked at, first as a model and then in the world of fashion; she had been what was called a “professional beauty.” Marceline’s father had painted pictures to be looked at; and while he had professed to be indifferent to praise and had refused sternly to promote his own work, Lanny suspected it was because he had met with so many disappointments that he had been forced to paint for himself. Surely the primary purpose of art is to communicate to others, and not alone to the artist!")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Back in Wickthorpe Lodge, as his temporary home was called, Lanny settled down to normal domestic life, something he had denied himself for a long time. He enjoyed the society of his lovely young wife; he dressed himself properly and took her to social affairs, carefully avoiding the expression of any ideas with which she might disagree. He reminded himself that after all she was only twenty-six, and her mind wasn’t entirely matured; it was no use expecting her to know everything or even to wish to know it. He played with his little daughter, teaching her dance steps and going with her to see the new kittens. He played the piano, and read books he was interested in; he went over his card-files and carried on his business correspondence with the help of a stenographer who came when summoned. He enjoyed peace and quiet, and thought with an ache in his heart: “If only men would learn to let one another be happy!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But all the time he was like a man waiting for a court to pass sentence upon him and for a bailiff or sheriff to come and take him away. He counted the days and tried to guess when Genosse Monck would probably get back to Berlin and a letter from Trudi Schultz, alias. Frau Mueller, might be expected. He felt certain that she would write; the conspirators would need all the money they could get, and she would hardly leave him in uncertainty. If no letter came, it could only mean that Monck was some kind of fraud.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the days passed, Lanny fell to guessing about that—what kind of fraud would he be? A terrorist—and had he now bought his gaspipe and his nitroglycerin, or whatever it is that bombs are made of nowadays? And who would it be? Hitler or Stalin or Trotsky, Hermann Goring or Pierre Laval, or—God forbid!—Ramsay MacDonald or King George of England? Lanny couldn’t believe that this man of intelligence and force was a common swindler who would spend the money on wine and women; no, he was some sort of revolutionary, or else a well-trained agent—in which case Lanny ought to get a letter from Trudi Schultz that would be written under duress or else would be a forgery. Rather difficult to lose yourself in the music of Liszt or Chopin while speculations such as these were haunting your mind!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At last, a letter with a German stamp and a Berlin postmark! A plain envelope, with no sender’s name; Lanny shivered, knowing that it was the court sentence. He went to his own study to open it, and standing in the middle of the floor he read:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal"
  }, [_vm._v("Dear Mr. Budd:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("I have many new sketches which I believe will interest you, and would like to have your help in marketing them. If you are in Berlin on Nov. 6 I would be happy to meet you and show them. If that date is not convenient, any date thereafter will do.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal2"
  }, [_c('span', [_vm._v("Respectfully yours,")])]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal1"
  }, [_c('span', [_vm._v("Mueller")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("A careful and proper note that could not excite the suspicions of any Gestapo man, or of a wife who might have an impulse to pry into her husband’s mail. The writing, of German type, might have been a man’s or a woman’s. Lanny, having had some correspondence with Trudi at the time he arranged for her drawings to be published in "), _c('i', [_vm._v("Le Populaire")]), _vm._v(", now got her letters from his files and sat down and studied them with a lens. More important yet, there were two little sketches with the letter; one was a head with which Lanny was most familiar, his urbane self in his most coming-on mood. Trudi, heart-broken and terror-racked, was saying: “Bright and shining one, dwelling in safety in a happy land—that fortress built by Nature for herself against infection and the hand of war!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other picture was of Hansi Robin with his violine, and that, too had its magic. Ludi and Trudi Schultz, a pair of pure-blooded Aryans, had been invited to the palace of Johannes Robin, Jewish "), _c('i', [_vm._v("Schieber")]), _vm._v(", to listen to Hansi and his New England wife playing the music of the German Beethoven and the Jewish Mendelssohn, the French Cesar Franck and the Hungarian Remenyi. This bright little sketch was a reminder of that evening; its message was that of Schiller’s hymn and the Ninth Symphony, that all men become brothers where the gentle wing of joy is spread.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course it might be possible that a skilled draftsman had imitated Trudi’s style; a signature can be forged, and many an expert has been humilated by a clever imitation of a painting. But Lanny thought this was the young woman’s work. He studied the sketches under a glass and saw that the lines were clear and clean, which would hardly have been the case if she had been working under duress. He had what he had been looking forward to for more than a year, a chance to meet her and perhaps to ask her some questions. For that and that alone he would be willing to go into Naziland again.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny had now come to a parting of the ways in his dealings with his wife. Should he go to her and say, straight out: “I have established a contact with the underground movement in Germany and I propose to go there to make sure about it”? That was the course he would have preferred to take; but was it consistent with his pledge of secrecy, with the protection he owed to people who were risking their lives? It had been all right to tell Rick, who was a comrade, and would keep his lips sealed without even being warned. But would Irma keep a secret when she didn’t want to and didn’t think that she ought to? When she considered herself being greatly wronged and ardently disliked the persons who were wronging her?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fanny Barnes, Lanny’s large and aggressive mother-in-law, was talking about paying them a visits. Would Irma, nursing a grievance against her husband, fail to pour it out to her mother? Would Fanny feel enjoined against telling it to her brother Horace and to her brother-in-law Joseph Barnes, one of the three trustees of the Barnes estate? Would she even withhold it from those inquisitive dowagers with whom she went about in London? Of course she wouldn’t, and the story would be all over town in a few days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The American heiress and her prince consort were conspicuous people; the eyes of gossip were watching them day and night and the tongues of gossip were busy with them, not merely over teacups and telephone, but by the medium of high-speed rotary presses. Let Irma speak a cross word to her husband at the breakfast table and the footman would whisper it to Irma’s maid, and she would pass it on to the maid of the Dowager Lady Wickthorpe at the castle, who in turn would tell it to her best friend in London and it would appear in the "), _c('i', [_vm._v("Tatler")]), _vm._v(" before the end of the week. Perhaps not with the names, but so indicated that all the world would know who was meant. “A popular American lady of many millions whose husband amuses himself as an art expert is being made unhappy because he persists in consorting with the Pinks and making leftish remarks in the most exclusive drawing-rooms. Just now it is said that he is distributing the commissions on his picture sales to those "), _c('i', [_vm._v("‘Genossen’")]), _vm._v(" who are secretly opposing the German Fuhrer. Friends of the Nazi regime in London—and there are many of them, highly placed—are reported making sharply pointed remarks on the subject.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No, that wouldn’t do; either Lanny had to keep the secret from Irma or else give up his project altogether. But did he have a right to give it up? Did he owe no debt to those who were sacrificing everything for the cause he professed to believe in? Is a man’s only obligation to his wife? Can it even be said that a man’s "), _c('i', [_vm._v("first")]), _vm._v(" obligation is to his wife rather than to what he believes is the cause of truth and justice? Does a marriage ceremony give a woman the right to take charge of a man’s thinking and tell him what is true and what is false? Has a woman the right to try to do that, no matter how rich she is or how sure of her opinion?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whatever her rights may be, it is certain that she has the power to make him uncomfortable if he persists in making her uncomfortable. Lanny wasn’t the first man to have made that discovery—the telephones and rotary presses of ancient Athens had spread the report that the left-wing philosopher Socrates was in hot water all the time, and there were even rumors concerning the head of the state, the august and ultra-fashionable Pericles. As for the grandson of Budd’s, who was neither philosopher nor statesman, but only a playboy trying his best to grow up, he didn’t want to hurt anybody in the world and was truly thinking about the happiness of his wife when he argued that he wasn’t going to get into any trouble and that it was really a kindness to keep her from knowing things which would cause her so much needless anxiety.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was so scrupulous that he took the trouble to make sure that every statement he made to her should be the exact literal truth. It was true that Germany was an excellent hunting-ground for old masters at the present time. The aristocracy was impoverished, and so were many kinds of business men; taxes were rising, and the only persons who were prospering were those who controlled the raw materials and the plants needed for the making of war goods. Americans, on the other hand, were having a New Deal. Robbie Budd and other soreheads said it was “inflation,” and maybe they were right, but anyhow it was paying dividends to some groups, and a few of them had learned to think of rare and famous paintings as a safer form of investment than even gold or government bonds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zoltan Kertezsi, Lanny’s friend and associate who had initiated him into this distinguished business, happened to be in Paris. Knowing him well, Lanny had figured how to get exactly what he wanted from him. He sent a wire: “You may recall that I mentioned having learned of a delicate small Hubert van Eyck in Germany I believe same might be purchased but there are social reasons why I hesitate to make the approach if I had a wire from you inquiring for such a picture it would facilitate matters will divide commission.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That would sound perfectly natural to Zoltan, who possessed a battery of harmless devices for making contacts with broken-down Erlauchten and Durchlauchten and causing them to think they were performing a cultural service by permitting their art treasures to be added to some famous American collection at a high price. Zoltan had remarked that such people must be handled as if they were made of wet tissue paper; so, before the sun had set, Lanny received a reply from Paris: “I have possible market for small Hubert van Eyck and recall that you once mentioned having seen such a picture in Germany would it be possible for you to enable me to see a good photograph of it and possibly get a price?”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("This telegram the schemer took to his wife, who was, as he expected, much upset. “Why, Lanny! You said that nothing would ever induce you to set foot in Germany again!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, but I’ve been thinking it over. It appears that Hitler is going to stay in power for a long time, and whether I go in or stay out isn’t going to make any difference. It seems foolish to give up the best market I have—to say nothing of all our friends there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But will the Nazis let you in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If they pay any attention to me at all, they’ll know that I’m bringing them foreign exchange which they need badly. If they don’t want me, they’ll refuse me a visa and that’ll be that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lanny, it terrifies me to think of your walking into that trap again. I know how you feel about conditions there and what you’ll be doing and saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had foreseen this and given careful study to his reply. “If I go there on a business trip, I’m certainly not going to say anything to offend my customers, and I certainly don’t want any unfavorable publicity. Also, if I have you with me, I’ll be under obligation not to do anything to spoil your pleasure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why don’t you tell Zoltan where the picture is and let him attend to it himself? You surely don’t need the money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I doubt if Zoltan could handle this deal. It’s a matter of some delicacy—the picture belongs to an aunt of Stubendorf, and you know how it is with the old nobility, especially the females. She has met me, but probably doesn’t remember my name, and I’ll have to get Seine Hochgeboren to introduce me all over again. We could run out and see Kurt, if you wouldn’t mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lanny, it makes cold chills run all over me! Would you still expect to make Kurt think you’re a Nazi sympathizer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiled. “Kurt and I were friends long before the Nazis were invented, and he won’t mind if I tell him I’ve lost my interest in politics. He’ll think that’s natural enough, now that the Robin family is out of Germany. Remember, I presented Kurt with a whole library of four-hand piano compositions—enough to keep us busy for a full week if we try them all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Making playful remarks and evading like a lively young eel, Lanny managed to get through this difficult conversation. Irma was so concerned to have him do what she called “behaving himself” that she grasped at every straw of hope. More than three months had passed since he had come out of Naziland, and during that time he hadn’t done anything indicative of madness. It had been his family duty to attend Freddi’s funeral, but he hasn’t revealed any deep emotion over it, and now it was possible for Irma to think that, having got his near-relatives safe, he might consider his duty done and give his wife a chance to enjoy the happiness which was her birthright.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also, he was proposing a trip; and it was a part of Irma’s upbringing, it was the psychology of everybody in the world she knew—they were always ready to take a trip. They had the newest and sportiest cars, and kept them supplied with gasoline and oil, water and air, each in its proper place; they had fancy leather bags, and valets and maids to pack them at an hour’s notice. At home they would say: “Let’s run down to Miami and drop in on Winnie,” or: “Let’s drive out to California and see how Bertie’s getting along with his new wife.” Over here it would be Biarritz or Florence, Salzburg or St. Moritz—it didn’t matter so long as it was some place to go. If you didn’t have much to do when you got there, you could always move on to some other place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now it was Berlin. The time of the year was pleasant; a bit chilly, but bracing, and Irma had lovely furs. They would take the night ferry to the Hook of Holland, and from there a one-day drive. They would visit Stubendorf in Upper Silesia and be guests at the Schloss, which seemed romantic to them both. In Berlin there was the Salon, and the concerts, and a social season getting under way. Yes, it was possible to think of many agreeable things to see and do. Irma said, as usual: “Let’s go”; but then, frowning, she added: “Listen to me, Lanny. I mean it—if you do anything to make me miserable the way you did, I’ll never forgive you as long as I live!”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("They waited only to see Robbie, who was due in London. He arrived, outwardly calm, inwardly exultant over his successes. Zaharoff had agreed to take a million dollars’ worth of Budd-Erling shares and had given Robbie permission to mention this to several of his former English associates. Denis de Bruyne had taken three million francs’ worth and was getting up a syndicate of his friends. Also Emily Chattersworth was coming in; and now Robbie, at request, sat down with Irma and laid the proposal before her. She said that she owned as much to the Budd family as any old Greek spider or wolf or devil; she wrote to her uncle Joseph, instructing him to descend into that vault where her treasures were stored. It was far beneath a Wall Street bank building, protected by layers of steel and concrete and having spaces between filled alternately with water and poison gas; a place which met all the biblical requirements, where neither moth nor rust could corrupt nor thieves break through and steal. From the many large bundles of securities Mr. Joseph Barnes was ordered to select half a million dollars’ worth of those which had brought in the smallest returns during the present year; he was to sell them at the market and replace them with Budd-Erling preferred plus common as a bonus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma wasn’t supposed to come into full control of her fortune until she was thirty; but she had taken to expressing her wishes, and so far the trustees had not found it necessary to oppose her. Uncle Joseph couldn’t find any fault with the business reputation of her father-in-law or with her desire to promote the fortunes of her acquired family. Of course, Robbie’s capable ex-mistress saw to it that the news of Irma’s action was spread among her fashionable friends, and Margy, Dowager Lady Eversham-Watson, and Sophie, former Baroness de la Tourette, and all the other ladies with large incomes and still larger appetites were eager to hear about this opportunity of enrichment. “Son,” exclaimed the promoter, “we’ve got the world by the tail!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was surprised to learn that Lanny was going into Germany again, but he didn’t say much about it, because he was wrapped up in his own affairs and never too curious about other people’s. He took it as natural that his son should have decided not to cut off his own nose to spite his face; it wouldn’t do Hitler any harm or Lanny any good. Robbie took the projected trip as a sign of returning sanity and so expressed himself to the young wife, thus confirming what she was trying so hard to believe. “Encourage him to make all the money he can,” said the father. “Hell manage to find uses for it, and it ought to be at least as much fun as playing the piano.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So Irma’s own father would have told her if he had been alive: Missing him greatly, she was moved to take Lanny’s father as a substitute. She told some of her troubles, not in a complaining way, but as one asking for guidance, and Robbie, who had had the same troubles with a too trusting idealist, helped her to understand his foibles. “We all think we’re going to change the world when we’re young,” he explained. “When we get older we realize what a tough proposition it is, and in the end we have our hands full taking care of ourselves and those for whom we are responsible. Lanny’s pink measles are lasting longer than most cases; but be patient with him—he has to cure himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know,” responded Irma. “People won’t let you tell them things. Maybe I’m that way, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Remember this,” added the shrewd man of affairs. “Lanny doesn’t make so much money selling pictures, but it’s an intellectual and artistic occupation and brings you into contact with interesting people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know that, Robbie. Don’t think I’m regretting my marriage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You understand how I feel about it. I’ve always left Lanny free to follow his own path, but I haven’t given up hope that he may come to take an interest in my affairs. I thought I was training him for that. Now, here’s a new opportunity—if he could be brought to see it and come in with me, I could push him right to the top in a year or two. You know what a quick mind he has.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, indeed!” assented the wife. “And I’d be glad if it could be managed. But it would never do for me to suggest it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bear it in mind and perhaps find a chance to drop a hint. Just think what he could do for us in Germany, if only he could get over his political notions and learn to take business as business. You know what connections he has; and you could help him, as Beauty has helped me so many times.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma shook her head. “I’m afraid it’s no go, Robbie. Lanny hates the Nazis with a sort of personal hatred.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s been too close to them. If he’d seen the other governments of Europe getting started he’d understand there isn’t much choice among them. They all put their opponents down with brutality, because they’re afraid; but when they’re safe in the saddle, they settle down and you can hardly tell them apart. In a few years the Nazis will all be wearing frock-coats.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t argue with Lanny,” said the young wife, sadly. “He’s read so much more than I have, and he thinks I’m just a dumb cluck.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have a lot more influence than you know, and between us we may get him interested in airplanes.” Robbie said that, and then after a moment added: “Give him time. There are no perfect husbands, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma nodded. There were unspoken thoughts between them. She had been taught the value of her money and understood why Robbie valued her so highly as a wife. But they were both of them well-bred persons, who would act on what they called “common sense” but wouldn’t put it into words.")])])])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h"
  }, [_c('span', [_vm._v("BOOK TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "part-center"
  }, [_c('span', [_vm._v("Some Hidden Thunder")])])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("DES TODES EIGEN")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In Germany the highways are smooth and straight and lined with well-kept trees, many of them fruit-bearing. New roads were being started, and some of these were wonderful—four-track model "), _c('i', [_vm._v("Autobahnen")]), _vm._v(" with all the crossroads over-or underpassed. Lanny said these were military roads, intended for the invasion of the bordering countries; he added that they were built with American money, borrowed by the German Republic and by its member states and cities. Lanny rarely lost an opportunity to make some disapproving remark about what was going on in Hitlerland, and Irma had learned not to comment, because if she did an argument might start and Lanny would overwhelm her with facts and figures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What she saw in this country was clean, well-kept streets and houses, and the people in them the same. Everybody appeared well fed, and working from dawn to sunset; a peaceful and industrious land if ever there was one. Adolf Hitler was carrying out literally his promise to provide work for everybody; factory chimneys were smoking day and night—but don’t point this out, because if you do, Lanny will say that it’s preparation for war, and anybody can do that if he means to make war, but what is the good of it if he doesn’t? And all these Stormtroopers marching and singing war-songs! Irma doesn’t know the words of the songs, and it is enough for her that the men are young and good-looking, well dressed and happy, singing in tune and marching in step. But don’t say that, either!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma has lived all her life in free countries, and finds it hard to realize that there are any other sort. She has never witnessed an act of violence in her twenty-six years on earth, and she has difficulty in making real to herself the idea that such acts are frequently committed. To be sure, she knows that the Robins were plundered of their possessions, and she cannot go so far as to think that Lanny was having a nightmare when he saw old Solomon Hellstein being beaten with whips in one of the dungeons of the Gestapo. But Irma finds reasons if not excuses for these events. She knows that Johannes Robin, in spite of his being their friend and very agreeable company, was an unconscionable "), _c('i', [_vm._v("Schieber")]), _vm._v(", a speculator in the currency of the German Republic. That seems to her a different thing from getting rich by building up public utility corporations after the fashion of the late J. Paramount Barnes. If you should mention such matters as stock-watering and the pyramiding of holding-companies, Irma would stare at you blankly, perhaps thinking you some sort of anarchist; for she has been taught that these are the processes out of which the prosperity and greatness of America were built.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also, the misfortunes of the Robins were brought on them by those two sons. Hansi, the out-and-out Red, asked for the worst of trouble and escaped it only because Lanny and his wife managed to lure him out of Germany in time. The Communists had had no mercy on their class enemies, and why shouldn’t Hitler dose them with their own medicine? As for Freddi, who called himself a Socialist, Irma was willing to admit that he had been harmless, like her own husband; but she considered them both dupes of shrewder men, who were using them for a while and would throw them aside when the time for action came. If in the confusion of a great social change some of the innocent had got mixed up with the guilty, that was a tragic accident, and what Irma had got from it was an intense desire to keep her husband from putting his head into a bear-trap.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("It was evening when they arrived in Berlin. They had telegraphed the Adlon for reservations, and they found newspaper reporters waiting; they were prominent people, well known in the city, and their coming would be made much of by the Nazi-controlled press. The “blood purge” of last summer had pretty well killed the tourist traffic, so important to the German economy, and the "), _c('i', [_vm._v("Regierung")]), _vm._v(" wished to establish the idea that all this was ancient history, an unfortunate necessity at the time, but now to be forgotten by everybody both at home and abroad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two shining American "), _c('i', [_vm._v("Zelebritaten")]), _vm._v(" would be interviewed amid the popping of flashlight bulbs and would have their opinions on art questions taken seriously. They had come with commissions to buy old masters and prepared to pay precious American dollars. They were expecting to run out to visit their old friend General Graf Stubendorf, also Herr Budd’s boyhood friend, Kurt Meissner, the composer. They would be interested to visit the autumn Salon, conducted under the personal supervision of the Fuhrer in order to exclude degenerate modernist stuff. Herr Budd agreed with the Fuhrer on this subject—he was the stepson of a French painter, a sound representational artist, and had had the honor of showing to the Fuhrer personally one of the best-known Detaze portraits. All of this had been published before and was in the "), _c('i', [_vm._v("Archiv")]), _vm._v(" of the newspapers, so the reporters had it prepared in advance. When, in answer to a question, Herr Budd stated that he was a non-political person, that pleased everyone, for the Nazis wanted all the world to be non-political except themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny telephoned to Stubendorf and made certain that both their friends were at the estate. Seine Hochgeboren renewed his invitation, and next morning they set out for Upper Silesia over another of the fast highways. It is a coal-mining region, and great numbers of factory chimneys were pouring smoke into the chilly air of approaching winter. The district of Stubendorf had been a part of Poland ever since the Versailles treaty, and if you asked why all the coal was burning and factory wheels turning in this vicinity, any German-speaking person would tell you that no German wanted war, but every German was determined to get back into the Fatherland. The arming and drilling—one of the commonest sights of the countryside—was for the purpose of making clear the German will to the whole non-German world. If they wanted war, they could have it; if they wanted peace, let them get out of German lands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was an old problem for Lanny Budd; he had listened to it being discussed at the Paris Peace Conference, day and night, from every possible point of view. He had seen with his eyes the elder statesmen known as the “Big Three”—Wilson, Lloyd George, and Clemenceau—crawling round on their hands and knees over a huge map spread on the floor, trying with colored pencils to mark out some solution of an insoluble problem. The various sorts of people were all mixed together, and if you tried to work on the principle of self-determination, you would have districts and even villages chopped up. In Stubendorf itself was a large Polish population, but they were mostly poor peasants, whereas the well-to-do and educated people were German; the latter were in position to make most of the noise and did so. They looked upon the Poles as a subhuman race, born to be ruled by the "), _c('i', [_vm._v("Herrenvolk")]), _vm._v(", and now this "), _c('i', [_vm._v("Volk")]), _vm._v(" had a Fuhrer who was going to bring it to pass. The unanimity with which he was supported made a great impression upon Irma; but she mustn’t mention the fact, because Lanny would say: “It’s because all the dissenters have been murdered or put into concentration camps; and what sort of unanimity is that?”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("They were welcomed to the modernized and comfortable Schloss, which didn’t seem so grand to Lanny now as it had at the age of fourteen. Seine Hochgeboren was an old-fashioned Prussian nobleman, very serious and formal, but intelligent within the limits of his training. He considered that he was doing something quite modernistic in receiving two fashionable but untitled Americans into his home. He had done so after he had met them in Berlin and carefully made sure that their money was real; also that they met influential persons, and could be discreetly pumped as to the attitude of Britain, France, and America to events in the Fatherland. The General Graf, a high-ranking officer of the Reichswehr, accepted the new government as it was his duty to do, and if he had any reservations in his mind no foreigner would be permitted a glimpse of them. He had no apologies to make, but took the dignified position that what Germans did became right as soon as they had done it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma was impressed by this German aristocracy, almost as much as by the English. They were age-tested and from this they derived assurance; compared with them she felt herself a "), _c('i', [_vm._v("parvenue")]), _vm._v("—though of course she wouldn’t admit it, even to herself. However, she watched what they did and said, and made mental notes. She had learned that when she didn’t know what to say, she could keep quiet, and this suited well her placid disposition. Afterward she could ask Lanny about the subject, finding it convenient that her husband knew so many things. His statements could be depended upon when they had to do with music, poetry, painting, or with history—everything except politics and economics. The fact that he was bored by the aristocracy and made fun of them was perhaps another way of being aristocratic; sometimes it impressed his wife and sometimes it annoyed her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a proper period of sociability Lanny revealed the purpose of his journey. He showed the telegram from Zoltan and asked if he might be permitted to inspect the Hubert van Eyck which was in the possession of the Baroninwitwe von Wiesenschmetterling. Seine Hochgeboren froze up and said that he doubted very much whether his elderly relative would consider parting with this family treasure; Lanny, who had encountered this attitude many times and accepted it as part of the bargaining process, explained suavely the cultural importance of great collections which were being made in America, their effect in bringing sweetness and light to a well-to-do but spiritually backward people. Such was the European tone toward America, and Lanny had learned from Zaharoff that one must belong to that nation in which one is putting over a deal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Baroninwitwe lived in the Neumark, not far off their route returning to Berlin. If it had been in well-to-do but spiritually backward America, the General Graf would have called up his aunt and made sure she was at home and told her about the matter. But this was the spiritual but frugal Fatherland, and so the master of the Schloss contented himself with writing a note and giving it to Lanny. However, the American was fairly certain in his own mind that his host would send a telegram or otherwise give warning to the old lady, so that she would demand a high price or perhaps refuse to put a price until she had taken his advice.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Kurt Meissner still lived in the five-room stone cottage which the lord of the castle had set aside for his use. It was the Nazi party which had paid Kurt enough money to build a studio near by—much like the one Beauty Budd had built for him at Bienvenu. Kurt’s gentle blond wife was becoming what the ladies call plump, and had presented him with four children who were perfect models of what the Nazi leaders approved but so rarely exemplified. The eldest was six, a pink-cheeked and solemn-eyed little boy, who already played the piano better than Irma Budd had ever learned to do with the help of the most expensive teachers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kurt was the same long-faced, severe-looking man, prematurely aged by war and suffering. Being slightly older than Lanny, he had always patronized him, and now felt gently sorry for him because of the way he was wasting his life. While Irma practiced her German with the admiring "), _c('i', [_vm._v("Hausfrau")]), _vm._v(", Kurt took Lanny to his studio and played his new piano sonata; Lanny listened attentively, and thought: “It is rather dry. Kurt is now imitating Kurt. That is, when he’s not imitating Bach. The fountain of his inspiration is drying up. That adagio is almost a plagiarism of Beethoven. Those stormy passages are forced.” And so on. It makes a great difference in what mood and with what predisposition one approaches music; this same sonata had just been rendered by its composer to an audience in Breslau, which considered him the new Germany’s most promising composer and had listened to the work with rapt attention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny knew what he was expected to say, and said it. He knew how to deal with Kurt, because for fifteen years or so he had considered him a great man and his spiritual mentor. He knew all the phrases of admiration and devotion, and he must use them now, and tell himself that he was doing it for Kurt’s own good. Some day this Nazi nightmare would pass, and a noble soul would awaken and rub his eyes and be glad that Lanny had stood by those ideals to which they had pledged themselves in boyhood—of love and service to all mankind and not merely to blond Aryans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By tacit agreement they left the subject of politics alone, and did not once mention a family of Jewish "), _c('i', [_vm._v("Schieber")]), _vm._v(". Kurt was free to assume that since Freddi was buried and the rest were free, that unhappy page might be turned and forgotten. When Irma was alone with Kurt she took the occasion to tell him that Lanny was conducting himself much more sensibly now; Kurt was glad to hear this, and said so. Kind and fundamentally good, but weak—this was the composer’s judgment of his boyhood playmate, and Lanny let it stand that way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Living a double life had been Rick’s phrase; and here it was. Lanny was a spy in Hitlerland, a secret agent in the enemy’s country. It is supposed to be romantic and exciting, but that is in the imagination of persons who have never experienced it. There may be some who like to lie and cheat and find pleasure in outwitting other persons, but Lanny was not among them and it hurt him every time he said something to Kurt which did not represent his true beliefs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had to remind himself that Kurt had done this himself, as a German agent in Paris right after the armistice. Would it occur to him now that Lanny might be returning the compliment? If so, the composer would probably not reveal it; he would dig deeper under Lanny’s position, as entrenched troops do in wartime, mining and countermining. Lanny watched for signs of this; for he feared that Kurt was deeper than he and would probably outwit him if it came to a real showdown. They would be two antagonists in darkness, groping for each other’s throat; yet they would still be friends, using the language of love and, strangely enough, feeling it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, Lanny decided that no matter how hard he might be fighting Kurt, he would still be yearning after him, with true old-fashioned German "), _c('i', [_vm._v("Schwarmerei")]), _vm._v(". All the time they were playing four-hand piano compositions, Lanny knew this with every fiber of his being: while they prayed in solemn ecstasy with Bach, while they danced in gilded ballrooms with Mozart, while they labored in spiritual anguish with Beethoven. Brothers have fought against brothers, and fathers against sons, in all civil wars; and here was a new kind of war, spreading rapidly all over the earth: National Socialism against true Socialism, racialism against the brotherhood of humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The widow of the Baron von Wiesenschmetterling lived in a fine old mansion entirely surrounded by potato-fields. At present they were bare and dark, but if you had come in midsummer you would have found them green, and would have seen a hundred or so Polish women, clad in what appeared to be potato-sacks, patiently hoeing the furrows from dawn to dark. They were brought into Eastern Germany by long trainloads, and all Germans agreed that they had been providentially created for two purposes, to produce potatoes and to produce potato-hoers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The mistress of the estate was a white-haired lady with a large bosom covered with black silk and old-fashioned ruching. Over it she had placed her best string of pearls, saying plainly that if you thought she was hard up and was going to sell any of her art treasures, you were vulgar intruders. She looked upon all Americans as dubious characters, and what business had they ever had to come and kill Germans? She held herself stiffly, and did not unbend even after she had read the note from her nephew. She could find no fault with the appearance of this young couple, or with the German speech of the man; the young woman had sense enough to keep her mouth shut, and that helped. The noble widow, "), _c('i', [_vm._v("gnadige Witwe")]), _vm._v(", consented to let them inspect her picture gallery; and only when Lanny told her that she had real treasures and began to explain their qualities to his wife, did she realize that he was an exceptional person. On the field of the arts even the most implacable of enemies can lift their visors and salute each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Hubert van Eyck was only about sixteen inches wide and twenty inches high, but a great deal had been crowded into that limited space. It represented a stained-glass church window, and so was art within art. It was done with extraordinary finess and exactness, so that you forgot it was small and thought you were in church. It portrayed the Blessed Virgin seated upon a throne, clad in a jeweled robe of remarkable splendor, really almost good enough for an archbishop. Above her hovered three cherubim who, presumably because they were young and active, didn’t need any robes. Golden sunlight shone upon the varicolored scene, and appeared to be as bright as when it had been painted more than five hundred years ago. It was marvelously contrived to look like glass and at the same time to look real.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny never tried to do business in a cheap way, to depreciate what he was buying; no, indeed, he was an aristocrat among experts, and dealt only in what he could praise. He delivered his “spiel”—oddly enough, the Americans use that German word, while the Germans call it a “"), _c('i', [_vm._v("Rolle")]), _vm._v(".” He was trying to help his country to acquire worthy art works which might some day stimulate American painting. His clients were able to pay for the best; but naturally, there being many old masters, Lanny would recommend those which offered the most for the price. He explained that it was his practice never to make an offer for a painting; he invited the owner to state the price at which he or she was willing to sell, and he would cable that price to his client, and if the offer was accepted he would come in a day or two and pay the sum in cash.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young expert examined several other paintings which the Baroninwitwe didn’t say she would be unwilling to sell; he gave her a list of these, and would be pleased if she would quote him a price on each. He wasn’t wasting his time or hers, for while he examined them he was busily thinking of persons who might purchase this and that. He left the severe old lady his addresses in Berlin and England; and when they had left the mansion and were driving past the potato-fields, Irma said: “Do you think she wishes to sell?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He answered: “It depends upon the state of her mortgages.” He explained that most of these estates had been loaded down with debts in wartime; many of them had come under the shadow of the "), _c('i', [_vm._v("Osthilfe")]), _vm._v(" scandal, which had had so much to do with the Nazis’ getting into power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma had heard talk of this affair, but had paid no attention to it, so Lanny told how the government of the Republic had paid vast sums to the great Prussian landlords to help them in reconstruction, and most of the money had been wasted. Hindenburg’s son had been involved, and that had helped to break down the old President and force him into a deal with the “Bohemian corporal,” as he had been accustomed to call the founder and Fuhrer of National Socialism. The question whether this van Eyck would ever be viewed in the United States might depend upon whether the aunt of Seine Hochgeboren had been able to collect her share of this respectable German graft.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("They returned to Berlin, arriving late in the evening. Next morning Lanny attended to his mail, and Irma telephoned some of her fashionable friends and was invited to lunch with the Furstin Donnerstein. Lanny was invited, too, but he said that the ladies were much happier when they were able to gossip alone, so he would go and have a preliminary look at the Salon. It so happened that this was Tuesday, the sixth of November, the day on which, exactly at noon, he was supposed to be standing on a certain street corner in a working-class district of this "), _c('i', [_vm._v("Hauptstadt")]), _vm._v(" of Naziland. It happened also to be Election Day in the land of Lanny’s forefathers, and Robbie Budd was predicting that the American people would come to their senses and elect a Congress opposed to the lunacies of the New Deal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If a handsome young "), _c('i', [_vm._v("Auslander")]), _vm._v(", wearing a neatly trimmed little brown mustache and a fall overcoat to match, goes driving in a sport-car in a part of Berlin given up to six-story tenements inhabited by the poor, he will attract some attention, but not so much as you might suppose. The poor do not go strolling on work days, and they have their problems to think about; at noon they are hurrying to get something to eat and do not linger outdoors on a raw gusty day. If a young "), _c('i', [_vm._v("Herrschaft")]), _vm._v(", as such a stranger is called, parks his car and gets out and strolls, they will glance at him with a moment’s curiosity, but no more; some "), _c('i', [_vm._v("Strassenjunge")]), _vm._v(" may follow him and beg for a pfennig, but that is all. If he stops on the corner and raises his hat to a slender and frail-looking young woman wearing a worn and drab coat and a felt hat with no ornaments, that will cause no sensation, for the poor people of all city streets have learned the facts of life and accept them. If they see the woman acknowledge the greeting and start to walk along with the man, the "), _c('i', [_vm._v("Polizei")]), _vm._v(" will not interfere, and everyone else will make allowances, knowing that life has been terribly hard for the women of Germany for a full two decades.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, this wasn’t the customary sex encounter, but something which the Geheime Staats-Polizei might have paid a small fortune to know about. Lanny Budd was saying: “So it’s you, Trudi!” And Trudi Schultz, staring straight before her, was murmuring: “You may trust Monck. I know him well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you really sure?” Lanny persisted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would trust him as much as any person I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I ought to be told a little about him, Trudi—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Frau Mueller,” she corrected, with a swift glance behind them. “Tell me where I can communicate with you through the next weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I expect to be in England until just before Christmas and then to return to my home in France. My mail will always be forwarded.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you reasonably sure of its not being opened?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As much as anyone can be. No one in my home tampers with it.” Trudi had met Irma and knew her attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you with all my heart, Herr Schmidt. It is very important to us all. And now I ought to go. We are too conspicuous, walking together.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want very much to have a talk with you, Frau Mueller. I have come a long way for it. Can’t you let me drive you for a while?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is a dreadful risk to take!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I cannot see how. You go on walking down this street and I will get my car, and after I make sure I’m not being followed, I’ll come up behind you and stop. You step in, and we’ll be gone out of sight before anybody has time to give a thought to us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will attract attention in your car; I’m not dressed for anything so elegant.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They will think I am taking home a new cook.” Lanny could grin even at such a tense moment; he still hadn’t suffered enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They will think something less polite,” replied the young woman. “But—all right, I will go on walking until you come.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("They drove, and no one paid any attention to them. Soon they were out in the country, where there was no possibility of being overheard, so they could drop, the feeble disguise of “Mueller” and “Schmidt.” Trudi could look at him without fear, and he could take a glance at her now and then when driving permitted. As an art lover he had said that her features represented a triumph of some idealistic sculptor; he had never seen a woman’s face more expressive of high thinking and fine feeling. When he had first met her four years ago, a student of drawing and a Socialist devotee, he had been struck by her look of alertness, of concentration upon whatever new idea was presented to her; by the way she held her head—high-spirited was the term he had chosen to describe her. She made him think of a pure-bred racehorse; watching her at work and seeing her intense concentration and delight in achievement, he had thought: “Here is a real talent, and I must help it to recognition.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In those far-off happy days it had been possible to believe in ideas, and to discuss them freely, and to feel sure that in the long run the soundest would prevail. In those days before Hitler, Trudi Schultz had had color in her cheeks, color that came and went with the excitement of achieving a good portrait or with the discussion of Socialism versus Communism, democracy versus dictatorship. Ludi and Trudi—Lanny had been amused by the musical combination—had argued as Lanny himself had so often done, that the reason there were so many splits and so little real co-operation among the left-wing groups was not so much conflict of ideas as of personalities; the lack of tolerance and open-mindedness, of the old-fashioned virtues of unselfishness and love. The reason one advocate could see no good in the other’s point of view was that both were jealous and greedy for power; the movement was racked and rent because men thought about themselves and not about the masses they professed to serve. Listening to this ardent young couple at a gathering of the intelligentsia in the school which he and Freddi Robin were helping, Lanny had thought: “This is the true German spirit; which Beethoven and Schiller dreamed of spreading over the world. "), _c('i', [_vm._v("Alle Menschen werden Bruder!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now Ludi was gone, and his wife was a fear-ridden, grief-tormented soul, who had not had a moment of real peace or happiness for a year and a half. She twisted her hands together as she talked; her finely chiseled nostrils quivered, and now and then tears would start in her eyes and run down her cheeks untouched. These cheeks were colorless, and Lanny could be sure that her work, whatever it was, left her no time and perhaps no money to eat properly. He would have liked to suggest taking her somewhere for a meal, but he knew this would be an intrusion and an error of taste.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She wanted to bring him to the same state of mind as herself, to make it impossible for him also to enjoy peace or happiness. Since she was taking the risk of being seen with him on streets and highways, she would put the occasion to use by impressing upon his mind the tragic need of help under which she and her comrades labored. She would persuade him to lend his powerful aid in saving Ludi if he was still alive, or if he had perished, in saving his comrades and his cause.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny had never had a chance to tell any of these German friends what he himself had seen and experienced. Now he listened to the familiar tale of cruelties beyond the imagining of decent human beings. Trudi told him about the fate of this person and that whom he had met at the school receptions. Pale and shivering with horror, she declared:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They seize men and women, old and young—they respect nobody. They carry them off to the woods outside the city and beat them to death and bury them where they lie or leave them for others to find and bury. They drag them into dungeons which they have in the cellars of police stations and party headquarters, where they torture people to make them confess and name their friends and comrades. Things happen, so hideous that you cannot bring yourself to talk about them; nothing worse was ever done by the Spanish Inquisition, or by Chinese torturers, or by savage Indians in America.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have heard a lot about it,” responded Lanny. He decided not to say more at present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Germany has become a land of spies and betrayers; you never know whom you can trust. They teach the children in the schools to spy upon their parents and denounce them; they torture perfectly innocent people because of something some relative has done. No servant can be trusted, no employee, hardly a friend. It is impossible for half a dozen persons to meet, even in a private home; one dares not express an opinion or even ask for news. You never know at what moment of the day or night will come a banging on the door, and it’s a band of Stormtroopers, or the Gestapo with one of their vans to carry you away. You live in the shadow of this awful thing and can never get it out of your mind. Because I am a woman, and because they have so many sadists and degenerates among them, I carry a vial of poison, ready to swallow it before they can lay hands upon me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listen, Trudi,” he said. “Why don’t you let me help you to get out of this country?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And desert my husband? Oh, Lanny, you must know I couldn’t do that!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hate to say it, but what is the chance of his being alive and not having been able to send word to you for a full year and a half? Surely some of his fellow-prisoners must have been released!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t tell anything about it, Lanny. Everything happens in the dark. They have people in their solitary dungeons whose names are not known. And even if I knew that Ludi was dead, I would have to stay for the sake of the others. How can I rest while my dearest friends are undergoing these torments and in such dreadful need of help?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But can’t you perhaps help them better from the outside?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have watched the exiles, from Russia and other countries; they are impotent people, cut off from their roots. They lose all sense of reality. They become strangers to their own people. They live in a little false world all their own.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you are an artist. You could put what you know and what you feel into your work. You could be another Kathe Kollwitz.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Some people have to stay here and keep the spark of freedom alive. There are millions of Germans who need us—all the old party comrades, and those who voted for us, the workers and the intellectuals. Most of the time we do not know who they are, but they are still alive and surely have not forgotten all that we taught them in the old days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But how can you reach them, Trudi?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is something you ought not ask. I am under a solemn oath not to give a hint of our methods without the consent of two other comrades; and if I ask their consent and reveal you to them, there is one more chance of a leak. I don’t mean that you might talk about us, but somebody else might and cast the burden upon you; we might be betrayed, and someone might decide that you were to blame. You must realize how it is—we may have a Gestapo agent working among us right now, and so your name would become known to them. It is ever so much better as it is, with no one knowing about you but Genosse Monck and myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right,” said Lanny. “You know that I trust your word.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I give you my assurance that we have a way of reaching the people, and telling them the truth about what is going on in Germany and in the outside world. We have told them the truth about the Reichstag fire, and about the number of those murdered last June and July. The Nazis admit less than one hundred, but we have listed more than twelve hundred and our lists have been circulated. The Nazis know that, and of course they are hunting us day and night; so far I do not think they have any clue. Even if they get some group it will be small; we have built ourselves like the worm, which can be cut into sections and each will go on growing by itself. We are bound to succeed in the end, because a great people will not let themselves be dragged down into such degradation.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny Budd had done some reading in the literature of martyrdom. He knew that liberty has nowhere been won without blood sacrifice, and now he was learning that it cannot be kept without further payments. Through his mind would come at times a procession of verses which he had read and learned: his Shakespeare, his Milton, his Byron; also "), _c('i', [_vm._v("Egmont, Wilhelm Tell, Die Rauber")]), _vm._v("—there had been lovers of freedom in Germany, too. Kurt Meissner had taught his American friend some verses about the Tirolese innkeeper Andreas Hofer, who had taken Innsbruck by storm from the forces of Napoleon; when the students came in a festival and wanted to sing his hero deeds, he made them a speech, one line of which Lanny had never forgotten: “"), _c('i', [_vm._v("Wir sind all des Todes Eigen")]), _vm._v("”—we are all death’s own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A grown-up American playboy realized that this was an important moment in his personal life. Something inside him was humbled and shamed, and he felt that he wanted to live the second half of his life to better purpose than the first. He said: “Just what is it you wish of me, Trudi?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are many ways you can help us abroad. We may not always be as successful as we are now, and we may need such things as radio tubes or a printing-press or paper, things it would be too dangerous to obtain here at home. For the moment, our great need is money. Monck has told me what you said about your own position—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never mind what I said, Trudi,” broke in the grandson of Budd’s, in one of those emotional moments to which idealists are liable. “I’ll get you some money now and then. I’ll take it as my job.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So here he was, pledging himself again; forgetting that he was a married man, that other people had claims upon him, a vested interest in him; taking upon himself that task which Irma considered the height of lunacy, the overthrowing of the National Socialist government of Germany. It would become his job to earn the money, and a handful of social outlaws hiding in tenement rooms were going to print leaflets or something, and perhaps poke them under doors or leave them on park benches, and by this means overcome the power of the Geheime Staats-Polizei, of the Sturmabteilung and the Schutzstaffel and the Wehrmacht, with their enormous armaments, their tens of thousands of highly trained experts, their incessant watchfulness and skill in torturing and killing!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I ought to have some way of reaching you, Trudi,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have racked my brains to think of a safe way. I am a poor workingwoman, living in a tenement, and I would not dare receive letters from abroad. Nor do I want to trust anybody else with the secret about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can Monck come to England or France now and then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He can arrange it, but it is difficult and risky. How often are you in Germany?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I never intended to come at all, until I got your message. However, I can arrange to come occasionally.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That would be expensive for you, Lanny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I travel on my wife’s money,” he told her, with a smile. “She wishes it that way, and I have long since abandoned my scruples in the matter. I tell myself that hers is capitalist money—she doesn’t have to earn it and it is her pleasure to spend it. Most of what I earn I will bring to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Won’t your wife wonder what you are doing with so much?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Happily, the idea will not occur to her. It is the mark of elegance among the rich that you do not bother your head with money. If the whim takes me, I buy a picture and put it in my storeroom, and I may not remember to mention it to my wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It sounds quite fabulous. People of our sort cannot imagine such a way of life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have had opportunity to observe the effects of inherited wealth, and for the average young person it is a sentence to futility and boredom. It cuts the mainspring of activity; the person no longer has to do anything, and so he doesn’t, and if he tries, he fails nine times out of ten. You at this moment are providing the strongest incentive to labor that I have ever had in my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She couldn’t keep from smiling. “Lanny, you are an angel! If I believed in such, I would be certain that you had been sent from heaven.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am planning just now to purchase three of these celestial creatures. They are cherubim, which I believe is a high order in the hierarchy; but they have no overcoats and I cannot imagine them in the climate of Berlin in the month of November.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The angel from overseas was moved to tell his friend about his visit to the Baroninwitwe, and by this means succeeded in amusing her for several minutes. He mentioned that the price of the picture could hardly be less than a hundred thousand marks, and so, if he sold it, he would have several thousand for the comrades. The question was, how was he to get it to her?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trudi could think of no safe way for them to meet except as they had just done. She gave him the name of a street intersection close to her own home, so that she could without great trouble arrange to pass there at noon every day. “I will arrange to do my marketing at that time,” she told him. “The only thing that will keep me away is being ill, and in that case I will write you that I cannot send any drawings at present.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Said he: “It would be inconvenient if you were ill on the day when I had a large sum for you. Therefore, you can do a service to the cause by keeping well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will do my best, Lanny—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I impose a condition as part of our bargain: that you pledge yourself to use part of the money to purchase one liter of milk per day and drink every drop of it yourself. You show that you need it, and this is to be considered doctor’s orders.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right,” she said, gently; then, after a pause: “When you see me on the street, do not speak to me, but watch in what direction I start to walk; then you may get your car and follow me, and after a couple of blocks you may stop for me. I will walk on the right side of the street and will be carrying a package. If I carry it in my left arm, so that you can see it, you will know that it is all right to stop; but if I carry it in my right arm, it means there is something wrong, and you will drive on around the block, and not stop until the package is held in the crook of my left arm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Sehr klug!")]), _vm._v("” he said, amused. “And now one thing more: suppose I am able to get you quite large sums of money, could you put them to use?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean by large?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A hundred thousand marks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Herrgott!")]), _vm._v("” she exclaimed. “I never thought of anything like that!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It may not be easy to spend large sums without attracting attention. Do you handle them yourself, or do you pass them on to others?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mostly I pass them on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And won’t these others be curious as to where you get them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Naturally; but they know they are not free to ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They doubtless remember that you know me. Won’t they think of me as the possible source?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, for they have read about you in the Nazi press. They’d be more apt to think of the Robin family.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much money can you handle effectively at present?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hadn’t expected to meet that question. Two or three thousand marks at a time, I should think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And how often?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We could spend that every month, if we had it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right,” he said; “here is some to start things going.” He took from his pocket a package containing a couple of thousand marks and slipped it into her hand. “Don’t make the mistake of moving too fast,” he warned. “Spending money is a conspicuous thing, and the larger the sum, the greater will be your risk. I’d hate to be the cause of your having to drink the contents of that vial.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("During the year and a half that Lanny Budd had been living a double life he had been troubled by the thought of what his friends in Berlin must be thinking about him. There was no help for it—except for this one comrade, and he wanted to make certain about her. “Listen, Trudi,” he said. “It may be a long time before I see you again, and there are some things I want you to have clear in your mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took her back some thirteen years, to the early days of the Nazi movement, when Kurt Meissner had introduced him to a son of the head forester of Stubendorf, a young enthusiast who had loaded him with literature of the movement, and later on had taken him to call on Hitler. He had taken him a second time a year ago; and Trudi said she had read about that visit in the papers; all the comrades knew of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course they assume that I’m a renegade,” he remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They don’t know what to think,” she answered. “They know that you saved Freddi Robin.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let them stay in uncertainty. You know how I make my money, and to do that I have to meet persons in power. I took one of the Detaze paintings to Hitler in Munich, and that fact was worth a small fortune to me in sales and in the opportunity to go where I pleased and to meet the right people in Germany. That is the world we live in. All I want to be sure is that you understand, and that no matter what I do, you will not doubt my good faith.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I promise that, Lanny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In the course of my efforts to help the Robin family, I achieved the honor of a personal acquaintance with General Goring. He seemed to take a fancy to me—I admired his prowess, and he found pleasure in displaying it. That might be useful some day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It sounds utterly fantastic, Lanny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In every revolution and in every war there have been men playing a double role and dealing with both sides. It isn’t according to my taste, but I am beginning to see possibilities in it. My father is going in for the manufacture of airplanes, and he will be expecting me to be useful to him; in return I may feel justified in making him useful to me. I don’t want to say any more about this, except to be sure that whatever happens, you will not mention your connection with me or your knowledge of my role.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll die before I do it, Lanny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have an idea which may be worth while and about which I would like your advice. You know that the fat General seized the palace of my Jewish friends, and you know the fine paintings which were a part of his loot. It happens that Zoltan Kertezsi and I selected nearly all those paintings, and it would be easy to find a market for them in America; they might bring several million dollars, and there would be a commission of ten per cent. That is one way by which I could get large sums of money for you, and it would amuse me to persuade an old-style Teutonic robber-baron to contribute to his own undoing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Knorke!")]), _vm._v("” exclaimed the woman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There is this drawback, that Goring would be getting nine marks for every one that I got. Thus I might be strengthening the Nazi cause far more than I was hurting it. What if he used the money to buy my father’s airplanes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trudi thought before answering. “He will buy the planes with the money of the German people, never with his own. For himself he is building a grand estate on a peninsula up in the North Sea. He is a greedy hog, and I do not believe he would give a pfennig to the government, but rather take away all that he dares.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then it wouldn’t be a mistake to offer to sell his pictures?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If he wishes to sell them he could do it without your help—isn’t that true?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, no doubt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, then, let him spend what he pleases upon his own glory, and we will use our share to tell the German people what lives their false leaders are living.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“O.K.,” said the American—a phrase which is understood wherever the movies go. “I may have the honor of being invited to that estate, which he is calling Karinhall in honor of his deceased wife. If I succeed in becoming his art adviser, I will appear in the next few days at our rendezvous wearing a feather in my hat!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not too large a feather!” said the anxious woman outlaw.")])])])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("ON TOP OF THE WORLD")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Lanny went dutifully to the Salon, and then, returning to the hotel, reported to his wife that he had found a new painter who impressed him greatly. She for her part was full of news about the doings of important personalities in Berlin, a lot of it scandalous; but repeating it wasn’t regarded as anti-Nazi activity—you did that in whatever world capital you were visiting. Human nature was the same everywhere, only worse the farther you came toward the east; now, somewhat alarmingly, the east appeared to be coming westward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny said: “A bright idea has hit me: all those pictures that Goring got from Johannes, he probably doesn’t care about them and might like to have them sold.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you suppose he would let you?” exclaimed the wife. She realized that this would keep her charge out of mischief for a long while.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It can’t do any harm to offer. I thought I’d call up Furtwaengler.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t mention what you have in mind,” said the cautious wife.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He called the official residence of the Minister-President of Prussia, and found the young staff officer disengaged. He and Lanny always outdid each other in politeness, almost like two Japanese, and now they went to it over the telephone. The Oberleutnant said that he had read of Lanny’s arrival and intended to call him up; Lanny said: “I have got the better of you.” He asked after the officer’s family, and about his health, and that of Seine Exzellenz the Minister-President General—he had a long string of titles, but four were enough for ordinary conversation. Furtwaengler replied: “"), _c('i', [_vm._v("Er sitzt auf der Spitze der Welt")]), _vm._v(",” and added: “I believe that is good American.” Lanny guessed that this was another case of movie influence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you are free this evening why don’t you run over to dinner?” said the subtle intriguer. “Bring your wife, if you think she would enjoy it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma dressed herself in raiment fine but scanty, and Lanny in tails; the staff officer appeared in his black and silver dress uniform with the white skull and crossbones, and his tall and angular country wife in a low-cut gown which revealed her shoulder-bones both front and back. A good "), _c('i', [_vm._v("couturier")]), _vm._v(" would not have let her make these disclosures, but she was the daughter of a cheese-manufacturer from Pomerania and didn’t yet know her way about "), _c('i', [_vm._v("die grosse Welt")]), _vm._v(". In Prussia wives have to pay for their husbands, and then for the most part they stay at home and devote themselves to their three K’s, which in English are three C’s: Cooking, Children, Church.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("In that large and elegant hotel dining-room, with obsequious waiters bowing around them and exposing dishes of steaming-hot foods, Irma presented an expurgated version of the conversation of the Furstin Donnerstein, while Lanny mentioned casually his intimacy with French financiers and revealed himself living next door to an English castle and dropping in informally upon staff members of the Foreign Office. When the four were alone in the drawing-room of the Budd suite, the two ladies sat in one corner and talked about ladies’ affairs, while Lanny expatiated upon the menace of French foreign policy and the untrustworthiness of French political careerists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Oberleutnant in his turn talked about the one and only party and its plans and hopes. A strange thing, to which Lanny could never entirely adjust his mind: the young S.S. man knew that his American host had penetrated to the very heart of the party’s treachery and cruelty, had witnessed soul-shaking sights and lost one of his dearest friends to the Nazi terror; but the fat General, Furtwaengler’s boss, had seen fit to take it all as a joke, and the staff officer had apparently decided that it had been a joke to Lanny as well. A curious quirk in their psychology, which an outsider had to try hard to understand: their collective egotism was such that they were rendered incapable of understanding other people’s minds, and in spite of their utmost cunning they remained naive and vulnerable; as if a man should put on heavy armor for battle, but leave a large opening over his solar plexus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The National Socialist. German Workingmen’s party had achieved in the past two years such triumphs as had never before been known in history. They knew they were going on to fresh triumphs; they had it in their hearts and were full of the "), _c('i', [_vm._v("elan")]), _vm._v(" which it gave them, the “strength through joy.” They sang exultant songs about the future, they dressed themselves in fine uniforms and paraded with banners celebrating it, they organized colossal and magnificent pageants to tell all the world; they were quite literally intoxicated with their own grandeur. “Germany belongs to us today, tomorrow the whole world”—and how can the world fail to enjoy the prospect as much as we?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here came these two Americans—rich, to be sure, but what is mere wealth compared with titles and honors, fame and glory vision and "), _c('i', [_vm._v("Geist?")]), _vm._v(" Wealth is an incidental, one of the rewards of courage and daring; all the wealth of the world lay exposed before the Nazis, as Pizarro had found it in Peru and Clive in India. This American pair had the wit to see what was coming and to climb onto the Aryan bandwagon. They enjoyed the privilege of meeting Seine Exzellenz the Minister-President of Prussia, Reichsminister of the German Empire, Air Minister, Commander-in-Chief of the German Air Force, Chief Forester of the Reich, Reich Commissioner, and so on and on; they were permitted to address him informally, to joke with him and share some of his confidences. How could they fail to be overwhelmed by the honor, and to march in spirit in his triumphal progress?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny had ordered the best champagne for dinner, and afterward he served brandy and liqueurs, and while sipping them lightly himself he kept his guest’s glasses full. So the blond young Aryan’s face became rosier than ever and his talk more naive. He revealed the fact that Germany was going to win the Saar plebiscite; the matter had been arranged with German thoroughness and everything would go through "), _c('i', [_vm._v("planmassig")]), _vm._v(". He didn’t go so far as to say that the murder of Barthou had been arranged, but he remarked with a smile that it was certainly most convenient, and that in future French politicians would be more cautious in their policy of "), _c('i', [_vm._v("Einkreisung")]), _vm._v(". He expatiated at length upon the wonders of the last Partyday, and became lyrical in describing the ecstatic state of mind of the rank and file. "), _c('i', [_vm._v("Sieg heil! Sieg heil!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So at last, when Lanny Budd, associate of noble lords and multimillionaires, thought it safe to remark: “I have some information which might be of interest to Seine Exzellenz,” the Oberleutnant did not hesitate for a moment, but said: “"), _c('i', [_vm._v("Herrlich, Herr Budd!")]), _vm._v(" I will speak to him the first thing in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Afterward, when Herr Budd told his fashionable lady about this success, she remarked: “My God, we certainly paid a price for it! Can you imagine anything duller than that poor country gawk he drags along with him?”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The old-style Teutonic robber-baron sat in the sumptuous private apartment of his official residence, the room with the large black table and the gold curtains of his own designing; however, the lion cub had been banished, having grown too big for play-acting. The vast bulk of the Minister-President General was covered in one of those gorgeous uniforms, to the designing and construction of which so large a share of the clothing industry of the Reich was now devoted. This one was of pale blue with a darker blue stripe, and insignia of which Lanny did not know the meaning. Whatever the uniform, the wide sash was never omitted, and the large gold star with eight points hanging from two white ribbons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Ja, Lanny!")]), _vm._v("” bellowed the fat man when he saw his guest. His broad face with heavy jowls, usually sullen, lighted up with pleasure, and he seized the American with a large moist hand—but not flabby—grab it hard to protect yourself! It pleased his whim to be genial in the presence of this favorite of fortune, of whom he had made use in an especially successful coup, the plundering of one of the richest "), _c('i', [_vm._v("Judschweine")]), _vm._v(" in Germany. Surely it couldn’t be that Hermann Wilhelm Goring laughed loudly in order to conceal embarrassment!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Gruss Gott, Hermann!")]), _vm._v("” responded Lanny, seeing that he had been advanced in social status.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Also!")]), _vm._v("” exclaimed the fat warrior. “You are on the way to becoming a crown prince of the air lanes!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny was taken aback and showed it. “You have indeed a good secret service,” he remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you ever doubt it?” queried the host. Then, more seriously: “Your father should come to see me; it might be to our mutual advantage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Na, na!")]), _vm._v("” smiled Lanny. “You are not financing any airplane factories outside the Reich.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Aber")]), _vm._v(",” countered the Air Minister, “we buy planes, and would buy more if they were good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One for a sample?” retorted the other. He knew he was supposed to be impudent; he was the court jester.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How can you say such a thing? Who could ever say that I took anything without paying for it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who could say it if I couldn’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this the stout General turned into a Kris Kringle, whose round belly shook when he laughed like a bowl full of jelly. It was to be doubted if anyone had had the nerve to address him in that fashion for many a long day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Setze dich, Lanny")]), _vm._v(",” he said, in fatherly fashion. “Seriously, tell Robert Budd that if he gets that thousand-horsepower engine, I will lease his patents and he won’t have to argue about the price.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was quite disconcerting. Lanny felt himself enveloped in a net of espionage, and shuddered inwardly, thinking of Trudi. But then he realized that Robbie had been talking his project all over Paris and London, and of course Goring’s agents would have sent him word. But what a contrast in efficiency! Robbie had been to consult the authorities both in England and in his own country, and both had high-hatted him; but here this old German "), _c('i', [_vm._v("Raubtier")]), _vm._v(" sent for him and invited him to name his own figure! It boded ill—and especially since Lanny knew that Robbie would be apt to accept the invitation!")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("This was a stag affair, and Irma had not been invited. They lunched at a table wheeled into the room, a meal consisting of a boiled turbot with thick rich sauce, and then of "), _c('i', [_vm._v("Hasenpfeffer")]), _vm._v(". Apparently the great man didn’t give any heed to notions of diet; he stuffed himself in the middle of the day, and pressed quantities of food upon his guest. He talked fast and with his mouth full, so that he was more repellent even than usual; but Lanny laughed at his jokes and admired his capacities and did not let himself be shocked by sexual anecdotes. When the waiters had served the food the General growled: “’"), _c('i', [_vm._v("R-r-raus!")]), _vm._v("” and they vanished and did not return until he pressed a button.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now was Lanny’s opportunity to show that he could and would bring information of value to the military organizer of Naziland. He had given thought to the problem and chosen his course with care. He would never tell Hermann Wilhelm Goring anything that would be of real use to him—unless it was something that Hermann Wilhelm Goring was sure to know already. The visitor would be prodigal of information of this sort, and it would be accurate; so Seine Exzellenz might be kept on the alert, hoping for something new. If he asked directly, Lanny would say he didn’t know, but would try to ascertain. How long he could make out with such a program he couldn’t guess; Rick had said: “Not very long,” and Lanny had answered that any time the General grew tired of his society, he could find some more compliant "), _c('i', [_vm._v("Spitzel")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The host led the talk to France, and Lanny told him about the anti-Nazi fixation of Barthou and how greatly his fellow-plotters had been disconcerted by his death; speaking to the man whom he suspected to be the real murderer, Lanny pictured the plight of a Foreign Minister who had interposed himself in the effort to save his royal guest and had been shot through an artery of the arm; he might have been saved if any of his staff had had the wit to tie a handkerchief about the arm and turn it with a stick or a fountainpen; but no one had had such wit and he had slowly bled to death. Lanny went into the gory details, thinking he might be able to spoil the murderer’s appetite for Moselle wine; but no such effect was to be noted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The visitor talked about the new Foreign Minister of France, whom one of his financial supporters had called a "), _c('i', [_vm._v("fripon mongol")]), _vm._v(". The “rascal” part was true, Lanny said; and as for “Mongolian,” the innkeeper’s son had learned to joke about it himself, because of his swarthy complexion, thick lips, and strangely slanted eyes. Goring asked if he really had Mongolian blood, and Lanny said: “Who could guess? The races have been so mixed in that part of the world.” Lanny knew exactly how to please a pure-blooded blond Aryan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The visitor told what he knew about the character of Laval, and little of it was good. He talked about the two hundred families who were reputed to rule France, and expressed the opinion that Laval had become the two hundred and first and would from now on serve their interests automatically. “Their own wealth concerns them so deeply that they have no time to think about their country. It would not trouble them too greatly if you were to bomb the rest of it, provided you would agree to spare their mines and steel mills and other valuable properties.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A good idea,” said the wholesale killer. “I will take it up with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny would have been worried if he hadn’t felt certain that Goring had already done it.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The luncheon table was wheeled out, and the fat General lighted a fat cigar and settled back in an overstuffed chair in a pose of contentment. They were alone, and the time had come for a showdown. “Tell me, Lanny,” said he, “have you given any thought to the idea of helping me now and then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have given much thought to it, and I find it troubles me, because I lack a sense of competence. I doubt my ability to be worth my keep.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You might let me be the judge of that, my friend. I have had some experience in judging men.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In this case you are far too generous. When one has been an idler for thirty-five years it is not so easy to change.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The judge of men fixed his gaze intently upon his guest. “Do you find yourself under any special strain at this moment?” he inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny smiled. “Only that I have eaten enough for two.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would ask you to do nothing but what you are doing now. It is your privilege to meet many persons who are of interest to me. I know that you are curious about them and amused to watch their minds work. Could you not find it worth while to come and tell me what you have observed? Suppose, for example, I should suggest that on your next visit to Paris you should cultivate Pierre Laval, study his temperament, and help me to understand what approach to him will be most effective.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Surely, Hermann, you have plenty of people doing that sort of work for you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have not tried to conceal the fact from you; but I do not know one of them I would trust so well as you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny, who hadn’t been born yesterday, but something over twelve thousand yesterdays ago, knew exactly how much weight to give to such a remark. “You honor me,” he said. “And, as I told you, so long as it is play, I can enjoy doing it. But if I accept compensation from you, at once I feel under pressure; I begin to wonder whether I am earning my salt, and decide that I am a complete "), _c('i', [_vm._v("Taugenichts!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your New England conscience,” said the fat General. “I have never before had an opportunity to observe it in operation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is sometimes inconvenient to its owner,” replied the grandson of the Puritans; “but those who deal with him find it useful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You must understand that we Prussians also have our code, though perhaps not the same. I should not feel comfortable asking favors of you unless I was in position to make some sort of return. Can you not tell me of anything you would accept?”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("So Lanny had what he had been angling for, and it was time for him to jerk the hook. Said he, promptly: “When you put the matter to me that way, Hermann, I will make you a straightforward answer. I have what I suppose is a sort of profession; at any rate, it has enabled me to earn more than I need, and spares me the embarrassment of living on my rich wife. For lack of a shorter name I call myself a "), _c('i', [_vm._v("Kunstsachverstandiger")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am informed as to your reputation,” replied the Minister-President; and it appeared as if he considered himself the one to jerk the hook. “You may perhaps have heard that I am building a rather good hunting-lodge for my friends. I want to furnish the place adequately, and nothing would please me more than to have your advice on the subject. Would you undertake to buy some art works for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What I had in mind was something different from that. I was thinking of the old masters which were in the palace of Johannes Robin. I don’t know whether I ever mentioned it, but my associate and I selected and purchased those paintings.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have heard many comments upon the excellence of judgment displayed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We gave a great deal of study to the collection, and I think it really is good. My idea was that possibly your tastes might be different from mine, and you might care to turn some of those works into cash. I have prepared a list of what was paid for them, and would be glad to try to find purchasers at the same prices. It will cost you nothing, let me add.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I thought you were going to suggest some way by which I could reward you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The purchasers would pay me ten per cent commission. That is the basis on which I work with them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But isn’t it fair that I also should pay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have a rule which I have never broken, that I do not take commissions from both parties. I represent one or the other, and try to serve his interest.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Aber")]), _vm._v("—why shouldn’t you serve "), _c('i', [_vm._v("my")]), _vm._v(" interest and let "), _c('i', [_vm._v("me")]), _vm._v(" pay the commission?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny maintained his winning smile. “You are kind and I am grateful; but it happens that I have a standing arrangement with several clients in America who are building up collections. They expect to add ten per cent to the prices I quote them; so why not let them go on doing so?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Famos!")]), _vm._v("” exclaimed Goring. “But mightn’t I get higher prices with the help of your persuasive skill?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I doubt it, for the reason that Johannes did his buying before the depression, and it will not be such an easy matter to find purchasers now. I am only offering to try, and am telling you in advance that I may have to come and confess failure. Johannes was a man who wanted what he wanted, and more than once he insisted upon paying prices higher than I considered wise from the business point of view. On this list which I have prepared from my records I have stated the actual prices paid, and in a few cases I have penciled in a lower figure, which I fear is the most I could advise any of my clients to pay now. It is, of course, for you to say whether or not you care to accept any of my suggestions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me how you achieve these feats,” said Goring. “Do your magical millionaires always pay whatever you tell them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“By no means. They have a habit of setting great value upon their money. They will ask: ‘Are you sure it is worth that?’ and I will reply: ‘There is no fixed price for a work of art; it depends on how badly you want it.’ Sometimes I am told to offer a lower figure, and then I take the cash and lay it on the table in front of the picture owner. I have observed that the actual sight of money exercises a kind of hypnotic effect upon many persons, and those who would resist a bank draft collapse in front of a packet of thousand-mark notes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Teutonic Falstaff was amused by this portrayal of human frailty. He called Lanny “"), _c('i', [_vm._v("ein ganzer Kerl")]), _vm._v(",” and said: “Give me the list and I’ll look it over. A number of the paintings don’t mean much to me, and maybe I’ll turn you loose to plunder those plutocrats of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("There was nothing to do now but wait—which wasn’t such an ordeal with a suite in a de luxe hotel and every service at command. Smart Berlin society threw open its doors to an American “glamour girl,” and after a half-dozen wardrobe trunks had arrived by express, she was ready to go day and night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The prince consort arrayed himself according to the decrees of the fashion dictators, and accompanied his spouse to luncheons, "), _c('i', [_vm._v("thes dansants")]), _vm._v(", and elaborate long dinners followed by music and dancing. He shook hands with numerous large gentlemen who seemed to have the bulk of whales and approximately their shape, starting with close-cropped heads and perfectly rounded all the way down, except for two or three deep creases at the back of their pink necks; their ladies were built on the same scale and had voices suited to Wagnerian opera—Lanny’s irreverent imagination saw them in flowing white robes, galloping to the rocking-horse rhythm of the "), _c('i', [_vm._v("Walkurenritt")]), _vm._v(". Their conversation was serious, and you might give deep affront by mixing a "), _c('i', [_vm._v("Hochgeborener")]), _vm._v(" with a "), _c('i', [_vm._v("Hochwohlgeborener")]), _vm._v(" or addressing a "), _c('i', [_vm._v("Frau Doktor")]), _vm._v(" as an ordinary "), _c('i', [_vm._v("Frau")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The younger set was not so heavy, either in body or in mind; they played golf and tennis, danced with spirit, and motored hither and yon; they admired Americans, used American slang, and bore no grudges because of the war. Like the daughter of J. Paramount Barnes, they made their religion out of having a good time. They were not interested in politics—except for repeating some comical story about the leaders of the fantastic new "), _c('i', [_vm._v("Regierung;")]), _vm._v(" when they had done that, they had proved themselves enlightened persons and could go on dancing. The "), _c('i', [_vm._v("Regierung")]), _vm._v(" rarely interfered with you if you had money and confined your witticisms to the right sort of people—those who also had money. When Lanny asked the grandson of one of the steel kings what he really thought about it all, the "), _c('i', [_vm._v("Grunschnabel")]), _vm._v(" answered: “"), _c('i', [_vm._v("Zum Teufel!")]), _vm._v(" It’s a problem of getting the votes of millions of morons, and the Nazi way seems to suit them in my country.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The larger magnates and their wives had decided ideas. For them the Hitler invention meant no more strikes or labor-union agitation, no more Reds fighting in the streets; it meant wages fixed and permanent, resulting in such prosperity as heavy industry had never before known. In short, the Third Reich was the magnate’s dream, and Lanny was struck by the curious resemblance of their conversation to that of his father. The only difference was that they had it while Robbie longed for it but didn’t know how to get it. The election in his homeland had gone in the opposite direction from what he had predicted, and his hope of putting restraint upon that man in the White House had gone glimmering. Robbie didn’t go so far as to ask for an American Hitler, but he took to predicting that one was coming, and if a likely candidate had presented himself and asked for funds he might not have been sent empty away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The masters of Germany’s immense steel, coal, chemical, and electrical industries said a few formal words of regret over the excesses of their new government, but hastened to point out that such things always happen during any social readjustment. They added that all Germany needed now was to have her lost territories restored, and then Europe might be assured of a long period of peace and prosperity. Lanny wanted, to say: “Peace and prosperity based upon the all-out manufacture of armaments?” but those were the things he had to keep locked up in the other half of his personality.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("When an American playboy wearied of Berlin fashionable society, there were the art galleries and the concert halls. The Nazis had burned most of the worthwhile modern books and censored the art exhibitions, but collections of old masters stood untouched, and you could still hear Bach and Beethoven, Mozart and Brahms—if not Mendelssohn and Mahler and the other Jews. Lanny would turn his wife over to the smart ladies or to one of the eager young dancing men, and lose himself in the contemplation of masterpieces which spoke to him of that Germany he had known and loved as a youth and which, he told himself, survived in a region beyond the range of Nazi “Big Berthas” or the possible flight of General Goring’s planes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He went to a concert in the Philharmonie and heard a fine rendition of the Fifth Symphony. He gave up his soul to that of Beethoven, and felt himself lifted into a kind of divinity, endowed with new perceptions and powers; he shared in the struggle of mankind against those forces which have sought to block the upward progress of the race. He dreamed mighty dreams, and when the last notes of the glorious music had died he came back to the real world refreshed and strengthened for new efforts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Lanny was not the same trusting and happy lad who had first heard this classic art work; he had learned more about the world, and his thoughts were more complex. Looking about the concert hall at the men and women, young and old, who had been mystically made one with him, he observed that several of them wore Nazi uniforms, and what could that mean? Was it possible to transform Beethoven’s passionate longings into any sort of Hitler ideology? To Lanny that appeared as the sin against the Holy Ghost; but evidently it had been committed, for the young Nazis looked just as inspired as the dreamiest "), _c('i', [_vm._v("Madchen")]), _vm._v(" or the most reverent "), _c('i', [_vm._v("Tonkunstler. “So pocht das Schicksal an die Pforte")]), _vm._v(",” Beethoven had said; and what did those hammer blows of fate mean to a Stormtrooper? To what door was admission being demanded? Was it the French armies at the bridgeheads of the Rhine, or the Russians at the forts of East Prussia?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hardly the best of thoughts to take into a concert hall! The alien rebel appealed to the soul of Beethoven on behalf of his cause, and the father of modern music told him that the knocking on the door was that of the Stormtroopers raiding the home of the Schultzes and dragging away Ludi and Feddi to torture and death. The second theme, gently pleading, was the soul of Freddi, which would live on in Lanny Budd’s soul for as long as he had one or was one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rebel’s thoughts wandered and came to rest upon an anecdote which had been told him by a Dutchman with whom he had chatted on the packet-boat from Harwich to the Hook of Holland. A Nazi friend had been extolling to this Dutchman the conditions within the Hitler realm; there was such perfect order, and the streets were so clean; everybody had work and enough to eat; everybody knew his duty and did it gladly—and so on. “Ah, yes,” the Dutchman had countered; “but when I hear a step on my front porch at four o’clock in the morning, I know it’s the milkman!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What was this strange duality in the soul of the German which made it possible for him to dream the noblest and holiest of dreams, and then go out and perpetrate the most hideous atrocities? What was it which had made Germany the land of Beethoven, Goethe, and Schiller, and at the same time the land of Bismarck, Hindenburg, and Schicklgruber alias Hitler? Evidently the German did not know how to harness his aspirations and make them work in his everyday life, especially political. He delighted in lofty abstractions expressed in the longest words and used like counters in a game, but without ever turning them into cash. His ideas were like the screws of a steamship during a violent storm; they race frequently in the air, failing to come into contact with the water and produce any motion in the vessel.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("One morning the mail brought a letter on old-fashioned stationery, bearing the crest of the Baron von Wiesenschmetterling. It informed Herr Lanning Budd that the Baroninwitwe would be pleased to consider an offer of one hundred and twenty-five thousand marks for the Hubert van Eyck painting. She wouldn’t quote in dollars, of course, but at the then rate of exchange it was about fifty thousand. Irma thought it monstrous for such a tiny piece of canvas; but this was a real old master, two centuries older than Rembrandt. Lanny said it might call for dickering; to begin with he wrote a carefully studied note calling the old lady’s attention to her phrasing and stating that he could not undertake the negotiations upon the basis of a promise to “consider.” Might he have her assurance that if within the next thirty days he brought her the sum of one hundred and twenty-five thousand marks in cash the painting would be his?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While, waiting for a reply, he escorted Irma to more entertainments; until one morning he received a ceremonious visit from the Oberleutnant bringing him a note on the impressive stationery of the Minister-President of Prussia, authorizing him to sell a list of paintings at various specified prices. A total of seventeen were listed, and the expert was amused to observe that they included all the Italians; most of the French, and several of the English, but none of the German, Dutch, or Flemish. There were conclusions of a political nature to be drawn from this. The Nazis were hoping to make friends with Holland and Belgium, but were in a state of intense irritation with Mussolini, who was busily intriguing with the Austrian government, seeking control of that near-bankrupt country. The fat Kommandant of the German Air Force had made a couple of trips to Rome, but with ill success according to all reports.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma, who knew the paintings, looked over the list and commented from another point of view: “He is keeping all the nudes!” Yes, a psychoanalyst could have told a lot about an old-style robber-baron from that list of rejects. He didn’t care anything about the Blessed Virgin or any such neglected females; he didn’t care for old people of either sex or for the proletariat of any tribe or color. What he cherished was beautiful young women in scanty garments, and especially when they had large ruddy limbs, after the style of Rubens; also princes, statesmen, and soldiers in gorgeous costumes, with jewels and lace and orders of whatever design. Did he intend putting these to use as fashion-plates?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anyhow, it was a job, though not an easy one, for all Lanny’s suggestions of reduction in price had been overlooked, and a couple of the prices had been hiked. But Lanny had explained that he sometimes came back with counterproposals, and presumably the Minister-President was taking precautions. It could do no harm to bring him a lower offer; his official executioner couldn’t chop off the head of a "), _c('i', [_vm._v("Kunstsachverstandiger")]), _vm._v(" who happened to be an American citizen. The total sum which Lanny was invited to contribute to the great man’s exchequer was slightly more than a million marks, and even if he took Zoltan Kertezsi in on some of the deals, he would earn enough money to keep Trudi Schultz and her fellow-conspirators in funds for a year or two.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny and his wife had a luncheon engagement, but he begged off in order to write letters and cablegrams. After Irma had departed, he decided upon a respite, and went for a drive into the Moabit district. As his chariot rolled, his thoughts were busy with the second-in-command of the Nazis, trying to probe the mystery of this unusual acquaintanceship. Did Goring really believe that Lanny was friendly to his cause and would be willing to help him? It was hard to imagine. A wholesale murderer, with the guilt of the blood purge and the Reichstag fire and other crimes beyond the reckoning of history, would hardly be apt to take up casual friendships or fall victim to the charms of a dilettante of all the arts, including conversation. Having at command the greatest spying-organization in the world, he will hardly admit any person to his intimacy without knowing that person’s record and connections. Could he fail to have learned about the Red uncle and the Pink school in Cannes, and that Lanny had got kicked out of Rome ten years ago; that he was a friend of Blum and Longuet and Steffens and others, and that his best chum was an anti-Nazi playwright? What could Goring be trying to get out of such a person?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A mystery complicated enough to make the plot of a melodrama for Eric Vivian Pomeroy-Nielson, if that fastidious highbrow would condescend to anything so far down in the dramatic scale. Was the Air Kommandant using Lanny as a preliminary to doing business with Lanny’s father? Or did he have his eye on Irma’s fortune, planning to get Lanny into a serious scrape and then plunder Lanny’s wife as he had plundered Johannes Robin? Was he expecting to use him as a decoy, to draw members of the underground movement into the Gestapo’s net? Trudi had vouched for Monck; but suppose Monck was fooling Trudi and getting ready to meet Lanny’s friends and probe his secrets? All these were possibilities, and seemed more probable than the idea that this vain and cruel man was really enjoying the company of the grandson of Budd’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe they were following him here in Berlin! That at least was something he could make sure about; he drove his car around a block, and every time he turned a corner he watched in his little mirror to see if any other car made the same turn. None did; so he decided that he wasn’t imperiling Trudi at present. He drove up the street which she had named, timing himself to pass the corner exactly at noon. There she was, also on the dot; walking on the right side of the street, and carrying a small package in the crook of her left arm, in plain sight as he drove up behind her. He passed her, going slowly, and in the next block drew up by the curb and waited until she came along and stepped in. They drove on, and again he turned a corner and watched carefully; but there was no pursuit.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("“I didn’t know where to get a feather,” said Lanny; “but I got the job with the General.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He told her about the luncheon in the official residence, and to the woman it was a sort of ogre-story, a visit to Bluebeard’s castle. “How could you swallow his food?” she exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I ate too much,” he replied. “It was part of the job. If I go there often, you may see me looking like him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Gott behute!")]), _vm._v(" What on earth do you talk about to such a man?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mostly you listen to him talk. You find that it has to do with himself and his prowess, and of course with the army and especially with the air force he is building. He has a strong ego, and his aim in life is to compel other persons to submit to his will. He is much better company than some of the other Nazis, because he does not bore you with their jargon; he talks like a man of the world who is interested in power and assumes that you are sensible enough to understand that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It does not disturb his sleep that he has killed tens of thousands of persons and is having a hundred thousand tortured in prisons?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am sure he sleeps as soundly as any other fat man. You must understand that he does not have our conception of human brotherhood. He is a professional killer of other men; he has been trained for it since youth, and during the World War it became the most exciting of games, in which he staked his life upon his skill. Frau Magda Goebbels called my attention to the fact that so many of the Nazi leaders have been airmen. It was a school for the making of initiative and daring, and for the eliminating of the scrupulous. I am sure that Goring would hesitate no more over eliminating you than you would over a bedbug.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am put in my place,” said Trudi, managing a wry smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now this wholesale killer is conducting a school for young Nazis, teaching them initiative and daring. Incidentally, and indirectly, he is teaching the same thing to young working-class leaders. It is a harsh school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She thought about that before she spoke again. “Tell me, Lanny, suppose you had a chance to address the workers of Germany—only one chance—just what would you say to them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The car rolled on for a block before he answered. “I believe I would point out to them that the increase in employment of which the Nazis boast is based entirely upon the manufacture of armaments; also, it depends upon the piling up of debts, and so it cannot go on indefinitely. It can have but one end, another slaughtering of the workers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Suppose you had a chance to bring them some sort of message from the outside world, what would it be?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That the workers of France and England and America are of a pacifist disposition; they do not want to rearm their countries and they have succeeded in cutting down military budgets to a great extent. But of course if Germany goes on rearming, that will automatically force the neighboring countries to follow suit. It is obvious that when a nation turns its whole substance into war materials, as Germany is doing now, the time will come when that nation has to go to war—it can do nothing else because it is equipped for nothing else; and it must use its armaments or else be suffocated under their weight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We do not get the Socialist papers from abroad any more, Lanny. Can you tell me of some foreign statesman who has said that, and who might be quoted?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Leon Blum has been saying it over and over; both in his speeches and in "), _c('i', [_vm._v("Le Populaire")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very well,” said the woman. “We will attribute it to him. The next time you come into Germany, bring us some clippings like that; they will be useful.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“O.K.,” said Lanny, somewhat offhand and without realizing that he was taking one more step toward trouble. Or maybe he knew but didn’t wish to admit it to himself. Wide is the gate, and broad is the way, that leadeth to destruction, and it is a common observation that when you have taken the first step through that gate and along that way, it becomes easier to take the second and the third.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("When Lanny got back to his hotel there was a cablegram, always an interesting event in the life of an art expert. Among Irma’s Long Island acquaintances was a young matron known as “the princess of pickles”; she had inherited a block of stock in a great industry having to do with the canning and processing of foods. Two or three years ago Lanny had cabled her from Vienna about a Blessed Virgin by Jan van Eyck, and she had promptly forwarded the price. In due course she had discovered, as most of his clients did, that it was a beautiful thing and that owning it was a source of rare distinction. So, immediately upon receiving the quotation from the Baroninwitwe, Lanny had cabled this same client that she had an opportunity to obtain a Blessed Virgin by the elder brother of Jan and thus be unique among American collectors so far as Lanny’s knowledge went. Now came a reply that a hundred and twenty-five thousand marks had been placed to his account in one of the great banks of Berlin, but that he would be expected to get his commission out of this sum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was the kind of thing which made Irma Barnes so furious with the rich; she called it “jewing down,” and she said, what was five thousand dollars to Brenda Spratt? Lanny grinned and said that if you counted it in the form of canned pork and beans it might amount to a carload. He was used to all sorts of counter-proposals, and had seen one of his clients give up a priceless painting rather than pay the extra ten per cent; he added one of his father’s favorite anecdotes, about a lady in Newcastle who had desired to sell her mansion but had refused because the purchaser insisted upon the curtains being included in the deal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It would mean another trip to the Neumark, and one of those bargaining-duels which Lanny had learned to enjoy. He performed a mathematical operation to determine the purchase price with his commission added. It worked out at one hundred and thirteen thousand six hundred and thirty-six marks and thirty-six pfennigs. It would sound better if he renounced his claim to the pfennigs and offered the Prussian lady an extra mark. He phoned to his victim and made an appointment to see her after lunch the following day; also he phoned Zoltan about the deal, and told Irma that he had fixed it up with his colleague, who was supposed to have a client desiring the picture but unwilling to pay so high a price.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny got a large bundle of crisp new notes from the bank and stowed them in an inside pocket; he didn’t have to worry about hold-ups, because in Germany the only kind was official, and if you possessed an American passport you were immune. They drove on a day of rain which turned to light snow before they got to their destination. The potato-fields were a vast magical blanket, suggesting a world where there had never been any suffering; but it was an illusion, for if you had known how many thousands of human bodies had fertilized those fields through the centuries it would have ruined your appetite for “earth-apples,” as the Germans call them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the drawing-room of the elderly stout aristocrat, overcrowded with things old enough to be valuable even though they were ugly, Lanny played the game which had become his substitute for war. A poet had told the world that the colonel’s lady and Judy O’Grady were sisters under the skin; Lanny had never bought pictures from either of this pair, but he had bought them from members of the French, Spanish, German, Austrian, Polish, and Russian ruling classes, and had proved that their manners and morals were not even skin-deep when immense quantities of their country’s currency were dangled before their eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Baroninwitwe von Wiesenschmetterling became indignant when she learned that this young American upstart had presumed to make an appointment and expect her to waste her time haggling over a few marks. She had set her price, and had written him a second note—not yet mailed—granting him an option. Why had he not told her over the telephone that he wished to try to force a reduction in her offer? Lanny said he was sorry. He had not understood that it would be an offense to make a counterproposal; and after all, a hundred and thirteen thousand six hundred and thirty-seven marks was not a sum to be sneezed out of the room. He said it with his amiable grin, and added that he would be glad if he could leave the package behind him, because it was so heavy it had stretched his coat out of shape. He dragged it forth, and saw the Baroninwitwe’s eyes grow larger—it was hardly likely that she had ever seen such an amount of cash in all her baronial life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a struggle to the death of the noble lady’s temper and very nearly of Lanny’s endurance. “This is really an immense sum of money, "), _c('i', [_vm._v("gnadige Baronin;")]), _vm._v(" it cost a lot to cable so much to Germany and I’ll hate to have to send it back. My client’s statement is positive, and I know from previous experience that she will not change. Please be so kind as to read the cablegram.” She refused, but when he put it into her hands, her curiosity got the better of her; this showed that she could change her mind and that she was not such a forbidding personality as she endeavored to appear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a table near her chair, and he unwrapped the package on it. “I want you to realize that this is not stage money,” he said. “This, as you will see, is the bank’s own label—in this bundle are fifty one-thousand-mark notes, and here is another of the same; and this smaller collection makes the complete sum. In my ten years’ experience as a "), _c('i', [_vm._v("Kunstsachverstandiger")]), _vm._v(" it has rarely happened that I have handled so large an amount of money—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Aber")]), _vm._v("—never before have you had a Hubert van Eyck!” She almost screamed it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have purchased a Blessed Virgin by Jan van Eyck from a relative of yours—and for a much smaller sum.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, I know, but that is not the same! You realize it as well as I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They argued the merits of the two Flemish brothers and the comparative rarity of their works. Here was a treasure unknown to the art world, a family possession for three hundred years, and he came and tried to shop for it as if he were buying the old clothes of her major-domo! When she said that, Lanny decided to resort to the last extreme. He put the bundles of money together and said, with dignity: “I am sorry, "), _c('i', [_vm._v("gnadige Baronin")]), _vm._v(", that I have wasted so much of your time.” Irma, who had been sitting motionless, a statue of silent contempt, arose, and the two of them started to take their leave. “I shall be leaving for England tomorrow,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny had known men who could stand that, but never a woman whom it had not broken down. “"), _c('i', [_vm._v("Gut denn!")]), _vm._v("” said the noble widow, torn between greed and rage. “I’ll meet you half-way. I’ll split the commission with you. You may have five per cent and pay me the balance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have brought no more with me than I have shown you, and I am not in a position to change my offer. I have to divide my commission with my associate—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what have I to do with that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If he has assisted me, he has earned his share.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what have you yourself done in the matter? You have made two trips here, you have written me one letter and sent one cablegram to your client—that is all!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Verehrte Gnadige")]), _vm._v(", you overlook the most important detail: I have spent a matter of ten years learning to do these things. I have not merely learned the names and addresses of persons who are willing to take my word for paintings, but I have established a character so that they trust me. Do you think you could find, anywhere on this earth, a person who would cable you one hundred and twenty-five thousand marks to buy a painting which the person had never seen or even heard of until your message arrived?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They had an argument standing on their feet. Irma was disgusted, and started to go out to the car, and that was good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll tell you what I’ll do—my last offer! I’ll allow you ten thousand marks, and you pay a hundred and fifteen thousand. "), _c('i', [_vm._v("Einverstanden?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was cheese-paring, and she must have known it. But don’t make the mistake of being impolite, for she might become really mad! “"), _c('i', [_vm._v("Verehrte Baronin")]), _vm._v(",” said Lanny, in the kindest tone he had in his repertoire, “you have a lovely and rare painting and I have not tried to conceal my admiration for it. I have offered you a very high price, and I think I have done well for you. I also think that I have earned my proper share. I have never in my life cut my own commission, because I know that the work I do is honest and is worth the price. If you accept my offer you will count this large sum of money, and then sign the bill of sale in triplicate, after which I will hand you the money with one hand and you hand me the picture with the other, and we will both be better off than we are now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had to walk all the way to the front door of the mansion and had begun to be seriously worried; but finally she said: “"), _c('i', [_vm._v("Also gut")]), _vm._v("—"), _c('i', [_vm._v("kommen Sie zuruck!")]), _vm._v("” She sat down and counted every one of the notes, stopping to wet her fingers for every two or three. She signed the documents, and Lanny wrapped the Blessed Virgin in a piece of oilcloth which he had brought. He was about to take his departure when she became suddenly human and invited the young couple to a "), _c('i', [_vm._v("Teegesellschaft")]), _vm._v(". But Irma had gone out to the car, and he was afraid she would refuse to come back; she wasn’t very well, he said, and they desired to get back to Berlin before dark.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("“Oh, that odious woman!” exclaimed the heiress, whose money had come so easily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have met worse,” said Lanny, well content.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The wife would have liked to say: “I can’t comprehend why you insist upon going through such scenes, for the small sums you get out of it.” But Emily Chattersworth had urged her to forgo these criticisms and let Lanny play the game which he had mastered. Instead she remarked: “I really can’t see why you should pay anything to Zoltan. He hasn’t helped with this deal, has he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny didn’t wish to tell what Zoltan’s help had really been. He said: “I’ll offer to pay him, but I know he won’t take it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Another thing,” added Irma. “You’ve got your money into Germany, and how will you get it out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It can stay for a while,” he replied. “Sooner or later I’ll see a painting that I want.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was no need to say more, for Irma would have forgotten about it in a few hours. He drove next morning and drew ten thousand marks from the bank and went to the rendezvous with Trudi Schultz, omitting no precautions. He staggered her when he put this sum into her hands. “It’ll save my having to come again so soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But, Lanny, how am I to keep so much money?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Find some hiding-place in your room—one where the Gestapo won’t think to look.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But suppose the house should burn down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If that happens,” he smiled, “be sure you get out, and don’t bother about the money. I can get more—but I can’t get another Frau Mueller!”")])])])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("SPIRITS OF JUST MEN")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Christmas at Wickthorpe Lodge was a delightful occasion, with friends coming and going, messengers bringing gifts, surprises being planned, a rushing here and there with artificially created excitement. Bright fires blazed in every room and the house was warm, the way Irma liked it. It meant servants coming with full coal-scuttles and going with empty ones; but that was no trouble in this delightful land where prompt cheerful attendants could be had at ridiculous wages. Lanny, the economic determinist, said it was the English land system, which excluded the country people from their birthright; but he had learned not to make “grouchy” remarks in the presence of his wife, and especially not at the season when peace and good will were supposed to prevail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beauty came from London with her husband. She and her daughter-in-law got along famously, the older deferring to the younger and doing everything to turn the spotlight upon her; it was according to her code that the world existed for the young, especially of the female sex—they were entitled to their turn. As for Beauty’s husband, that gray-haired and rosy cherub wouldn’t ever be in the way of anybody; for who can object to being loved, especially in a quiet and non-invasive way? Parsifal Dingle had healed little Frances of a mild cold; at least, he had treated her by his method of prayer and meditation, and the trouble had disappeared. He didn’t make any claims, but left it for you to draw your own conclusions. He was just the person to have around the house at Yuletide, a sort of Santa without whiskers. At this season everybody practiced what Parsifal preached—and if only they had been willing to live the rest of the year in the same spirit, what a different world it might have been!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young people, home from school, were coming and going from one house to the next; they came in with eyes shining and cheeks glowing from the cold; they drank hot punch, laughed and chattered and danced, and then raced off to some other place. Alfy followed “Marcy,” as they called her—impossible to say more than two syllables when you were so busy enjoying life. Theirs was a different kind of love from that which Mr. Dingle taught, and apparently it didn’t make you so happy. The young couple got into one of their fusses, and it was off again and on again; Christmas Day they weren’t speaking, and Marcy was telling her mother about it in tears. Lanny thought it was too bad, but they didn’t ask him for help. Beauty said it was part of the process of getting adjusted, but Lanny thought she was too optimistic. “I never had any such troubles with Rosemary,” he said; to which his mother answered: “Yes, but you lost out with her!”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("In one of the attic rooms of this large house lived a stoutish elderly woman whom you would have taken for a retired nurse or housekeeper; she was known to all as “Madame,” and spoke English with a Polish accent. Nobody could have been more unobtrusive; she seemed perfectly content to sit in her room and play various games of solitaire, and when Irma’s maid, her friend, came to see her, she would tell how the latest batch of games had eventuated. Never would you have guessed that this dull-seeming, slow-moving old person was the repository of one of the oddest and most bewildering gifts with which a prankish Nature or Providence had seen fit to endow humankind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some member of the Budd family or their privileged friends would send up to her room and ask if she felt in the mood for a sitting; almost always she would say Yes, and would repair to that person’s room, and sit in an easy chair, lay her head back and close her eyes—and then what fantastic events would begin to happen! You would hear the deep bass voice of an Amerindian chieftain, dead a couple of hundred years according to his own account and speaking with a Polish accent! But don’t laugh—for before you had got your mouth open he might be telling you something about your great-uncle, whose very name you would have to look up in the family records; or something about yourself that you had thought was a secret from the whole world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny Budd, free-spoken and too humorous, had managed to get himself “in Dutch” with “Tecumseh” by asking persistent questions of a skeptical nature; so it was rarely that the old creature—whoever or whatever he was—could be persuaded to serve him. “Oh, so you’re back again, Mr. Smarty!” the booming voice would say; which certainly didn’t sound Iroquois or Polish. It was unfortunate, because Lanny was one who really wanted to understand these mysteries, and had stood for a lot of ridicule on Tecumseh’s behalf. People wouldn’t make subtle distinctions in matters occult; either you knew it was all tommyrot or else you were a victim of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Lanny kept on trying, because he had witnessed events which were beyond explanation by what the world was pleased at the moment to consider “normal.” By and by the world might change its mind and decide to include a lot of new things as normal; but they weren’t going to do it at the behest of a playboy, a darling of fortune whom they knew as Mr. Irma Barnes. Lanny held a great respect for science, and it was his hope that some day a really learned man would come along and experiment with Madame Zyszynski and find out how she did these things. He had found scientists who admitted that it was quite remarkable, but that didn’t keep them from going back to their everyday routine, disregarding the possibility that there might be unknown universes all around us, or in us, or through us, trying in vain to let us know about themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("At this time Lanny was persisting, because it seemed to him that if there was a world of spirits, Freddi Robin, newly arrived among them, would certainly be seeking to communicate with his former friends. But Tecumseh had become annoyed by the very idea of “that Jewish fellow” and would have nothing to do with him. A slow, tedious, and for the most part thankless task, probing these dark regions of the subconscious mind! Each of us has his own, and apparently something of other people’s; an ocean of mindstuff in which few soundings have been taken and which is full of creatures stranger than any Loch Ness monster. Put your net down in it, and you may bring up a burden of seaweed and a wriggling mess of jellyfish; you may try time after time with no better luck. But then, just as you are about to quit in boredom, up comes something that shines with an unearthly light—or maybe some writing derived from a lost Atlantis!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tecumseh,” pleaded Lanny, with abject humility, “do be kind to me. I know that my Jewish friend is in the spirit world now, and he would surely talk to me if you would find him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What was it that brought results after so many failures? The power of some spirit? Or some new train of thought in Lanny’s own subconscious mind? Impossible to say; but on the day after Christmas, sitting with Madame in his own study, the investigator got something that jolted him like a mule’s kick. “There is no Jew here, but there is a young man who says he is a friend. He is tall and has a sort of yellow hair, rather wavy. He is drawing a picture of you and it is good. He says you will know him that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does he give any name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He says something that sounds like Lood. Do you know him? Lood-veek?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know him well,” said Lanny, promptly. “I am delighted he has come.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He hears you say that and is happy. He rubs out the mouth in the drawing and makes it smiling.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here was another of those strange, confused, and confusing manifestations! Gertrud Schultz had identified herself to Lanny by means of a drawing, and now her husband was doing the same! Was that because they were two artists with but a single thought? Or was it because Lanny had got the idea fixed in his mind, and now the subconscious mind of Madame was incorporating it into the fantasy-creation which was called Tecumseh? Very certainly Lanny hadn’t mentioned Trudi and her drawing to anybody in this world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell him I am most anxious to hear whatever he cares to tell me,” said Lanny; and added, ingratiatingly: “Also, I am deeply grateful to you, Tecumseh.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You will really appreciate me some day. This man writes on the drawing-board that to you he is Ludi. Is that right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quite right. Ask him how he is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He says he has escaped from terrible suffering. He says he never believed in the spiritual life. He used to laugh at you and at me, but he will surely never do it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I beg him to come often and tell me about himself. There are reasons why I wish especially to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He says: ‘How is my wife?’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She is well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He asks: ‘Have you seen her?’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Something like a lightning flash took place in the mind of Lanny Budd. One cannot lead a double life and not have suspicions of even the most innocent-seeming events. Could it be that the Gestapo was reaching into the spirit realm? Could it be that some agent had managed to make friends with Madame and was using her, with or without her own knowledge? Either idea seemed fantastic, but Lanny couldn’t keep them from his mind—and it was exactly as if he said the words aloud. “You do not trust me!” exclaimed the deep bass voice. “How can I ever help you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do trust you, Tecumseh!” exclaimed the secret agent. “Don’t you know the story of the man who prayed: ‘Lord, I believe, help Thou mine unbelief’? Help me now by giving my messages to Ludi. Tell him that I have seen his wife and she thinks only of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would like to communicate with her, Lanny.” It was Ludi himself, speaking directly, something which happened only when a seance went especially well. He used precise English, as he had done in the old days when Lanny had visited the Berlin apartment of the Schultzes to inspect Trudi’s art work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It would be hard to arrange, Ludi; you know the circumstances. Some day, perhaps, but not now—unless you can reach her where she is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have tried, but I cannot; there is no channel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hope to see her again some day, and I will deliver your messages. Give me some password, something that will convince her it is really you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She has a strawberry mark just over her right knee.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A curious “psychic phenomenon” indeed! Lanny was always trying to persuade himself that these revelations were a product of telepathy, or mind-reading, or whatever name you chose to give it. He hadn’t told anybody about Monck or what this man had said about Trudi’s birthmark; it seemed to him obvious that at this moment the mind of Madame was taking things out of Lanny’s mind and weaving them into her story. Fascinating to watch, and to a psychologist perhaps as hard to believe as the existence of spirits; but surely it wouldn’t help to convince Trudi that her husband was actually sending her a message!")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The investigator thought as hard as he could. He had to step warily, knowing that the querulous chieftain might decide to break off the conversation at any instant. “Ludi,” he explained, “you must realize that your wife goes swimming in summer, and many people see that mark. Can’t you manage to think of something which only she would know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right,” replied the strange voice—composite of an old Polish woman, an Iroquois Indian, and a Berlin commercial artist and Social-Democratic party member. “Tell her: ‘Chin-Chin.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will she know what that means?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She will know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly there came from the throat of the old woman a burst of sound, the barking of a little dog; it was so realistic that Lanny could have imagined the creature within a few inches of his ankles, leaping at him in a fury and compelling him to kick it away. This went on for fully a minute, and was followed by silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was that Chin-Chin?” inquired the investigator.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was me,” said the spirit voice. Ludi wasn’t required to be perfect in his grammar—and anyhow, there are grammarians who defend that form. “Trudi will tell you about it,” he added. “People do silly things when they are young, and happy, and very much in love.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course,” said Lanny, who had been all three. “She will want to know how you came to pass over, Ludi.” The phrase is considered good form among spiritualists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It would be better not to go into that. I was in Oranienburg, I couldn’t stand it any more, so in the night I chewed my wrists until I tore the arteries.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me where you are now, Ludi. You know that will mean a lot to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She will come here some day and then she will know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to try to convince her,” persisted the American. “You can help me by explaining matters. Do you have a body where you are?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What would I do with the body I left in Oranienburg and that the Nazis burned in a furnace?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know all the things you knew on earth. Do you know other things also?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very many. I am my own mind, but I am other minds, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Minds of people on this earth or on your side?” It was an ill-chosen question, which had the effect of breaking up the show. “What’s the use of all that?” burst out the voice of the old-time warrior. “You aren’t going to believe what he tells you; you’re just figuring over the old stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, please, Tecumseh!” pleaded Lanny. “I’m trying so hard to help my friend and his unhappy wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He is a good fellow,” announced the chieftain. “For his sake I will tolerate you; but you are no good at all, you just tie yourself up in long words, and you wouldn’t believe it if I should smack you one in the eye.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Try it some day,” said the playboy, spunkily. “It might be good for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You sit with Madame in the dark some night, and I’ll show you what I can do. Only you’ll say it’s a teleplasm! Go on about your business now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And that was the end. Lanny knew it would be useless to plead. A long silence; and then Madame began to sigh. When she came out of her trance she inquired, as always: “Did you get good results?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very good, indeed.” Lanny was happy to say it, because it pleased her. She never asked what you had heard; she had the idea that this was bad form, since people often got embarrassing secrets about themselves or others. Instead she lay back and closed her eyes, resting. Finally she remarked: “I won three games of Patience this afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You cheated yourself,” he replied. It was his customary jest, at which she never failed to titter. She had adopted him in her heart as an imaginary son, replacing one whom she had borne and lost; every moment that he would spare out of his fashionable life to chat with her was one she would cherish and dream over.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Robbie Budd was back in Newcastle, but there weren’t any Christmas holidays for him; he was working harder than ever in his life before, bent upon showing his world that he was not merely a great salesman and promoter, but also an executive, in every way the equal of his father, who had failed to appreciate him all his life and had died without atoning for the error. Robbie had collected large sums of money and was going to spend them with a speed and efficiency which would astonish the town of his birth. He was going to build a fabricating plant which would be his own to run, whose products would be his own to market, with no father and no elder brother to hinder or check him. Robbie had made his blunders of overoptimism, but he had learned from them and would not repeat them; there would be no more speculation in Wall Street, only production in Newcastle, and of an article which was in the position of the motor-car thirty years ago. Once more there was a chance to reap fortunes; and in spite of the Bible statement, the race would be to the swift and the battle to the strong.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Robbie’s forward-leaping land it was no uncommon thing for a man to raise several million dollars for a new enterprise and then be in a hurry to get it started. There were men who knew how to design industrial plants, and Robbie was now closeted with them day and night. There were men who knew how to dredge tidelands and make docks and a model harbor; others who knew how to grade land, and had tools which would do it with magical speed. Robbie was now making contracts with these, and with others who would come and pour, concrete foundations the moment the frost was out of the ground. Before summer a forest of steel girders would arise where formerly had been marshes and cow pastures. All this was commonplace in the “land of unlimited possibilities.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robbie threw up his job with Budd Gunmakers, and Johannes Robin, coming home from South America, set to work to help with contracts and purchasing. The firm of “R and R,” which had been Lanny’s joke in youth, was now a firmly based reality. Hansi and Bess being married, Lanny having risked his life to save Johannes and Freddi, Robbie having helped Johannes to get on his feet again—all these were ties stronger than any law could have devised. A one-time Jewish money magnate would give his friend the benefit of the skill he had acquired in more than forty years of trading, and would never worry about what he was going to get in return. He could be sure it would be generous and, what was more important, it would be out of reach of the Nazis!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mama and Rahel packed their few belongings and departed from Bienvenu, writing letters full of thanks to Mrs. Dingle and Lanny and Irma for their kindness. Irma said nothing to her husband, but he knew what a relief she found this; for how could anybody enjoy the pleasures of social life in the atmosphere of grief and fear which those poor Jewish people inevitably spread around them? Irma was glad also on account of her little girl, because she didn’t want those two children to become too fond of each other; she had no mind to find herself some day in the position of Robbie Budd and his wife, with a Jewish son-in-law and the possibility of a half-Jewish grandchild. All right to have Jewish friends, but mixing your blood was something different.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Right after the holidays the Lanny Budds—or the Irma Barneses, as their friends often said it—were planning to return to the Riviera for the winter. Lanny in the meantime had managed to find purchasers for two of Goring’s paintings, and it was a question of how to handle these deals. To Irma it appeared simple to send the money and let the fat General ship the paintings directly to the purchasers; but Lanny said: “How could I ever know what they got?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean you think he’d send them the wrong pictures?” There was a note of indignation in Irma’s voice, as if the governing classes of the whole world were being insulted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny explained patiently that there was a great deal of rascality in the art world—he didn’t say in the Nazi world. “Paintings are imitated so cleverly that only an expert can tell the difference. Somebody might do it without even Goring’s knowing it. My duty is not done unless I personally see the painting shipped. Otherwise, if the customer complains, I have no defense, but have to refund his money and take the loss.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s going to be a nuisance, your having to go to Berlin all the time, Lanny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll let these customers wait till the weather gets warmer,” he answered, with a smile. He would have liked to tell Trudi about the seance, but he wanted still more to be fair to his wife and not deceive her any more than necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, the day before they were leaving England a letter came, having all those signs which he recognized—the German stamp, the writing, and the cheap envelope. He put it into his pocket with some other mail until he was alone. Then he read:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal"
  }, [_vm._v("Dear Mr. Budd:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("If you should see your friend Schmidt, the art dealer, please tell him that I have some sketches which I should like to show him. They are not the same as the last, but better, I hope, and have to do with interesting personalities. This is important to me. Thanking you for past favors,")]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal2"
  }, [_c('span', [_vm._v("Mueller")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("That was all; but it was enough to cause Lanny to reconsider his plans. “Irma, I’ve been thinking about it and I believe I ought to run over to Berlin and get those paintings before I settle down for the winter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, how provoking!” she exclaimed. “Why do you want to make yourself a slave like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’ll only take a couple of days, and you don’t have to come. Wait for me in Paris if you prefer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paris was always an agreeable place for waiting. You could do shopping, if you had what it took, and there were plays to be seen and fashionable friends to go about with. This young couple had two cars which they were taking to the Riviera, so they arranged that the chauffeur should drive Frances and her governess and maid direct to Bienvenu; Irma found traveling with children a nuisance and always avoided it if she could. Lanny would drive his wife to Paris and then proceed alone to Berlin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was but one dubious aspect of this project. “Lanny, can I really trust you in Germany?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Darling,” he smiled, “how could I be under better auspices than the head of the Prussian state?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know what I mean! You’ll be getting mixed up with those friends of Freddi and Hansi again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had thought carefully what he would say, and had learned a number of formulas. “My dear, I have important business to transact and I’m not going to let anything interfere with it. If I do this job, the old pirate may give me others. Don’t forget that Germany is a treasure-house of great art, and America can use a lot of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lanny, I tell you I couldn’t stand anything like you put me through before. I’ve got to make that plain to you. I can’t stand it and I won’t!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He knew that he had to grant her the right to say it all over again; it is a part of the duty of husbands to hear about their past sins. It is the part of wisdom never to argue, or question any statement, however inexact it may seem; merely utter soothing words, and the fewer the better—Mother Nature having apparently planned women to talk and men to listen. “Yes, dear,” he repeated. “I’ll take the best of care of myself, and not stay a moment longer than necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Irma wanted him to take a train; but he liked to drive, even in January. He paid no attention to the weather—unless it was a blinding snowstorm, he went right through. He would need only one day in Berlin, and he wanted to bring the paintings out with him, and have them packed and shipped from France—trusting no one in Naziland. If anything delayed him, he would telephone without fail; meanwhile Irma would be gossiping with the Duchesse de Ceci and the Comtesse de Cela, and on the way to Bienvenu she would entertain him with all the latest scandals of the "), _c('i', [_vm._v("haut monde de Paris")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He motored without incident, and saw once more the factory chimneys of Germany, pouring forth smoke day and night; also the patient people, performing whatever hard tasks were assigned them, and winning the sympathy of an American who rarely had to do anything except what his fancy dictated. He arrived late, spent the night at the Adlon, and in the morning telephoned the Oberleutnant, a sort of glorified secretary in military uniform, who met him by appointment at the palace. Up to twenty months ago this marble edifice had belonged to a Jewish "), _c('i', [_vm._v("Schieber")]), _vm._v(", and in it Lanny and his wife had eaten and drunk delight. Now it was the home of the fat General’s lady favorite, a darling of the German stage and screen; Lanny’s taste was all over it, and he hoped the statuesque blond beauty appreciated what he had done for her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two paintings, "), _c('i', [_vm._v("Head of St. John")]), _vm._v(", a fragment of a larger picture by Tiepolo, and "), _c('i', [_vm._v("Parliament Buildings on the Thames")]), _vm._v(" by Monet—curious contrast of old and new—had been taken from the walls and set aside for him. He examined them and made sure they were what he wanted; then he put a bank draft into the Oberleutnant’s hands and took the bills of sale which had been signed by the Minister-President’s personal disbursing officer. Lanny wrapped the precious works in two oilcloths he carried for the purpose, and two uniformed lackeys bore them to his car. “You can show these documents at the border,” said the staff officer, “and if there is any question about it, tell them to phone me.” Lanny thanked him, asked after his family, answered questions about his own; they smiled, bowed, shook hands, and parted the best of friends.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny was returning to Paris, but he chose a devious route, not prescribed in any motorist’s guidebook. He turned a number of unexpected corners, and ended up in the Moabit district exactly at noon. As he passed a certain corner, there was a young woman in a worn brown coat, with a bundle of sketches in the crook of her left arm. He passed her and stopped as before; she stepped in without a word, and away they went—but not toward Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny watched in his little mirror, while Trudi sank low in her seat to make herself inconspicuous, and turned her face toward him so that it could not be seen by persons passing. “Lanny,” she exclaimed, “it is so kind of you to take this trouble!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My expenses are being paid,” he replied, amiably. “I have two paintings in the back seat, for which I have just paid your Air Kommandant the sum of forty thousand marks. It means that I have four thousand for you, if you can use them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have used most of what you gave me, and to good purpose.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“O.K. Is that why you wrote me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No—something even more important. Are you sure were not being followed?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll take another turn,” he replied. The car roamed here and there about this old working-class district of the "), _c('i', [_vm._v("Hauptstadt")]), _vm._v(". “All clear!” he said, in American. “Shoot!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have some documents of a most confidential nature which I thought you might be able to put to use. They are photostatic copies of reports to Goring’s office, showing production of military planes in violation of the Versailles treaty. You perhaps do not know that we are manufacturing certain types of transport planes in Germany, while in Sweden the same types are being made for our government, but having armament; they bear the same type numbers, but the armored ones have the initial K, that is, "), _c('i', [_vm._v("Krieg")]), _vm._v(". With these documents you can prove that Goring is getting more warplanes than France and Britain combined.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Holy smoke!” said the art expert. “How do you get such things?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is one question you are not permitted to ask. Suffice it to say that all our friends are not yet dead, or even in concentration camps. Old-time party members come to us; some of them have turned Nazi as a camouflage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is pretty risky business, Trudi.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They risk their lives, and so do we. Whether you care to help us is for you to decide.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you want me to do with the documents?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is a field altogether strange to me. I should think the information would be of interest to the military authorities of France and England.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anyone would suppose it; and if I tell you that they might do nothing about it, you would be shocked. But I know some of them, and they believe what they want to believe and nothing more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even if you put the documents into their hands?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They would want to know how I got them, and if I didn’t tell them, I’m afraid they’d begin to suggest they mightn’t be genuine. All intelligence departments forge documents for their own purposes, and naturally they are sure that others are doing the same. They can’t trust any anti-Nazis, because they have the same sort of people in their own country and fear them even more than they do Hitler and Goring.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I haven’t told you everything yet,” said Trudi. “I have photostatic copies of Wehrmacht intelligence reports, sent in by agents in Paris and London, giving data as to the situation of military objectives such as oil-depots, gas-tanks, arsenals, and other bombing-targets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, my God!” exclaimed the American.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They are evidently the results of surveyor’s work; that is, they tell you, so many meters north-northwest of some prominent object—things like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are they in code?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They consist entirely of names of places, distances, and directions. They are abbreviated, and for place names they give only initials. The person who brought them to us has supplied interpretations which make it all quite clear. One hundred and forty-seven meters due north of such and such a station of the Paris Metro there is an oil-storage depot; so and so many feet southeast of the south entrance to Waterloo Bridge there is a warehouse full of explosives—things like that. Don’t you suppose that might be of importance to the English authorities?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve no doubt they’d read them with great interest,” replied Lanny, “and doubtless would check them carefully. But would they do anything that made any real difference? You should hear my father talk about the British brass-hats, their dumbness, and their utter, impenetrable complacency. It is beneath their dignity to worry or even to take precautions about anything. They are as solid and as self-satisfied as their own Rock of Gibraltar.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny took his friend for a long drive, discussing every angle of this complicated problem. His final decision was that the documents ought to be published in some paper. The brass-hats wouldn’t fail to read them, and the public clamor would stir them up, if anything could.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trudi had but one objection. “It might be pretty hard on the person who got them for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does he imagine that you can turn these documents over to the British or the French military authorities and not have Goring get wind of it in a few days? Just as you have spies in his office, so he has equally efficient ones in every army and navy headquarters in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I suppose so,” admitted the woman. “We may have to get our friend out of the country.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me suggest something I thought of while I was figuring out ways to help Freddi. Devise a scheme to cast the suspicion on some good Nazi official. That is a way to confuse them and break them up.” When she did not answer, he added: “Tell me this: have you the right to let the documents be published?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was told to make whatever use of them seemed best.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very well; I’ll take them on that basis.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think you can get them out safely?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It happens that I am in position to do so. There’s no use going into details.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You must be careful, in disposing of them, that there’s no trail leading to you; for surely the Gestapo will get busy with all their resources, and if they trace it to you, you’ll not be able to come back here again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand, and I think I know a way.” She had told him not to ask questions, and now he showed that he had learned the lesson. “I wasn’t bargaining for anything like this, but I see it’s important, and you may count on me to do my best. If I fail, it won’t be from lack of careful thought.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("That subject settled, he told her about a stout old woman, widow of a butler in the home of a Warsaw merchant. Trudi had heard all about Lanny’s interest in spiritualistic matters; it had been part of the gossip concerning the rich American couple, and had cost him a good part of the respect which the comrades might otherwise have felt for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have never given any thought to such matters, Lanny,” she said, taking no chance of offending him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, but you’re going to give some now. Last week I had a seance, hoping to get Freddi, and instead I got a voice that said he was Ludi.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Ach, Gott!")]), _vm._v("” He felt her start. “Did it sound like him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not especially; but it usually doesn’t. What I did was to ask for a sort of password; something that you would be sure to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And he gave one?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He said to tell you ‘Chin-Chin.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sat up, forgetting about the traffic and the possibility of being seen. “Oh, Lanny, how amazing!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You recognize it, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was a little Skye terrier we had.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He barked with great excitement—short, quick barks—you’d almost think he was crazy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did Ludi say that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He did it. At least there was a lot of barking, and when I asked if it was a dog, he said: ‘It was me.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman sat with her hands pressed together until the knuckles were white. “Lanny, that takes my breath away! Ludi used to play with the dog; he would get down on his hands and knees and bark at him, and the dog would bark back, and you could hardly tell one from the other. It used to terrify me, because the dog became so excited, and I was afraid he might bite Ludi’s nose.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ludi said: ‘People do silly things when they are young, and happy, and very much in love.’”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman bowed her head in her hands and began to weep silently. It was too much, hitting her all at once. The fact that Ludi was dead—and the fact that he was alive! But was he? Right away arose those doubts which torment people who begin to consider the possibility of survival; especially when they have built their faith upon the dogma of materialistic interpretation—not merely of history, but of psychology, and of everything else on, under, or above the earth!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman began to stammer questions through her tears. Did Lanny really believe it was Ludi? What else had he said? Did he say what had happened to him at the hands of the Stormtroopers? And what was happening to him now? She was ashamed of her tears, because she was certain that it was all nonsense; but even to think about it was more than she could bear. The strangest paradox imaginable: she couldn’t believe that Ludi was dead unless she first believed that he was alive, and she couldn’t believe that he was alive unless she first believed that he was dead! And which did she want him—dead in this world and alive in a future, or alive in this world and certain to be dead before long? Also, which was more precious to her, love for her husband or love for Marxist doctrines?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny couldn’t solve those problems for her. He could only tell her everything that had happened, every word that had been spoken. They were out in the snowbound country by that time, and he drew up by the roadside and consulted his notebook to verify details. Then she wanted to know about Madame from the beginning, and those strange phenomena the very thought of which had bored her two or three years ago. Zaharoff and his duquesa, Lady Caillard and her husband—“Vinnie, Birdie, and a Kiss!”—and then about Johannes’s Uncle Nahum, and all the other shadow figures who had haunted the personality of Madame, like so many bats in the twilight, fluttering past a light and then out into darkness again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lanny, I must meet that woman!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have brought her to Berlin more than once, and it may be possible to do it again. Meanwhile, here is something you might do.” He told her how he and his wife had each of them visited a different medium in Berlin at the same time, and had got what was called a “cross-correspondence”; that is, two parts of a message which fitted together, in this case a verse from the Bible. One of these women was fashionable and high-priced, but the other was poor and obscure. Lanny consulted his notebook and wrote down her name and address for Trudi.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t say an unnecessary word,” he advised. “Give a false name if she asks. Pay her five marks or whatever she charges, and sit still and listen to what she says.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Immediately the Marxist conscience of Trudi Schultz began to trouble her. “Lanny, it seems wicked to spend money for such things when the cause needs it so badly!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m interested in this subject,” replied the young plutocrat, with a grin. “I make it obligatory—like the liter of milk every day! By the way, I see you have been getting that, for it shows in your face.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny gave his friend the money he had brought, and then deposited her in the vicinity of a station of the Underground from which she could get to her home. Then he set out toward the west, and when he was out in the country he stopped and unwrapped the documents which Trudi had left with him, freight more dangerous than so many cans of nitroglycerin. With tools in his car he took off the cover from the back of a picture frame, spread the documents flat against the back of the canvas, and tacked the cover into place again. It wasn’t a perfect job, but he counted on the priceless bill of sale with the letterhead of the Minister-President of Prussia and the official stamps and seals, so overwhelmingly impressive to every German functionary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wasn’t going to Paris, but to Amsterdam, an orderly and well-conducted capital a safe distance out of Naziland. As he drove he tried to imagine all possible mishaps which could occur at the border, and to rehearse what he would do and say in connection with them. By no means the best thought companions on a cold January day with flurries of snow in the air making careful driving imperative. He made up his mind to take the most haughty of attitudes; to stand on the prerogative of his expensive car, his impeccable clothing, and above all his almost divine document. Under no circumstance would he permit anyone to lay profane hands upon the precious paintings; he would produce a veritable tornado of "), _c('i', [_vm._v("Donnerwetter")]), _vm._v(" and threaten instant loss of office to the underling who dared to defy his commands. He would compel that person to telephone immediately to the Minister-President’s staff officer; or, if this was refused, Lanny would insist that they wait until he had had opportunity to do so himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But all this worrying proved entirely unnecessary; such mishaps simply do not take place under "), _c('i', [_vm._v("deutsche Zucht und Ordnung")]), _vm._v(". The fine car drew up in front of the painted pole which barred the highway, and the driver descended to meet the officials who came forth from the station. It was dark, and snow was falling; there were dim shadows while he stood in the rays of a flashlight. He swung up a stiff right arm and declaimed: “"), _c('i', [_vm._v("Heil Hitler!")]), _vm._v("” They answered—it was obligatory, also automatic. He dropped his arm again, and in his best German announced: “I am an art expert”—fortunately the Germans have a full-sized and impressive word, "), _c('i', [_vm._v("Kunstsachverstandiger")]), _vm._v(", literally, “art-object-understander.” He went on: “I have traveled to Berlin at the request of Minister-President General Goring and purchased from him two art works which I have in this car. I am instructed by Oberleutnant Furtwaengler of the Minister-President’s personal staff to present to you this bill of sale for the works as evidence that the matter is according to command—” "), _c('i', [_vm._v("befehlmassig")]), _vm._v(", another impressive word. “Here also are my passport and my exit permit, which has been signed by the Minister-President’s office.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Sehr wohl, mein Herr")]), _vm._v(".” They fell over themselves. Nothing so momentous had come their way in many a week. “"), _c('i', [_vm._v("Will der Herr nicht hinein kommen?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll wait and stretch my legs,” said Lanny. “"), _c('i', [_vm._v("Heil Hitler!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Heil Hitler! Heil Hitler!")]), _vm._v("” They didn’t even ask if he was taking out money or anything else that was "), _c('i', [_vm._v("verboten")]), _vm._v(". They hurried inside, and never were documents inspected and stamped so promptly. Others came out to have a glimpse of the wonderful car and the wonderful Herr who only a few hours previously had been in the actual presence of the Godhead; not El Shaddai, the Terrible One, but the Teutonic Odin, God of the Furious Host. The documents were returned with bows, and Lanny took them and put them with slow dignity into an inside pocket; he stepped into his car, the barrier was raised, and he rolled into the Koningrijk der Nederlanden.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("In a comfortable room in the Hotel Amstel Lanny put in a midnight call for Eric Vivian Pomeroy-Nielson at The Reaches. He felt safe now—if the Gestapo hadn’t been interested to follow him in Berlin, they would hardly be doing it here. “Excuse me if I woke you up,” he said. “I’m in Amsterdam on picture business, and Irma is waiting in Paris. There’s something I need your advice about. Can’t you and Nina take the Harwich ferry tomorrow evening? I’ll meet you at the Hook in the morning and drive you to Paris and we’ll have a lark.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I’ll be damned!” said the baronet’s son.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t explain it, but it’s important, and you’ll understand when I see you. Don’t say anything to Nina about it, just call it a holiday and let me pay the bills—it’ll be worth it many times over to me. If she can’t come, you get somebody to motor you to Harwich and let me pay for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You must have sold some big pictures, old top! It’s a date!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny called his wife and told her of this arrangement. She said: “Oh, goody!” and felt no surprise because people jumped here and there in search of pleasure. She herself had just got back from a theater party with Denis de Bruyne. Lanny said: “Furtwaengler sent his love—I believe you have made a conquest.” He laughed, because he could imagine the "), _c('i', [_vm._v("moue")]), _vm._v(" she would be making. She regarded the Nazi staff officer as what the Germans call an "), _c('i', [_vm._v("Emporkommling")]), _vm._v(", a “little upcomer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny had the two paintings brought to his room with him and now he took off the back of one and spent a good part of the night studying the photographs—twenty-four sheets, carefully selected. He thought: “If this doesn’t wake up the British and French, they’ll deserve what is coming to them.” He thought of the model airplane factory his father was planning, and had an impulse to go and help. But no, what he was doing was better. Set up a big alarm bell and start it ringing!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He slept with the documents half under him, and in the morning he borrowed a needle and thread from the chambermaid—having a hard time persuading her not to do the work for him! He sewed the documents in several parts of his coat-lining, and then, feeling like a padded Chinese, he had his paintings carried down into the hotel basement and separately crated by the porter. He took them to the express office and shipped them, duly covered by insurance; after which he went for a walk in this fine old city of frozen canals and snow-covered trees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the Ryks Museum the kindly authorities had provided comfortable plush-covered benches upon which an art expert could sit for hours and study the fine points of several of the world’s great masterpieces. During his lifetime the creator of these works had been treated none too well; he had died bankrupt and miserable, but now he was honored, and his finest works were placed in separate rooms with ample space and perfect lighting. Amid reverent silence Lanny could lose himself in a time three hundred years gone, imagining himself in conversation with the five “Syndics,” members of the Clothmakers’ Company. This association had made good cloth and from it their tailors had made good clothing; the five gentlemen had put on their best, and their wives had seen to it that all the accessories were right, while an eccentric genius named Rembrandt van Rijn was immortalizing their features and figures. They looked out at Lanny with such life that he was prepared to have them speak, and was sure it would be a worthwhile conversation; for they were obviously cultivated gentlemen, who knew how to make use of their wealth and whose ideas were by no means limited to the quality and prices of cloth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In an adjoining and much larger room the visitor renewed his acquaintance with a great canvas, covering an entire wall, "), _c('i', [_vm._v("The Sortie")]), _vm._v(", sometimes known as "), _c('i', [_vm._v("The Night-Watch")]), _vm._v(" although it appears that the sun is streaming onto some of the accouterments and colored raiment of the watchmen. It is the painting which ruined poor Rembrandt, because the gentlemen who had ordered it wanted a portrait gallery, with each of their faces given equal prominence, whereas the bold painter had presumed to compose a scene. They were marching out to repel invaders; and Lanny had a hard time keeping his attention on the fine points of the art of applying paint to canvas, because he was thinking about the position of a small and civilized country lying alongside a powerful one which was rapidly sliding back into barbarism. He wanted to cry out to all the polite and friendly Dutch people whom he saw in this museum: “Keep your night-watch, and your day-watch, too, because the Nazis are making surveyor’s maps of all your bombing objectives! Do not give too much thought to splendid uniforms or other such details, because you may have to dig down into your everlasting mud to hide from bombs and grenades and flame-throwers and poison gas!”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Nina and Rick arrived, and Lanny bundled them up and drove them to Paris in time for lunch. Afterward the two ladies discussed their affairs in Irma’s room, while Lanny took his chum into his own and told him what it was that made his coat fit badly. After Rick had got over his amazement he said: “It’s ghastly, Lanny, but I doubt if we British will really do anything about it, because our governing class can’t make up their minds whether Hitler is good or bad—in other words, whether he intends to march east or west.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good God!” exclaimed the American. “If he’s going east what does he want with surveys of London and Paris?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, well, they’re all getting such data—that is, unless they’re too lazy, as I rather think we are just now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rick agreed that the only hope was to use the documents to stir up the public. An active journalist didn’t have to be told what an explosion they would make, and he offered to take them straight to a liberal editor whom he knew and who would give them ample space and advertising. But Lanny said: “You’ve contributed to that paper, so you will be one of the first persons the Nazis will set out to trail. They will find out that you came to Amsterdam right after I left Germany; and they may even find us registered at this hotel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Whoo-ee!")]), _vm._v("” said the Englishman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve given a lot of thought to the job, and it’s far from easy. You can’t imagine what efforts Goring will make to trace this thing down; he’ll stand the whole Gestapo on its head. If anything turns attention to me, they’ll watch me the next time I come into Germany, and get every person who meets me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right you are, son.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These documents have to be published by some paper with which neither of us has ever had anything to do; a paper without any left tendencies, so that Goring will decide that the job was done by respectable government spies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That will need some thinking,” declared Rick. “The "), _c('i', [_vm._v("Times")]), _vm._v(" has gone over to the pro-Hitler clique and the "), _c('i', [_vm._v("Daily Mail")]), _vm._v(" is practically a Fascist organ.” He went on to canvass the other papers, and finally chose one which he said was completely reactionary, interested in rearmament from the point of view of British Empire security. “Too bad to promote its circulation, but that can’t be helped. Hitler’s going to make strange bed-fellows in all the nations around him!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Said Lanny: “The documents ought to be taken to the paper, not by you but by somebody who is pledged never to mention where he got hold of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That also called for thinking. They discussed public men whom they knew, whether personally or by reputation, to find one who was honest, at least to the extent of being for England more than for himself. In the end Rick’s choice fell upon a member of Parliament whom “the pater” knew slightly; one of those Englishmen who manage to combine Church of England piety with capitalist-class politics and the construction of bigger and better dreadnoughts. Rick would seek a private interview with this statesman, vouch for the genuineness of the documents, and pledge him to deliver them to the newspaper publisher without any hint as to how they had reached England.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“By the way,” said Lanny, “I’m not saying anything to Irma about all this, and it might be just as well not to tell Nina.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“More than that,” countered his friend, looking him in the eyes. “Neither of us is going to say one word about this—ever. Shake hands on it and mean it!”")])])])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("THE DUSKY CLOUDS ASCENDING")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("There were three comfortable dwellings on the Bienvenu estate, the Villa, the Lodge, and the Cottage—the first being the home of the Dingles, the second of Lanny and Irma, and the third of Nina and Rick or other friends when they were free to come. Also there were two small structures known as studios, one having been built for Marcel and one for Kurt in the old days. Marcel’s studio was now occupied by Lanny, his books, piano, and music, while the other was for Hansi and Bess when they came, and otherwise for any noisemaker or other eccentric person whom it was thought wise to segregate. Lanny was always coming upon someone who claimed to have genius, and Irma had been told that it was a distinguished thing to have such persons on the place—only she begged that they wouldn’t be Reds or Pinks, because they brought such undesirable company. Since Lanny was trying to avoid displeasing not merely his wife but also a fat Nazi general and his secret police, he made a practice of meeting his off-color friends at some obscure lunching-place in the city of Cannes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bienvenu was an extremely humble affair according to Barnes family standards, but Irma put up with it for the sake of love and the climate. The main trouble was, there was no room for entertaining on what she considered an adequate scale, and outdoor affairs were subject to the whims of the weather. The problem was solved by a combination with Emily Chattersworth, who had two fine drawing-rooms at Sept Chenes, her Riviera home, big enough for dancing. Emily was no longer equal to the task of entertaining, yet she couldn’t bear to give up her friends or to neglect to make use of a celebrity when one came along. So Irma would come up and act as hostess, with the older woman to advise her. After some argument Irma had gained the right to pay for the “talent,” also for the food and drink. Emily’s staff of well-trained servants would do the work, and the utility king’s daughter would watch and learn every detail of the subtle duties of a "), _c('i', [_vm._v("salonniere")]), _vm._v(". That was the career she had chosen, and the experience would be equally useful whether she decided to apply it in Paris, London, or New York.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So a season passed pleasantly enough. Visitors came back to the Riviera, and costumes and jewels and titles were flaunted. Prosperity appeared to be reviving after a long financial drought. Franklin D. Roosevelt had been President of the United States for two years, and while the Supreme Court had thrown out some of his schemes, the general idea of free spending was coming to be accepted, even by those who scolded at it. The device enabled people to live, and after the fright they had had, that was enough. The masses got money from the government and spent it in grocery and clothing stores, and these in turn bought from the wholesalers, and these from the manufacturers; so it went, all the way down the line, and bonds which Irma owned began to draw interest and stocks to earn dividends. Each quarter her income was a bit larger, and all this reinforced her own firm conviction that money was made to be spent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("People gathered around, eager to help her spend it, and she was generous because that was so much the easiest way; she didn’t want glum or anxious faces anywhere in sight, and would put money in the bank to Beauty’s account and to Lanny’s, and if she found them trying to economize she would say: “What’s the big idea?” Living with or near the daughter of J. Paramount Barnes was like being on board one of those old-fashioned, full-rigged clipper ships with every sail set—a wet sheet and a flowing sea, a wind that follows fast, and fills the white and rustling sails and bends the gallant mast!")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The Saarland plebiscite was held in January, and resulted in a nine-to-one vote by the inhabitants in favor of a return to Germany. The district had always been German, and doubtless would have voted that way without the colossal propaganda campaign which the Nazis had put on. But the Nazis liked such campaigns, they were the breath of Nazi being, and they were practice for other campaigns which were scheduled for everywhere along the German borders. They included not merely speeches and music and marching, but also the boycotting of merchants and the terrorizing of opponents by brownshirted rowdies of the Deutsche Front, armed with revolvers, daggers, and hard-rubber truncheons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as the election results were announced, the Nazis prepared their “long knives,” and so most of the French population picked up what belongings they could carry and fled. Many came to the Riviera, because it was warmer and therefore a more pleasant place in which to starve. Many were of leftist tendency, and they hadn’t been starving for long before they heard about that extraordinary American family with a son and heir who had a tender heart and who was simply rolling in money, being married to one of the greatest heiresses in the world. So came numbers of begging letters in the Bienvenu mail, and many of them were heart-rending. Visitors came to the gates, and when they were told that the young master was not at home they would go away and put their wits to work on some method of getting hold of him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There had been a sort of amateur secret service at work on the Budd Family, and all the Reds and Pinks knew exactly the situation. The mother was a butterfly and a good deal of a fool, while the wife was reactionary, even Fascist in her sympathies; these two guarded the place like dragons and told all the servants not to let strangers past the gates. The time to catch Lanny was when he came to town; then if you pounced on him and told him a hard-luck story, he couldn’t say No. Another method of contact was through Raoul Palma, director of the Ecole des Travailleurs du Midi; so it came about that new persons joined the school and asked for jobs as teachers, with salaries however small. Lanny would give money to his Spanish friend, but always under the condition: “Do me the favor to pretend that you got it somewhere else.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("There came a letter from Rick, saying: “I have seen the gentleman whom I hope to interest in your pictures, and I think the deal will go through.” Then a second note: “The picture deal is O.K., and I believe you will be satisfied.” A week or so later the documents were published, in installments, day after day, and there was a tremendous sensation; the baronet’s son wrote about it freely, as he would have done if he had known nothing about the matter in advance. There were interpellations in Parliament, and vague answers to the effect that the government were taking cognizance—the English government were always plural, and also they were dignified, imperturbable, and slow to anger when they wanted to be. There was a new term coming into use for statesmen and officials who avoided getting angry with the Nazis; they were called “appeasers,” and the Nazis quickly found out who they were and made the most of their state of mind. Jesse Blackless had pointed out to his nephew the fact that those who were most afraid of displeasing the Nazis appeared to be least afraid of displeasing the Soviets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny got copies of the London papers, and clipped them and sent them to his father. “This looks to be genuine,” he wrote, “and ought to help sell your products when you get them ready.” Robbie replied: “Hot stuff, and if I thought it was genuine I’d send Johannes over now! Send me anything more of the sort that you come upon. Also, ask your fat friend about it the next time you see him!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ramsay MacDonald, still holding on as Prime Minister, made a speech protesting against German rearmament. Ramsay made speeches about many evils, and assumed that this was equivalent to abolishing them. Hitler made a speech in reply, telling how pacific were the intentions of his government; and all the appeasers said: “There, now, you see how he is being maligned!” Wickthorpe told Rick that Downing Street—the British Foreign Office—had made strong representations to the Wilhelmstrasse, and the Wilhelmstrasse had promptly denounced the documents as fraudulent. His Lordship added that he was inclined to accept this, and Rick was not in a position to dissent. Among other things Rick sent to Lanny was a clipping from a Left paper of London which said that, if the truth ever became known about these revelations, it would be found that aircraft manufacturers outside of Germany had had a hand in the preparation of them. Rick put some exclamation points in the margin of this, and Lanny Budd, son of an embryo aircraft manufacturer, didn’t fail to appreciate the humor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also, there came one of those plain-looking missives from Berlin. “Mueller” expressed her gratitude for his wise use of her sketches, and promised to make some more. Lanny knew that the circulation of English newspapers was still permitted in Germany, and while those particularly dangerous issues had doubtless been confiscated, the details would be known to both the Nazis and their foes. In the midst of the darkness of intrigue that covered Europe, you cast your bread upon the waters—such small crumbs of truth as you could collect—and wondered if the Preacher had been right and would you ever find them again, and where, and when, and how.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("There was a diplomatic chess-game being played, with the continent of Europe as the board; a new and immensely complicated kind of chess in which the pieces, instead of being lined up on opposite sides, had each his own color and played his own game. Each king, queen, knight, castle, even the smallest pawn, had his group of elder statesmen who put their heads together in anxious consultation, and after days and perhaps weeks of arguing they made a move; whereupon the whole aspect of the board was altered, and the statesmen of all the other pieces put their heads together and argued and agonized, until some group made a countermove, and at once the clamor of protest and the buzz of consultation started up afresh in all the other chess-chancelleries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Britain and France had been playing as partners, but were greedy and suspicious, each of the other, and Britain was willing to let Germany grow stronger in order to keep France from growing too strong. So France turned to Russia, which she hated, trying to work out a deal for common defense against a greater danger. Hitler and Mussolini, two upstarts jealous of each other, were ready to break all the rules of the game in the effort to grab something for themselves. Pierre Laval, fresh from a visit to Moscow, paid one to Rome, in which he cooked up a deal with Mussolini pledging them both to mutual assistance should Germany take what was called “unilateral action” in the matter of rearming. Meanwhile the British Foreign Secretary was angling for an invitation to Munich in order to negotiate with Hitler the terms on which Britain might grant him permission to rearm. Then, of course, it wouldn’t be “unilateral action”!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such was the state of affairs on the sixteenth of March, when Hitler in one of those sudden moves which Europe was learning to know to its terror, upset the continental chessboard by announcing conscription and universal military service in Germany; also that the army, which the Versailles treaty had limited to a hundred thousand men, was to be increased to more than five hundred thousand. At the same time he issued to the German people one of those flamboyant manifestoes, which to Lanny Budd was like hearing his raucous scolding voice. For the ten-thousandth time “Adi” recited the outrages of the Versailles "), _c('i', [_vm._v("Diktat;")]), _vm._v(" for the ten-thousandth time he repeated the tale which he had invented and taught to the German people, that the Allies had promised at Versailles to disarm themselves; for the ten-thousandth time he made that declaration of peaceful and honorable intentions which cost him nothing and was worth several army corps to him and his party:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In this hour the German government renews before the German people, before the entire world, its assurance of its determination never to proceed beyond the safeguarding of German honor and freedom of the Reich, and especially does it not intend in rearming Germany to create any instrument for warlike attack, but, on the contrary, exclusively for defense and thereby for the maintenance of peace. In so doing, the German Reich government expresses the confident hope that the German people, having again reverted to their own honor, may be privileged in independent equality to make their contribution toward the pacification of the world in free and open co-operation with other nations and their governments.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("A great many people thought that Adolf Hitler Schicklgruber was insane, and they wrote and talked that way concerning him. When Lanny’s friends asked him about this, he replied that it might be a question of definition. If Adi was a lunatic, he was one of that well-known kind which possesses and displays the utmost cunning. He had learned about the British habit of weekends, and so he made it a rule to announce his bold moves on a Saturday. No British statesman could possibly take action on that day, and every British statesman would have all day Sunday to pray over it, to contemplate the horrors of war and work himself into a state of conscientiousness. He would threaten and bluster, of course; he had to do that in order to be re-elected, but he wouldn’t take any action—so Adi figured.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a while Lanny Budd was fooled, and thought that the Versailles law—the only law that poor Europe had—was going to be enforced. The French government issued a call for common action, and French troops moved up to the German border. The British liberal and labor papers, those which Lanny read, all clamored for the ending of this intolerable menace. The statesmen rushed here and there like ants whose nest has been upset; they argued and scolded and issued high-sounding pronouncements. The French appealed to the League of Nations, whose duty it was to enforce the law, and the League summoned its Council to decide upon a course.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny, the optimist, cherished the dream that Nazism was going to be checked at last, and he was disconcerted by the letter which came from his English chum, saying: “What’s the use of getting excited about German rearmament when you know that it’s been going on for years? And don’t make the mistake of expecting any action from the sort of statesmen we have here. The British lion is old and has lost nearly all his teeth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny couldn’t believe it, and waited in a state of tension which threatened to interfere with his health. He composed a long letter to Rick, which caused his friend to protest: “No good convincing me. Convince Ramsay, the world’s worst maker of phrases! Convince Simon, the world’s worst pettifogging lawyer!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sir John Simon, British Foreign Secretary, had spent his long life confusing property-rights, and thought to confuse Hitler in the same way. Or, at any rate, so Rick said of him. The big Tory papers were all for “peace,” and they were the papers from which nine-tenths of the British people got their ideas. As for the League, it hadn’t stopped Japan from taking Manchuria, and wasn’t ever going to stop any greedy power from taking whatever it could. The Nazi tiger was coming out of his cage—one small step at a time, and very softly, on padded feet, purring most beautiful phrases about making his contribution toward the pacification of the jungle in free and open co-operation with other predatory beasts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny couldn’t give up his hope. How could a man go on living in a world such as Rick portrayed—a world governed by knaves or fools, or a combination of both? Something ought to be done, and Lanny was getting unhappy with himself about it. Here he was dressing up and helping to entertain his wife’s friends; taking her out to parties whose sole distinction was the amount of money which had been squandered upon them; exchanging words of little consequence with persons who were considered "), _c('i', [_vm._v("distingues")]), _vm._v(", not because they were wise or good, but because they had learned to spend their wealth upon highly conventionalized forms of costume and conduct. Lanny would drink tea, and dance, and bridle his tongue when political subjects were brought up. When he could stand no more of it he would go off to his studio and pound upon the piano—loudly enough to wake the ghosts of Marcel Detaze, who had painted the pictures on the walls of this studio, and of Great-Great-Uncle Eli Budd, who had willed Lanny most of the noble books which lined the rest of the wall-space.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma had come to understand that she had drawn an odd card in the marriage lottery. She knew that he had to let off steam, and didn’t allow herself to be disturbed by thunderous sounds rolling over the estate. But after an hour or two, when she thought he had had a good “workout,” she would appear in the studio door clad in a Chinese silk wrapper with magnificent embroidery, plus a pair of bathing-slippers, and holding by the hand a lovely little daughter who had just celebrated her fifth birthday with a party for all the aristocratic children of Cannes and the Cap d’Antibes. “Come on, Beethoven,” she would say—or Chopin or Liszt, as she happened to guess. And of course Lanny couldn’t resist such condescension; he would slip into his bathing-suit and they would race down to the blue Mediterranean, the temperature of which was exactly right at this time of the year. So the grandson of Budd’s would forget the world’s woes and follow the advice offered to Alexander the Great:")]), _vm._v(" "), _c('p', {
    staticClass: "left-4"
  }, [_vm._v("Lovely Thais sits beside thee,")]), _vm._v(" "), _c('p', {
    staticClass: "left-5"
  }, [_vm._v("Take the good the gods provide thee.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Now and then, in some newspaper or magazine—mostly the leftward and wishful-thinking ones—Lanny would come upon some reference to the underground movement of Nazi Germany and the great success it was having; then something would warm up inside him and he would have a few hours of deep inward peace. He dictated letters and mailed out copies of photographs of paintings which he recommended to his clients, and by April he had found purchasers for three more of Goring’s works. He was beginning to worry about not hearing from his fellow-conspirator; but at last came a note like the others: “If you see Herr Schmidt, the art dealer, tell him that I have some more sketches, which I hope he will interest himself in. Mueller.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny had been preparing his wife, telling her of the orders he had got and suggesting a trip to Germany in the spring. Irma, for her part, had been preparing a more elaborate program. Her mother in the Long Island palace was clamoring about being neglected and not having seen her adored granddaughter for nearly a year. Irma had been afraid to take the child to America for fear of kidnapers; but now these seemed to have been all caught, and Irma wasn’t the sort of person to stay worried about anything very long. Said she: “Let’s go and spend at least part of the summer, and see how Robbie’s getting along with his job.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They would visit Berlin and then sail from Bremen, or from London in case Lanny wanted to see Rick. They would motor, of course; and just as they were discussing whether to go by way of Paris or Vienna, there came a postcard from Pietro Corsatti, American-born Italian who represented a New York newspaper in Rome. They hadn’t heard from him for a long time, but would never forget him because of the part he had played in helping to get them married. Now he wrote on a picture postcard showing an alluringly colored scene, a blue lake, a little island with a huge vine-covered palace having a red roof, and behind it green mountains capped with snow. “Isola Bella” was its name—Beautiful Isle—and underneath it “Pete” had written: “Another gab-fest. Why not come and listen in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma, who rarely read the newspapers, didn’t know what this meant; Lanny explained that at Stresa, on Lago Maggiore in the Italian Alps, the statesmen of Britain, France, and Italy were assembling in the effort to agree upon a program to tie Hitler down and make him behave. Pete’s suggestion struck a spark in an amateur publicist’s soul. Over a period of many years he had been wont to grace these international gatherings with his airy presence; he knew most of the correspondents and some of the diplomats, and it was fun to watch history in process. He said: “Wickthorpe will probably be with the British staff.” Irma replied: “Let’s go!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After their fashion, at half a day’s notice, they tossed their things into their bags: winter things as well as summer, because, while it would be warm in Italy, there would be heavy snows in the Alpine passes. No need to make detailed plans; they would go like the wind, where they listed, and in due time would write or wire instructions for their packing, and for the twenty-three-million-dollar child and her staff. Beauty was staying on at Bienvenu, having not yet decided upon plans for herself and husband; she might be in England visiting Margy when Irma and Lanny arrived. Such was the delightful way of the rich. When a hot spell came, they picked up and moved to the north; when chill winds arose, they fled south again; they were birds of passage, beautiful and elegant birds of passage for whom the modern world had been made.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("First the route along the Cote d’Azur, to Lanny as familiar as the letters which composed his name. Then the Italian Riviera, full of exciting memories. All border passport controllers had little books with alphabetical lists of undesirable characters; but Lanny’s sins were eleven years old, and he trusted that the list wouldn’t go back that far, and it didn’t. Up through the passes to Milan at the loveliest season of the year, with fruit trees in full blossom, turning the humblest garden into a place of magic, filling the air with delicious scents. Lanny loved this country and its people—at least the poor ones, so cheerful and friendly—and he jabbered away with them whenever he had a chance. If he hated those in authority he kept his mouth shut—even when alone with his wife, who considered all authority as necessary, or it wouldn’t exist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny knew the beautiful mountain lake, forty or fifty miles long. Stresa is one of its smaller towns, popular with tourists and crowded with tile-roofed villas and hotels. They hadn’t wired for accommodations, because Lanny thought his name might attract the attention of his old enemies, the Fascist "), _c('i', [_vm._v("Militi")]), _vm._v(". There were plenty of other resorts along the shore, and no trouble to drive a few miles. The precaution proved wise, for never had a conference been so thoroughly policed. Perhaps it was the recent killing of King Alexander and Barthou; Mussolini was harboring some of those conspirators and protecting them, but when he himself was on the scene it was quite another matter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here in Stresa the "), _c('i', [_vm._v("carabinieri")]), _vm._v(" were everywhere, and in hotels and other public places were swarms of men whom no one had trouble in recognizing as detectives. The sessions were held on a tiny island having one great palace and nothing else, so there was no difficulty in protecting its secrets; motor-boats with armed police kept intruders away, and an airplane overhead made certain that no adventurous revolutionist dropped bombs on visiting statesmen. Lanny and his wife arrived after dark, and the first thing they noted was searchlights in the sky and others sweeping the surface of the lake from motor-boats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny thought it the part of wisdom to establish his social status; so, as soon as they were in their suite, he put in a call to the hotel which had been set aside as headquarters of the delegations. It was evident from the sounds on the telephone line that one or more persons were listening in, and that was what he wanted. He asked for the secretary of Lord Wickthorpe. “Certainly, Mr. Budd, I am sure His Lordship will be glad to speak to you.” Then, after a wait: “His Lordship wishes to know if you and Mrs. Budd will come for tea tomorrow afternoon.” After that, Lanny could be sure that, however carefully the authorities might watch him, they wouldn’t request him to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("At these conferences there was always a press headquarters, a sort of clubhouse for the swarms of correspondents. Thus it was easy to get hold of Pietro Corsatti. Would he have dinner? Indeed he would; but why not come with Pietro and meet some of the bunch? This pleased Lanny more than anything; it had been his function to pay the bill, and his privilege to listen while the men who knew what was going on in the world shared their “tips” with one another. Most of them had known the grandson of Budd’s over a period of years; he wouldn’t betray any confidences, and if they mentioned him and his plush-lined wife as among the visitors at a diplomatic “gab-fest,” that would enhance the prestige of a budding "), _c('i', [_vm._v("Salonniere")]), _vm._v(". The newsmen liked Irma because she was easy-going and informal, having been trained in cafe society; they cultivated Lanny because he had social contacts which might make him a source of news.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The correspondents were having the devil of a time here at Stresa, they reported. Never had speech-making statesmen been kept so aloof as out on that island, where Napoleon had once entertained an Italian diva. The future of Europe for a hundred years might depend on what they were deciding, but the information you got was contradictory, and the Americans were having to pad their dispatches with accounts of Blackshirt parades and the loveliness of almond blossoms. The journalist with an Italian name and a Brooklyn accent cried desperately: “For Pete’s sake, get Wickthorpe to spill some beans!” Lanny replied: “For Pete’s sake, I’ll do what I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Laval and Flandin were representing France; a queer pair, one squat, the other several inches taller than anybody else and that much duller. Pete said they were the calamity twins of France, and MacDonald and Simon were the same for England. Il Duce was here, representing himself; he had just issued decrees doubling his own army, and now France and England were trying to buy him to some program that would at least look like restraining Hitler. What price was Musso demanding, and how much of it was he going to get? These were the questions which tormented the journalists; and the extreme secrecy meant bad luck for somebody. Austria, perhaps? Or was it Abyssinia? “Poor niggers!” exclaimed one of the Americans; he had read Thoreau in his youth, and didn’t like killing, but fate had made him into a war correspondent, and his editors had sent him here because they thought that something was “cooking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few months ago there had been an “incident” at a place called Ual-Ual, which wasn’t in any gazetteer, and which consisted of a well and some mud-huts in the Ogaden Desert near Italian Somaliland. Native troops accompanying a border commission had driven some Italian troops away. This had been an insult to Il Duce’s dignity, and his kept press denounced the intolerable conditions of disorder existing in this backward land. To watchful editors it meant that Mussolini was getting ready to start that empire which he had been promising his young Blackshirts for a matter of twelve or thirteen years. Pete pointed out that the headwaters of the Nile are in that land, and surely Britain wasn’t going to let anybody dam them and divert them from the cotton-fields of the Sudan!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So they argued, outspokenly, and Il Duce’s badly disguised detectives sat at near-by tables and listened, scowling. Lanny, the most vulnerable person there, said the least. Later in the evening they heard shouts in the square outside, and they left the "), _c('i', [_vm._v("trattoria")]), _vm._v(" and joined the throngs which were hailing their stuffed-shirt leader. “"), _c('i', [_vm._v("Duce! Duce!")]), _vm._v("” They made it into a sort of chant, accenting and spacing the two syllables equally, so that nobody could have been sure whether they were saying “Doo-chay” or “Chay-doo.” The great empire-builder was in a hotel in front of them, and presently he appeared on a balcony, clad in breeches and riding-boots. Appearing on balconies is one of the principal functions of a dictator, and always a spotlight is ready to make him look grand in his shiny uniform—even if he is rather short and thick through the middle like the leader of the Fascisti.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fifteen years had passed since Lanny had first seen this man of destiny in San Remo, a thin, pasty-faced fellow with a little black mustache and a black suit and tie; a renegade Socialist editor, being cursed in public by one of the men he had betrayed. Now, walking on the Promenade with Irma and their friend, Lanny told the story of this encounter, and what he had learned about the “Blessed Little Pouter Pigeon” from a couple of his former associates. Before the World War he had appeared in Milan, a wretched half-starved youth whining about his syphilis, and the Socialists had taken him in, fed him, and taught him all he knew. Now those Socialists were dead, or in exile, or slowly dying on barren rocky islands in the Mediterranean; but this new Caesar was grown so great that he appeared on illuminated balconies, and when Americans wished to say what they thought of him they had to refer to him as “Mister Big.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("In every town where a conference took place there was always some resident English family of social acceptability, to whose home the wearied statesmen might repair for refreshment. Wickthorpe’s secretary phoned to Mr. Budd, saying that he and his wife were invited to such a home on the lake-shore. They were received by an elderly lady and her two unmarried daughters, and introduced to other English residents—the hostess had made friends or enemies for life by extending or withholding invitations to this affair. Members of the diplomatic staff drifted in, including the gray-haired and mustached Prime Minister whom Lanny Budd looked upon as a pathetic renegade; but the renegade didn’t know it, of course, and bowed graciously, saying: “Ah Amer-r-ricans! I am r-r-really fond of your country.” Tea was served in lovely Dresden cups, and in addition to little cakes there were scones in honor of a Prime Minister who came from Lossiemouth. They were passed around by means of a wicker table mounted on rubber-tired wheels and called “the curate,” because its invention had deprived large numbers of amiable young Englishmen of their principal social function.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wickthorpe was glad to see them, and was especially attentive to Irma, in a dignified and respectful way. He had always behaved thus, and Lanny’s mother had observed it and had hinted at it tactfully to her son; but Lanny wasn’t going to worry about any such matter—Irma had always had hosts of friends, both women and men, and how could people help admiring her? “Ceddy,” that is, Cedric Masterson, fourteenth Earl of Wickthorpe, introduced her to distinguished persons, including the long and clerical-looking Sir John Simon. Lanny saw the ladies watching and putting their heads together, and knew they were saying: “That’s Irma Barnes, the American heiress.” They would look at Lanny and add: “That chap is her husband—some sort of art broker, they say.” No use expecting people to say kind things behind your back in fashionable society, for they have social positions to guard and would cheapen themselves if they allowed too many to break into the sacred precincts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was Saturday afternoon, and everybody seemed to have plenty of time. Two distinguished diplomats played croquet with young ladies on the lawn, and others sat in groups under blossoming magnolia trees and talked about friends at home. Wickthorpe introduced Lanny to a couple of young fellows who were filling the same role of secretary-translator which the American had played in Paris at the age of nineteen. They and His Lordship talked freely about what had been happening on Isola Bella—it had all been settled that morning, it appeared, and the conference was ready to adjourn. The independence of Austria was to be guaranteed, and the three powers pledged themselves to oppose “by all practicable means” an evil thing called “unilateral repudiation of treaties.” That meant, of course, Hitler’s recent pronouncement about rearming; and Lanny was greatly heartened—until he began thinking about the word “practicable.” He had been among diplomats enough to learn how they said something which seemed to mean something but didn’t; how they put in weasel words which would sneak away with the substance of any sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just what is practicable right now, Ceddy?” he inquired; and the answer was: “Oh, well, you know we don’t want to get into a war.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hope not,” said Lanny. “But suppose Hitler won’t stop for anything less?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, but he’s got to, old chap. If we fight Hitler, we’re both playing Stalin’s game.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I know. But if you don’t fight, maybe you’re both playing Hitler’s game.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They had no time for further discussion. As Wickthorpe was turning away he remarked: “I say, Lanny, you understand that what we’ve been talking about is strictly under your hat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, of course,” said the other, with a pang for his friend Pete. “But, if it’s settled, why don’t you give it out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you see, some of our leading papers don’t publish on Sunday, so we’re holding the announcement for Monday morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The news was released in due course, and the diplomats entrained for Geneva, where the Council of the League was due to meet, and, it was hoped, take a firm stand against the violators of law. Brass bands played the delegates out of Stresa, and marching throngs of Fascisti sang to them of the future glories of Italy. Lanny and Irma bade farewell to their friends and set out through the Alpine passes on the way to Vienna. It was the season of spring floods and avalanches, which are no respecters of social position; but Lanny was a skilled driver and Irma was not the nervous sort, so they enjoyed some of the world’s most celebrated scenery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Vienna he had an appointment with one of the old empire’s nobility who had at last consented to put a price on some of his art treasures. They were invited to tea in one of those half-abandoned marble palaces on the Ringstrasse, and looked at old masters and argued over what they would bring in the American market. This displayed an elderly aristocratic couple in the worst of lights to Irma Barnes; but they had the titles and manners and there could be no denying that they had once had the “stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poor souls, they had lost the war, and it was necessary to treat them with great consideration. What seemed small sums to a utility king’s daughter were of the utmost importance to them, and they suffered agonies of soul under the process of deflation which Lanny felt obliged to put them through. “If you really want me to make sales, this and this and this is what you will have to accept.” They wanted so badly to get an offer; but Lanny was immovable. “I do not make offers. I tell you that at such and such a price I will try to find you a buyer; but you must make the offer.” In the end, close to tears, they gave way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A night at the opera, and next day the motorists were at the Polish border. It wouldn’t do to pass so close to the Meissners without stopping, so Lanny telephoned to Kurt and, learning that he was going to Berlin to conduct one of his works, invited him to come along in the car. Driving to Stubendorf, Lanny said: “Let’s not say anything about having stopped in Stresa. They will look upon that conference as an anti-German conspiracy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma, a comfortable person, well satisfied with the world’s arrangements, wished that people wouldn’t quarrel and upset everybody’s peace of mind. She was inclined to take the point of view of those she was with; at least to let them think that she did so. She was sure there ought to be some reasonable settlement of Germany’s claims, but she hadn’t insisted upon it while having tea with the fourteenth Earl of Wickthorpe and his colleagues. She would agree with the Meissners that Stubendorf ought certainly to be allowed to go back to Germany; but if she had been visiting one of the Polish families of the district—well, she hadn’t met any Poles, and their case wasn’t clear to her. Both sides had factories, and both needed the coal which came from the mines under these hills. “Why can’t they buy it from each other?” she wanted to know, and Lanny mentioned that profits go to those who own and not to those who buy. “You ought to know that!” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The arrival of this fashionable American couple always created a stir in Stubendorf. Seine Hochgeboren was away, so they stayed the night at the home of Kurt’s father, the Comptroller-General of the great estate. They slept in the rather small room which had been Kurt’s, and which Lanny had shared with him on his first Christmas visit more than twenty years ago. The Meissners were warm-hearted people, and they still saw him as the gay and graceful lad who had shown them Dalcroze dancing and amused them with his American accent. He hadn’t known that he had one, of course, and they had never told him, but had cherished his quaint phrases after he had gone. Now he was here with his heiress wife, and since the pair had been guests several times at the Schloss, it was doubtful if the family of a mere "), _c('i', [_vm._v("Beamter")]), _vm._v(" was good enough to receive them. A lot of fuss had to be made and extra food prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kurt and Lanny played music out of the treasury of four-hand compositions. The family all sang for a while, and it was so lovely that tears ran down the cheeks of the old couple. The father’s heath was failing, and he wasn’t going to listen to music much longer, at least not played on the old piano in his somewhat crowded livingroom. They didn’t spoil that sentimental evening with talk about politics or anything in the ugly outside world. Irma thought: “Now I am meeting the real Germans; and oh, dear, why can’t they stay like this always?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But no, indeed; Germany was ringed with enemies—"), _c('i', [_vm._v("die Einkreisung")]), _vm._v(", they called it—and they were getting ready to break that ring. In the morning the travelers shifted their bags so as to make room for Kurt in the back seat and they drove into Germany. First they were held up by not very prompt or courteous Polish border guards, and Kurt said: “You see what we have to go through.” Then, on the first level plain they came to, uniformed young Germans were drilling in the yet unmelted snows. None of the travelers commented, but all three were thinking: “It is the big new army the Fuhrer has promised!” Later they passed an airport, and planes flew close overhead, as if inspecting a foreign car and its occupants; all three of them thought: “The new fighter planes of General Goring!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They talked about music, and the paintings that Lanny had handled, and about Robbie’s new business undertaking. Kurt was always glad to hear how Beauty was getting along; he said that she had saved his life after the war, and in the Continental fashion he spoke frankly about the years of happiness she had given him. Once when a sparkplug fouled and they stopped to have it fixed, Irma and Kurt strolled up and down and she told him: “Lanny is behaving much better, and I am really happy about him.” She meant it, for like most humans she found it easy to believe what she wanted to. Sometimes it appeared as if life could hardly have gone on in these days of old Europe’s trials if it hadn’t been for this odd human faculty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kurt didn’t wish to stay in a fashionable hotel; he had already promised to visit the family of his brother Emil, a colonel in the Reichswehr. He was going to be busy with rehearsals, which his friends might attend if they would be interested. Nothing would have pleased Lanny more, but he had business he must see to. So they parted for a while, and as Lanny drove on to the Adlon he was wondering: “Am I really fooling him? And just how much?” He knew that he was fooling Irma pretty well, and it hurt him; but it was one of those things which couldn’t be cured and must be endured.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny had telegraphed Furtwaengler, announcing that he and his wife were on the way; now, in the morning, he phoned the Oberleutnant, whose first words were: “"), _c('i', [_vm._v("Ach schade, Herr Budd")]), _vm._v(", you should have been here for the wedding!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why didn’t you let me know in time?” asked the visitor. He meant it for a joke, but the staff officer took it for a rebuke and was profuse in apologies. Only after he had received forgiveness did he feel free to rave over the wonders of that greatest of all German social events, the marriage of the Fuhrer’s second-in-command to Emmy Sonnemann, the stage and screen star who had been his official mistress for some time. After the ceremony there had been a reception in the Opera House—the performance had been held up for more than an hour while Minister-President General Goring and his bride stood in the great hall at the head of the staircase, shaking hands with all the eminence of the Third Reich and the diplomatic world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny said: “I read a lot about it in the foreign press. I saved some clippings for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Danke schon!")]), _vm._v("” exclaimed the worshipful young Schutzstaffel man. “We are collecting everything and will prepare scrapbooks for the National Bibliothek.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are the happy couple?” inquired the visitor, gallantly, and was informed that they were both sitting on top of the world. The Oberleutnant had become fond of this phrase, which he believed was the very latest American slang, and Lanny didn’t suggest how uncomfortable this position might prove to a man of Seine Exzellenz’s figure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny specified what pictures he had come to purchase, and mentioned with seeming casualness that he and his wife had been attending the Stresa Conference. No competent staff officer would fail to get the significance of that. “Seine Exzellenz will wish to see you! Will you hold the wire?” Lanny did so, and presently was told that the Minister-President was due to leave that afternoon and spend a night and a day in the Schorfheide. Would Herr and Frau Budd honor him by coming along? Lanny replied that nothing would give them both more pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He hung up, and remarked: “So, we are going to see Karin hall!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And Emmy, do you suppose?” asked Irma.")])])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("SHAPE OF DANGER")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In a white marble palace on the fashionable Konigin Augustastrasse lived Irma’s friend the Furstin Donnerstein, second wife of a Prussian landowner and diplomat some thirty years older than herself. She had first met Irma on the Riviera, before the latter’s marriage, and had taken a fancy to her; they had gone about together, gossiping about nothing very much. Now the Furstin had three children in her nursery and was bored, missing that gay free life on the Coast of Pleasure and finding Berlin society stiff, cold, and dull. Her husband’s position required that she go out, so she picked up a great deal of news, of which she desired to make the normal use. When Irma came along they would have a regular spree of gossip, the American having to swear that she wouldn’t repeat a word of it in Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So it would be: “"), _c('i', [_vm._v("Ach, meine Liebe")]), _vm._v(",” and: “"), _c('i', [_vm._v("Na, na, meine Gute!")]), _vm._v("”, Hilde, a tall blonde, rather thin for a German matron, smoked too many cigarettes, and perhaps as a consequence of this was nervous and intense in manner. She would begin: “"), _c('i', [_vm._v("Man sagt")]), _vm._v("—” and then she would look about, lower her voice, and say: “Perhaps I’d better not”—which was provoking. She would get up and go to the door of her boudoir and open it suddenly and look out. “You never can tell. One’s servants have all become "), _c('i', [_vm._v("politisch gesinnt")]), _vm._v("”—she spoke nine-tenths English and one-tenth German. “It is you Americans who are to blame. They have heard of that "), _c('i', [_vm._v("fabelhaftes Land")]), _vm._v(" where there are no class distinctions, where anybody can become rich and nearly everybody does. So now we have a "), _c('i', [_vm._v("kleinburgerliche Regierung")]), _vm._v("—the little man is on top, and we are prisoners in our own homes. Somebody may report on us, and some official may welcome a chance to show himself "), _c('i', [_vm._v("eifrig")]), _vm._v(" at our expense.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma had seen in some homes a device called a “cozy,” a sort of little tent made of quilting, to be set over the teapot and the hot-water kettle to keep them warm. Now Irma learned that it was used by Germans to set over a telephone, because they had the idea that there was some secret device which could be installed in the receiver so that outsiders could listen to conversations even when the phone was disconnected. Hilde wasn’t sure if it was so, and didn’t know how to make sure; so, when talking to Irma she carefully put the “cozy” over the phone, and when they were leaving the room she took it off, so that no servant might see what she had been doing. “"), _c('i', [_vm._v("Wirklich")]), _vm._v(", it is like living in Turkey in the days of the sultan!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hilde Donnerstein was no conspirator, nor was her husband; they were simply two members of the old nobility who were, as she said, out of fashion; they resented the tough crowd who had seized the power and the glory for themselves, and they took revenge in telling personal scandals and funny stories about the absurdities of the "), _c('i', [_vm._v("Emporkommlinge")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Ach, meine Liebe!")]), _vm._v(" I must say I don’t envy you your visit to that monstrous Karinhall! But I suppose you are curious about Emmy—no doubt you have seen her on the screen. "), _c('i', [_vm._v("Ganz kary atidenhaft")]), _vm._v("—what is it that you say?—statuesque—but as for acting, "), _c('i', [_vm._v("ausserst gewohnlich;")]), _vm._v(" all people of taste stay away. Of course, I suppose an opera house is the proper place for the wedding-reception of an actress. It is characteristic of our time—"), _c('i', [_vm._v("eine Filmkonigin")]), _vm._v(" instead of a real one!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lanny says the film queens do it much better,” remarked Irma.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How can we judge? But really, when you consider what the life of that couple has been—you have heard that their affair has been of long standing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have heard rumors.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They were getting along reasonably well; "), _c('i', [_vm._v("der dicke Hermann")]), _vm._v(" said: ‘You know that I cannot marry you, of course’; and Emmy, who is not so bright, didn’t know, but was afraid to say so. But one day the pair were in a motor accident—"), _c('i', [_vm._v("schrecklich")]), _vm._v("—the car into a tree crashes; "), _c('i', [_vm._v("der Dicke")]), _vm._v(" is not much hurt, "), _c('i', [_vm._v("aber die Geliebte")]), _vm._v(", she has her skull cracked and is in hospital a long time, and of course it is something that cannot be hidden, "), _c('i', [_vm._v("die ganze Welt")]), _vm._v(" talks; Hermann must go every day to see her, and it becomes a scandal. Then just the other day "), _c('i', [_vm._v("unser")]), _vm._v("—” The Furstin wishes to say “"), _c('i', [_vm._v("unser Fuhrer")]), _vm._v(",” but doesn’t quite dare, even in her own boudoir. She says: “"), _c('i', [_vm._v("Die Nummer Eins")]), _vm._v(" wishes to send his Number Two to the Balkans on a diplomatic mission—you know how it is, we must have allies there, our enemies seek to undermine us in every part of the world; and Hermann proposes to take his woman with him, she must have a rest, and he will make a little holiday of it. But "), _c('i', [_vm._v("die Nummer Eins")]), _vm._v(" says: "), _c('i', [_vm._v("‘Bist du toll?")]), _vm._v(" You will force your mistress upon them? They will take it as an insult; they will say: “What do you think we are—niggers, perhaps?”’ "), _c('i', [_vm._v("Die Nummer Eins")]), _vm._v(" is furious, and gives the fat man a dressing down. ‘Marry her!’ he says. ‘I have had enough of scandal in my party—make her your wife, or we are "), _c('i', [_vm._v("unten durch")]), _vm._v(" in the Balkans!’ So that is how we had this grand "), _c('i', [_vm._v("Staatshochzeit mit Empfang")]), _vm._v(", with gifts the like of which have never been seen in all the world. It is what you say in America, "), _c('i', [_vm._v("eine Hochzeit vor dem Gewehrlauf")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma didn’t know these words, but the Furstin explained that it was when the bride’s father or her brothers come with guns and fetch the groom. Irma said, greatly amused: “Oh, a shotgun wedding!”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("While Irma was enjoying this high-class entertainment, her husband was looking at an art show, and afterward driving his car into a Berlin slum. Promptly at the stroke of twelve he passed the agreed-upon corner and picked up his “underground” friend. Spring was here and the day was bright. She had left her heavy coat at home and wore a gray cotton print, the most inconspicuous that could be found; her hair was parted straight back and covered by a black straw hat—in short, she was a poor workingwoman, with no non-sense about her, and in her arms she was carrying a paper bag.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that what you have for me?” he asked, but she said: “No, just groceries. I was afraid to bring what I have until I was sure you were coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were driving on a little-frequented street, but, even so, Trudi glanced about nervously and lowered her voice. “I have photostatic copies of confidential reports to the Wilhelmstrasse—that is the German Foreign Office—covering the details of our intrigues in various capitals; reports of our ambassadors and instructions to them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good Lord, Trudi!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It will not be so easy to make use of them this time, I fear, since they expose the double-dealing of other nations also, and England among them. I cannot imagine any but a Socialist paper being willing to publish them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s one bourgeois paper, the "), _c('i', [_vm._v("Manchester Guardian")]), _vm._v(", which has a reputation for publishing the truth regardless of whom it hurts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, you will have to be the judge. You might give them to different papers, according to what they contain. For example, dispatches from our ambassador in Rome, telling the inside story of the deal between Mussolini and Laval. You know that Laval went to Rome at the beginning of the year and spent several days with Il Duce. Afterwards he gave the Chamber of Deputies the solemn assurance that he had made no concession imperiling the rights of Abyssinia.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I made note of his language,” said Lanny. “It was most explicit, but even so, I didn’t believe him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He has made a ‘gentleman’s’ agreement, permitting Il Duce to take the country without the interference of France. What worries Mussolini is that while he’s tied up there, Hitler may take Austria; and so they have a mutual guarantee against this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If we could prove that, Trudi, we’d blow the lid off the diplomatic teakettle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our ambassador states it categorically. Italy has already shipped thirty thousand troops through the Suez Canal, with complete equipment and supplies for a six months’ campaign. Operations will begin in the autumn, when the rainy season there is over.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What else have you in this magic box?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have read about the decision of the Stresa Conference?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was there five days ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All three of the powers have been secretly negotiating with the German Foreign Office behind one another’s backs—that is, they think it’s secretly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But of course they all find out!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The real question is, what is going to be done at Geneva. The Wilhelmstrasse has the assurance that no overt action will be taken. Of course the Nazis don’t care about speeches—that gives Hitler a chance to make more speeches and to play upon the persecution complex of our people. A committee of the League will be appointed, but no one of the Big Three is prepared to demand any action to stop German rearmament. Sir John Simon is angling now for another invitation to Berlin to negotiate permission for German naval rearmament up to a fixed percentage of the British.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One of the newspaper men at Stresa told me that,” responded Lanny. “It means a complete sell-out of France!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Nazi argument is that they are not arming against the French fleet, but against the Russian. The Soviets have some new submarines, and it is not in the British interest that they should get command of the Baltic.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There it is again!” exclaimed the American. “Everything goes back to their fear of the Reds. If they have to choose, they prefer Fascism every time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s an intrigue going on between Mussolini and the British over the lake called Tsana, the source of the Blue Nile. Some day there will be a big dam, and the question is whether the waters shall flow to the Sudan or eastward to where Mussolini is going to settle his Fascist families. The British are willing to let Abyssinia go, provided they can have the lake and its headwaters; but Mussolini won’t give them enough, and it looks as if there’d be a showdown before the end of the year. The Wilhelmstrasse is happy over that, because it will mean that we can have the "), _c('i', [_vm._v("Anschluss")]), _vm._v(" with Austria, and perhaps close the Polish Corridor also. Goring is planning to travel to the Balkans next month to cement alliances there—our new trade routes lie that way, down the Danube with our machinery and munitions, and returning with wheat and oil and raw materials.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("So there was a diplomatic map of Europe, drawn by the cartographers of the Nazi Fuhrer. Lanny recalled his friend the young S.A. sports director, Hugo Behr, who had been shot in the face during the blood purge of less than a year ago. Hugo’s crime had been that he had taken seriously the second half of the label, National Socialist, and had urged that the party should attempt to carry out its promises to the little people of the Fatherland. In his last days on earth he had explained to Lanny how the course the Fuhrer was following would make him the prisoner of the Reichswehr, or rather of the Junker officers who controlled that highly disciplined fighting-force. “If he bases his program for re-employment entirely upon armaments, it means that sooner or later we shall have to fight, because that’s all you can do with guns and tanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here was the prophecy coming true. Anybody who was capable of thinking could see that the little people of the Fatherland were being led into another slaughter-pit. The trouble was, there were so few people anywhere in the world who could think or were willing to take the trouble; and in Germany so many of them had had their faces blown off, or were shut up in concentration camps, being made into physical and nervous wrecks. Lanny recalled a remark he had heard the Fuhrer make on the subject of the spiritual nature of man: “The greatest of spirits can be liquidated, if its bearer is beaten to death with a rubber truncheon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re right about those documents, Trudi,” he said. “They are dynamite, and if they’re in a safe place I’d rather wait and get them when I’m ready to leave. My bags are likely to be opened at the hotel; and tonight I’m invited to visit Karinhall, which you must admit is hardly the safest place for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Unglaublich!")]), _vm._v("” exclaimed the woman. “How do you manage such things?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is simple. I have a bank draft for a large sum of money, enough to keep the fat General that way for many months to come. Incidentally, his staff officer has offered to show us the wedding-presents, the wonders of which have been broadcast to the world. Don’t you wish you could come along?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You make me believe in miracles—even if you cannot make me believe in spirits!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, by the way, did you go to see that medium?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did, and it was pathetic. She told me I was about to get a letter from a dark man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, it might happen, in spite of all your doubts. You have decided that what I brought you was not a message from Ludi?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to give up thinking about it; it makes me too unhappy. I have enough problems in this present unhappy world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have had several more seances; but all I got was my grandfather Samuel Budd telling me to hearken to the Word of the Lord; or else the voice of Marcel, telling me that he is painting pictures of a wonderful new world—but his descriptions lack the clarity which characterized his brushwork on earth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They came back to the documents which Lanny was to carry out of Germany. He said: “I’ll do it once more, but after this we’ll have to arrange some other way. The Gestapo will be checking on everybody who comes and goes, and they’d be sure to make note if the publications coincide with my departures. And anyhow, I have to go to America for most of the summer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny didn’t give any hint of how he had handled the former job, nor did he ask Trudi what the repercussions in Berlin had been or whether any of her friends had got into trouble. She came to him out of the darkness, and he retired into another darkness; but where they met was a spotlight, and while they were in it they had to watch every step. They agreed that on the day after the morrow Trudi would come to the usual corner at three in the afternoon; that hour was better for Lanny, because by then he could have got his wife tired of looking at paintings and ready to keep some engagement. When the two conspirators saw each other they would not stop or speak; Trudi would go and get the documents, and half an hour later would meet him at a different corner and hand them to him; both of them would make sure they were not being followed, and Lanny would watch both times for the “all clear” signal. This having been agreed upon, he gave her the money he had brought for her, and then set her down in the neighborhood of an entrance to the Underground. It was the same place where he had once set Freddi Robin down for the last time and the recollection gave him a shiver of dread.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Toward the latter part of the afternoon the huge baby-blue Mercedes limousine of the Minister-President General called at the Hotel Adlon for the American couple and their bags. Wherever this vehicle came, the awe-stricken flunkies bowed low, and the reputation of the foreign guests was made forever after. The two favored ones were taken to the ministerial palace, where the Oberleutnant escorted them for the ceremony of viewing the gifts. Three large rooms had been set aside for the exhibition, and a dozen S.S. men in their black uniforms with silver braid and the skull and crossbones had been set to watch the treasures laid out on dozens of long tables. It was like a visit to Tiffany’s, or Gorham’s, only more so. Every sort of jewelry known to man, or to woman, and every design of gold and silver plate and utensil. Der Fuhrer had presented to his loyal friend one of the three existing portraits of Bismarck by Lenbach. The bridegroom had presented to his lady a transparent blue zircon of enormous proportions—everything in the way of jewels that one woman could carry, diadem, earrings, a bracelet, a ring, a necklace; the staff officer said it had cost thirty-six thousand marks, and he didn’t consider it necessary to lower his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was glory, this was success; a long way up the ladder of fame for a man who had started as a humble Reichswehr lieutenant with no special influence, and who had got stuck in the trenches at the outbreak of the World War. But even now the General was only at the beginning of his dizzy ascent—his whole manner told that to his guests; his step was firm and quick, his laughter exuberant, his handclasp somewhat crushing. He was clad in a white uniform with a pale-blue stripe that matched his car, and his orders and decorations made Lanny think of Tiffany’s again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bags had been moved into a second car, and with the General and his guests rode two of the older staff officers. Furtwaengler and another youngster followed in a second car, and the bags of all of them in a third. At Lanny’s feet was an object covered with a rug, and on the way he kept moving his feet over it; his expert knowledge told him that it was a submachine gun. He couldn’t be sure whether it was a Budd, but he knew that the firm had sold thousands of them to the Nazis for the street fighting with the Communists. "), _c('i', [_vm._v("Der dicke Hermann")]), _vm._v(" was taking no chances!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the way the great man talked about airplanes, and aviation as the science of the future. He talked technicalities, because Lanny was an insider. He wanted to know how Budd-Erling was coming along, and Lanny, who had had a letter just before leaving, had no reason for withholding the fact that the frost was out of the ground in New England and the foundations due to be completed. In his boyhood he had learned the technical terms of ballistics, and in his recent talks with his father he had learned about wing loading and supercharging, increased compression ratios, anti-knock ratings, controllable pitch propellers. When he mentioned casually that Robbie had actually got an engine with a thousand horse power, the General demanded to see one right away. Lanny grinned and said: “It will please Robbie greatly to have you make the first approach.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The head of the Prussian state had apparently not learned fear from his recent auto accident. They drove at high speed, with a long mournful horn warning other cars out of the way. It was dark when they arrived in the Schorfheide forests and all the visitors saw was a blaze of lights in the new palace, called a “hunting-lodge.” Lanny had seen a number of these constructions, in both the New World and the Old, so there was nothing novel to him in a great hall with a huge fireplace, a long banquet table, bearskins on the floor and heads of many kinds of antlered creatures on the walls. All you needed was a quarter of a million in any currency, and architects and interior decorators would turn you out such a job complete in three or four months; a good steward would get you a trained staff of servants in forester’s livery, or military or medieval or "), _c('i', [_vm._v("opera bouffe")]), _vm._v(" as preferred.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But not a "), _c('i', [_vm._v("Filmkonigin")]), _vm._v("—no, that was something you had to go out and find for yourself, and it would cost you more. Emmy Sonnemann was built on generous lines, equipped to play Brunnehilde or any of the other Choosers of the Slain; in fact she had about reached the point where if she became any plumper it would be "), _c('i', [_vm._v("bouffe")]), _vm._v(". But it would no longer matter, for it had been announced that she was going to make only one more stage appearance, and then would do her duty to the Fatherland and set an example to other German brides. She had abundant blond hair, bright blue eyes, placid features, and color which you couldn’t be sure about, since she might have brought her makeup artist with the rest of her wedding-cortege. Her manners were those of the stage, rather than of the aristocracy; she welcomed her guests with effusiveness, pressed food and drink upon them, called them by their first names, and afterward sat on the arm of her bridegroom’s chair and kissed him affectionately. Her first husband had been a leading Communist, and Lanny wondered what impression, if any, that had left upon her mind. He would have liked to be alone with her and try to find out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was obviously a kindly and somewhat naive person, and Irma liked her. Easy to see why audiences came to look at her on both stage and screen; also, why directors avoided giving her roles which called for the manifestation of intense passion. When the two guests were in their own room they carefully avoided expressing opinions, for the architect of Karinhall would hardly have failed to include wiring for espionage. However, when the two were lying in bed, Irma whispered, softly: “Oh, Lanny, that poor woman!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She seems to have got what she wants,” ventured the husband; to which the wife replied, still in whispers: “What do you suppose "), _c('i', [_vm._v("der Dicke")]), _vm._v(" weighs?”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("In the course of two years of power the Minister-President General had added a number of new titles to his list; besides being Reichsminister without Portfolio and Minister of Aviation and Chief of the German Air Force, Field Marshal and General of the Gestapo and President of the Reichstag and of the Prussian State Council, he was also Minister of Forestry and Master of the Hunt; which meant that it was a part of his role to be a country gentleman and have fine horses even though he rarely hoisted himself on top of one. Now he wanted to show his splendid estate to his guests, and it was a bore to them both, because Irma had been brought up on an estate and didn’t care a hang about it, and Lanny had had to entertain country gentlemen by looking at their estates ever since he had been a small boy and had really enjoyed it. Emmy went along, because she was a bride and it was her duty to follow her man and tell him that his possessions were the most wonderful in the world. Lanny and Irma assented meekly and didn’t dare look at each other for fear of revealing what was really in their minds. One feature of the place was a shrine to Karin, the owner’s former wife, and before this a candle was always kept burning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Afterward the General governed Prussia over the telephone; as always when angry, he shouted as if he expected to be heard without a wire. Then he summoned Lanny to his study for a talk, and the playboy felt the cold blue eyes of the wholesale killer boring into him. For a matter of four or five years Lanny had been speculating about the possibility of telepathy, and now he was thinking: “"), _c('i', [_vm._v("Ach, du lieber Gott")]), _vm._v(", suppose it should start working now!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But it didn’t. This Hermann the Great was neither medium nor conjurer, but had to get his information by the ordinary objective method—hiring agents of very little competence, so he complained. If he could get valuable tips by social blandishments and a few smiles from his "), _c('i', [_vm._v("Filmkonigin")]), _vm._v(", it would be a bargain. Apparently what he wanted was to be told about Stresa, and about the prospects at Geneva, where the League was now carrying on its solemn procedure of condemnation. Had Goring’s agents in Italy reported to him that Irma Barnes and her husband had been socially received by the English residents of Stresa, and introduced at a tea party to MacDonald and Simon? Anyhow, "), _c('i', [_vm._v("der Dicke")]), _vm._v(" would only have to listen for a while, and he would hear his art broker refer familiarly to the leading statesmen of all three of the Stresa allies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny had lain awake in the small hours of the morning, reflecting upon the peculiar problem confronting him. As before, he had to assume a pose of omniscience before the fat General and yet tell him nothing he didn’t already know. Also he had to use care not to employ too many of the facts which Trudi had told him. Some of them he couldn’t leave out, because they were the salient facts of the hour and had been told to him by others, also. But he must be careful not to assemble them in such a way that if the documents were ever published it would flash over Goring’s mind: “The very things that Lanny Budd revealed!”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The art expert began with a summary of the situation which the cynical Pete had allowed him to read before it was put on the wire to New York. “My general impression is that you and the Fuhrer haven’t much to worry about in this case; you have got away with it, as we say in America. You got a slap on the wrist at Stresa, and you may get several more in the course of the year, but nobody is coming after you with a gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We are sitting in at a poker game,” responded the General, “and playing for very high stakes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your hand is not a strong one; but the same is true of your opponents. It happens that this game is different from poker in that nerve counts for even more. Also, it is possible to change the rules in the middle of the game—which cannot be done at cards.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The General smiled; he was continually being impressed by the intelligence of this seeming-idle young man, and that was why he desired so greatly to put him to work. “Then you don’t believe our opponents will try to put ‘sanctions’ on us?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What I believe, Hermann, would be of no use to you. What I am telling you is the general impression among insiders, both the diplomats and the newspaper men, of whom I happen to know a number. On Isola Bella most of the time was spent figuring out how they could appear to do something while really doing nothing. Large elements of the public in both France and Britain clamor for action, and so it is necessary to appear determined, even menacing; but no one of the countries is willing to move, because no one can trust any other. Take Britain and Italy—what agreement can there be between them, now that Mussolini has definitely committed himself to the raid on Abyssinia? Is Britain going to let him have Lake Tsana and get his foot into the door of Suez? Of course not!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think he has really committed himself?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“With all those troops in Eritrea and more on the way? Are they going for that hellish climate? And why does Mussolini go to such trouble to make a bargain with Laval? Il Duce was staggered by what he was able to get—he hadn’t believed there was a man in all France who was fool enough to make such a deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What deal do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Na, na, Hermann!")]), _vm._v(" You know much more about it than I!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have heard rumors, naturally; but I am interested to see if your information confirms mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, they have a hard and fast understanding that France will not interfere with Mussolini’s adventure and that Laval will cooperate with Mussolini in making sure that you do not move into any of your lost territories.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that generally known in the diplomatic world?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is known to those who have a right to know. I got all the details in Paris as soon as the deal was made. It happens that my father and I know men who were Laval’s paymasters before he made so much money of his own. He still consults them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Precisely what does Laval think he is getting out of such an arrangement?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He is fool enough to imagine that he is getting an ally. I could tell him otherwise, because it happens that I have known Mussolini from of old; I heard him orating when I was a youth, and my father was a friend of the American ambassador to Italy at the time that Mussolini made his famous march to the Eternal City in a Pullman car. Richard Washburn Child was what his last name implies; he thought he was saving civilization by getting the House of Morgan to lend Mussolini two hundred million dollars to start his empire. Just so Laval now thinks he is saving France by becoming a friend of the man who is teaching the children of his Balilla that Nice and Savoy and Corsica and Tunis are all parts of the new Roman empire.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long will the French public be content with that course?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It does not depend upon the public, but upon the Comite des Forges. My father and I visited Zaharoff not long ago and I listened while they canvassed the situation thoroughly; the attitude of these men is precisely that which you know in Germany—I have heard Thyssen and Hugenberg explain it in the days when they were backing you: they want law and order, and the putting down of the Communists. In France now there is a strong movement for a Front Populaire among Reds of all shades, and the big business men are looking for any leader, any movement, any alliance that will counteract it. They would be perfectly willing to do business with you if you would allow them their share of Eastern European markets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Would you be willing to take a message to these men from me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It would not be to your advantage if I did so. I would be putting a label on myself, and from then on they would be careful what they said in my hearing. As it is, I am an American, and therefore a neutral; a gentleman idler, and my questions are naive. They talk even more freely to my father, since he is one of their sort, and in return he tells them what they wish to know about America. You should understand my relation to my father. He expected me to become his assistant; he educated me for that from boyhood and taught me to, keep all his business secrets. As a munitions salesman he dealt with persons high up in the different countries; to me a general was somebody to take sailing and an ambassador was somebody I could beat at tennis because he was apt to be out of condition.”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("So an American playboy prattled away, tossing the names of the world’s greatest as if they had been so many brightly colored balls for a juggler. Was he telling Hermann Wilhelm Goring anything Goring didn’t know? He hoped not. But everything he said was right, and in each case Lanny provided several different sources from which he might have got the particular item. He didn’t say that he was an intimate friend of Ramsay MacDonald and Sir John Simon and Anthony Eden and the rest; he merely told anecdotes about their personal peculiarities, and quoted them as having said the things which they would and must have said. It was hard to name anybody he hadn’t listened to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He talked about the negotiations over naval limitations between England and Germany, which were supposed to be the most precious of state secrets at the moment; he mentioned offhand and as a matter of course the twelve sea-going submarines which Germany was building at Wilhelmshaven—in spite of the Versailles prohibition and the "), _c('i', [_vm._v("dementis")]), _vm._v(" of the Wilhelmstrasse; also the tonnage of the battleships in process. Of course Germany was building against Russia and not against France—at least that was what Laval and his friends wanted to believe. “It may be different when you are ready to move into the Rhineland,” said the playboy, with a smile, and the fat General didn’t attempt to deny or to contradict any of these brash and undiplomatic assumptions. The General must have been wondering whether he himself had been talking in his sleep; or perhaps whether the American had been consulting that Polish medium whom they kept in their home and about whom Lanny’s wife had been telling Hermann’s wife!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The upshot of it all was that Goring realized he had a valuable friend, and at an absurdly low price; it occurred to him that it might be the part of wisdom to raise the price at once. He said: “"), _c('i', [_vm._v("Sagen Sie mal")]), _vm._v(", Lanny; you’re having trouble with the rest of those paintings, I imagine. Are the prices too high?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m rather afraid they are. You will remember I warned you; nobody has as much money as they had ten years ago—save only yourself, Hermann.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fat man tossed back his head. It was really impudent, and tickled him greatly. He was experiencing that which caused the kings of old days to have a court jester: boredom with sycophancy, the cloying effect of flattery, the need of the human system for some new flavor, some pungency or tang in social intercourse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have offered to divide with you,” said the master of all Prussia, “and I put no limit on your demands.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am an art expert,” replied the American, “and I like to find purchasers for beautiful masterpieces.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, since you must have it that way, I’ll reduce the price of mine. Would that help?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It might, if you wish to dispose of them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Jawohl")]), _vm._v(", suppose I make a cut of ten per cent all along the line. Or would twenty be better?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It would be wiser not to ask me about that, since I am representing my clients, and it is my duty to get them the lowest prices I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m willing to take my chances. You sell the rest of the paintings for what you think fair. I want to show my confidence in you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is very kind,” said Lanny. “I can’t recall that any owner of a painting has ever taken that attitude to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Art is not my principal interest in life just now,” replied the fat commander. There was a twinkle in the cold blue eyes, and for the moment he seemed human; Lanny had to keep saying to himself: “Don’t forget, he’s the killer!”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Late in the afternoon one of the staff cars took the guests back to Berlin, and in the morning Lanny went to the former Johannes Robin palace and presented his bank draft, inspected the three paintings, and saw them carried to his car. He received another of the invaluable bills of sale, also the exit permits for himself and wife. Irma had proposed that they start at once, but Lanny had pleaded that there were art shows he really should take in. Irma had made a luncheon engagement, to be followed by a session of a game called bridge, whose rules are international and are not changed while the game is in progress.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, at a quarter to three o’clock Lanny was driving in the Moabit district, turning many corners and watching in his little front mirror to make certain that no other car followed the same eccentric course. He rolled through one stone canyon after another, endless vistas of those six-story tenements which have become standard for wage-slaves in Megalopolis throughout the world. Here they were cleaner and less dingy than in any other city Lanny had visited, and now in bright spring weather the flowers in window boxes made the scene almost cheerful. Nobody except a few children paid any attention to a car rolling quietly, and there was no need to come through the same block twice, for there was an oversupply of blocks, and except for the names at the corners a stranger could not have told one from another. It was the same with the people of the neighborhood; subdued and standardized creatures, prisoners of the machine, cliff-dwellers of capitalism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With his watch on the seat beside him Lanny came to the familiar corner on the stroke of fifteen o’clock, as they called it on the Continent. He looked for the figure in the gray print dress and the little black hat, but he did not see it, and slowed up his car to look down the intersecting street from which on previous occasions she had appeared. But she wasn’t there, nor was she on the street down which he drove. They had set their watches together, but of course one of them might have got wrong, so after driving a couple of blocks he made a right turn, coming around two blocks and back to the appointed corner. Again he watched in every direction; but no Trudi.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was beginning to be worried. She had always been prompt on the minute, and he knew that nothing would keep her from this appointment except sheer physical disability. They had repeated the details of their understanding so carefully as to preclude the possibility of mistake. If she had come too early, she would surely not have gone away without waiting or coming back on her tracks to look for him. Perhaps she had done so while he was making his encirclement; so he drove down the street again, this time making a left turn, so as to take him around two different blocks and avoid making his car conspicuous. He studied the street signs to make sure there was no mistake; this was the corner, and the time was now fifteen minutes past the hour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He kept up this procedure for quite a while, driving this way and that, circling all the four blocks which made the intersection and coming back again and again. He decided that one of them must have misunderstood; Trudi must be at the other corner agreed upon, the one where he was to have received the documents. He drove to that corner, and repeated his procedure of driving around one block and then another; but in vain. He came back to the first place, and did more circling, keeping a look-out in every direction—not merely for Trudi, but for Stormtrooper or other Nazi uniforms, policemen, or loiterers who might betray interest in a de luxe motor-car.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("At last the sickening conviction settled itself in Lanny’s mind: Trudi Schultz wasn’t keeping this appointment, and there was nothing to be gained by waiting any longer. He gave up and drove at random on one of the boulevards, so as to think without interruption. Something had happened to his fellow-conspirator, out in that darkness into which she disappeared; something serious, for nothing less would have stopped her. She might have been struck in the traffic, or have met with some other serious accident; but far more probable was the thing from which Lanny’s mind shrank in agonized dread—that the Gestapo had got her!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It might be, of course, that they were looking for her; she had received a warning and had fled; she was “sleeping out”—the phrase used by these “underground” people to describe the condition when they did not dare come to their homes or to stay in any one place for two consecutive nights. If that was so with Trudi she would surely drop him a note to the Adlon; she would find some phrase to convey to him the idea of danger. They had talked about this, and she would be careful to write so that the shrewdest police agent would find nothing suspicious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, if the Gestapo had actually got her, they would be torturing her, trying to wring her secrets out of her. They might have had her for the past two days, and if so, that graceful and active figure would be a cringing and shuddering wreck. The thought of it made cold sweat come out on the forehead of Lanny Budd; made him dizzy, so that he had to stop his car at the side of the Potsdamer Platz and turn his face from the passers-by. He thought only of Trudi, and not of possible danger to himself—for he was certain that this woman would die as many deaths as need be before breathing the name of one of her friends. But then he thought: “They may have Monck, too!” He thought: “Monck may be their agent!” At no time since their first meeting had Trudi mentioned this man, and Lanny had no idea where he was or what he was doing. If he was a spy, or if he gave way and talked, then Lanny himself was in serious danger, and instead of wandering distractedly about the streets of Berlin he ought to be getting his wife and his belongings and streaking it for the border.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Once more a lover of "), _c('i', [_vm._v("die schonen Kunste")]), _vm._v(" came face to face with the tragedy which had befallen Germany. One of the world’s most civilized peoples had got into the clutches of this monstrous thing, this lunatic’s dream turned into reality and setting out to uproot and destroy every humane and decent influence among sixty millions of people! If you were a citizen of this land you had to submit and become its slave; to sweat and toil and bleed for it, to share all its vileness and its crimes, to let it take your children and distort their minds and make them into little monsters in its own image. Either that or else sacrifice forever your safety and peace of mind; become a hunted creature, with a hunted soul; know that the evil thing was stalking you, dogging your footsteps day and night, lurking in your home, bribing your servants, teaching your own little ones to report you and bring you to destruction! You had to live in the knowledge that the slightest misstep, a single betraying word or even look—or for that matter the lie of an enemy, a discharged employee, a disgruntled servant, a rival in love or in business—might serve to throw you into an underground dungeon and subject you to such tortures that you would cry out for death!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny was back in the days of Freddi Robin, when he had waited and feared and imagined dreadful things—none of them worse than the reality. Hoping for a telephone call or a message; waiting hour after hour, day after day, for something which wasn’t going to come. Then at least he had had Irma to whisper to; they could go out in the car and indulge in the privilege of normal human beings, to say what they thought. But now he had nobody; he had to carry this burden alone, and have it increased by the necessity of acting a part and keeping his wife from guessing that he had trouble on his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At first he thought he couldn’t stand it. He would take Irma in the car, tell the truth, and throw himself on her mercy. But he knew that she wouldn’t have any mercy; she had told him the state of her mind and given him fair warning. She had suffered the Freddi affair because she had to; because Freddi had been the brother of Lanny’s brother-in-law, and Irma had been a guest in the home and on the yacht of Freddi’s father. Those were ties which you couldn’t refuse to acknowledge, much as you might hate and resent them. But what did Irma owe to Trudi Schultz?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She had met Trudi two or three times, rather casually; once at an evening reception at the school, where she had disliked everybody; again when the young artist couple had been invited to a gathering in the Robin palace, where they had felt out of place and looked it. To Irma all shades of Pink were Red, and if the Schultzes weren’t that, they were dupes like Lanny himself. They had brought on this Nazi terror, they had “asked for it,” in the current American slang; now, if they wanted to overthrow the German government that was their business, and if Lanny wanted to help them it was Lanny’s business, but in neither case was it going to be the business of Irma Barnes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No, Lanny must go back to the hotel and talk about the pictures he had seen; he must invent some excuse for remaining in Berlin, for he was determined to come once more to the appointed corner both at twelve and at fifteen o’clock. Something might have happened; Trudi might have had a fainting-spell owing to lack of nourishment; she might have fallen and broken her ankle. He must get hold of an afternoon paper, to see if there was any story about an unidentified young woman being knocked senseless by a taxicab or a bandit. Also, he must look in the amusement section for an entertainment that he could persuade Irma to be interested in. When he got back to the hotel he must call up somebody and make a date to see an old master and try to get a price on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These activities would help to keep his mind off the idea that the General’s bloodhounds might be hot on his trail; that the General’s torturers might be sharpening their knives and practicing the shrill whistling sounds of their whipping-rods. Lanny Budd, who had made an effort to enjoy the hospitality of Karinhall and had succeeded reasonably well, now thought: “That fat slob may be looking over those stolen reports and Trudi’s confession!” He thought: “I ought to have shot the son-of-a-bitch while I had a chance.” But no, that wouldn’t have changed anything, really. Some other capable Nazi would have carried on, and the system would have become yet more ruthless and determined. What was needed was truth-telling about it, the shouting of its crimes from all the housetops of the world; and after that—Lanny tried to peer into the future, but it was like trying to see to the bottom of a volcano in eruption.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Irma hadn’t arrived when he reached the hotel, so he had more time to get himself together. He consulted his lists and found a picture on which he could possibly get a price; if he did so, he would send a few cablegrams and have an excuse to wait for replies. He would take Irma to a movie in the evening, to keep her from getting impatient. Movies are run in the dark, and that would be good, because he could shut his eyes and think about Trudi in the hands of the Gestapo without Irma’s seeing his fear-stricken face. If he shivered at the thought of what might happen to himself, Irma would attribute it to events on the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No messages came; nothing happened; and to Lanny it was like one of those nightmares in which you know that you have been there before. But in the case of Freddi Robin he had been able to get some information because he happened to know one disloyal Nazi. Now that Nazi was dead, and where should he look for another? There wasn’t a person in Germany to whom he could mention the name of Trudi Schultz without risk of destroying not merely Trudi and her associates, but his own chances of being able to do anything for Trudi’s cause.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma proved to be unexpectedly compliant about the extra day’s stay. She was trying hard to be considerate and fair. She went with him to look at the painting, and agreed that it was fine, though the price was high. It was so high that he couldn’t offer it to his clients; but he didn’t tell her that, he said he would send a couple of cablegrams. It would take but a day or two more, he remarked, casually; and only then did his wife begin to make a fuss. Really, there had to be some limit to delays; she had made promises to her mother, and also an engagement in London. “I want you to do what you enjoy, Lanny, but it’s not fair to turn us both into slaves to this picture business!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had made the mistake of choosing a picture which was owned by a person of good repute, no Nazi; so Irma could argue that in case a sale was made, they could surely count upon having the right picture shipped. “Good Lord, I’d be willing to guarantee it; I’ll put up the money if the man cheats you!” And what could he say? He pleaded for one day extra, promising to leave the morning after next; and so she gave way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After all, what sense was there in staying? If there was a question of the documents, Trudi could find some other way to smuggle them out; Monck might bring them to England and send them to Lanny by registered mail; Lanny could forward them to Rick by the same means. As for fretting and eating his heart out with anxiety, he could do that just as well in London or on Long Island; more easily, in fact, because he wouldn’t have the extra tension of lying to his wife. If ever he did get a letter from Trudi, if ever he could think of a way to save her, there would still be steamers crossing the Atlantic, and it would be nearly as easy to think up an excuse for returning to Berlin as for staying now.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Was it cowardly of a Socialist to go off and leave his comrade in her plight? This was Trudi’s job, he told himself; she had chosen it for herself, knowing clearly its risks. She had refused to give him any means of communicating with her, so surely she couldn’t blame him for not doing it. Nevertheless, he would go on being dissatisfied with his job, of playing prince consort to an heiress, taking her to picture shows, and lying to her because she wouldn’t permit him to have a social conscience. He had told Trudi that he could get money for the cause in that money world and nowhere else; and Trudi had been glad to have that sort of assistance. But it had worked out to this: that while she lay in the dungeons of the Gestapo, Lanny would drive off in a fancy car, cross the ocean in a luxury liner, and spend the summer in a Long Island show-place with two- or threescore servants to wait on him. No amount of arguing could make that seem a satisfactory division of labor!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No message of any sort; and on the morning set for their departure Lanny packed his things with a heavy heart. He purposely took a long time, for there was a second mail before noon, and something might come by that. No need for hurry, he told his wife; it was a clear day and they would drive fast, and catch the Hook of Holland ferry in the evening. He talked about the news from Geneva; the first mail had brought a card from Pete, and now Lanny was reading aloud an item from the morning paper which showed how correct Pete had been. The League committee had appointed subcommittees, a time-worn device for postponing action. Lanny beguiled his wife into talking about a journalist, born in Naples and raised in Brooklyn, who took a disparaging attitude toward all “wops.” Irma, interested in people, let herself be beguiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At last, however, the husband could think of no more devices. Their bags were locked up and carried away. He went down and paid his bill at the cashier’s window. He asked at the desk for a message, and there was none. The car was at the door, the bags stowed, and Irma appeared in her quiet but elegant traveling-costume, conscious of her ripe brunette beauty, gazed at by all men and women, and knowing it. A splendid tall personage in uniform opened the door for her and then hastened to open her car door; the bellboys bowed, and Lanny followed, scattering largess, one of his functions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma took her seat, and Lanny had gone around to the other side to get in, when there came a bellboy running with a letter in his hand. Lanny thought: “Oh, God!” His heart hit him a blow under the throat. It was one of those cheap envelopes that Trudi used, and the handwriting was hers. He opened it hastily and read:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal"
  }, [_vm._v("Dear Mr. Budd:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Very urgent circumstances made it impossible for me to complete the sketches as I hoped. Please accept my apologies. "), _c('i', [_vm._v("Gluckliche Uberfahrt!")])]), _vm._v(" "), _c('p', {
    staticClass: "blq-normal2"
  }, [_c('span', [_vm._v("Kornmahler")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("He got into the car, a bit dizzy. “What is that?” asked Irma, and he had an answer thought up in advance: “Young artist whose work I took a fancy to. Promised to send me some sketches, but something went wrong.” He handed the note to his wife, so that she wouldn’t be looking at him for a few moments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is this why you wanted to wait?” she inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, no,” he replied; “they can come by mail just as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Kornmahler,” she remarked. “An odd name!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Probably Jewish,” he said, starting the car. “Graingrinder” instead of “Miller”! Trudi had known that he would get the point; she was in hiding somewhere, and had to change her name in a hurry! Also, she was telling him that there was nothing he could do about it. Happy crossing! "), _c('i', [_vm._v("Bon voyage!")])])])])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h"
  }, [_c('span', [_vm._v("BOOK THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "part-center"
  }, [_c('span', [_vm._v("The Worst Is Yet to Come")])])])])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("THE HEAD THAT WEARS A CROWN")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("It is the nature of the human creature to have desires, and part of the process of civilization to devise new ones. The creature forms ideals, he sets himself goals, and then labors to attain them. When he has got there he looks about, and finds that it isn’t so satisfying as he had imagined; already he is in process of forming a new ideal, of setting himself a new goal. The unfortunate creatures are of two sorts: those who are so low in the social scale that they have no hope of attaining their desires, and those at the other end of the scale, so well provided with everything that they have nothing to strive for, and thus fail to make the efforts whereby their capacities are developed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny Budd was one of these latter unfortunates; or so, at any rate, he felt himself while playing his role of prince consort on the Long Island estate. He was the young lord of Shore Acres, the only male there having authority; and while the females owned the place and ran it, they deliberately deferred to him and abrogated their rights in his favor. They did this because they wanted him to stay; they wanted the place to serve his pleasure, and they were puzzled when it failed to do so. They watched him anxiously for signs of discontent, and their attitude was communicated to the servants, who never fail to know the circumstances of those families upon which their lives are centered. Mr. Lanny doesn’t like this place, Mr. Lanny wants to go back to Europe and take his wife and daughter with him. If he goes, the staff will be cut down, a lot of us will lose our agreeable jobs; so let us find out what it is that Mr. Lanny lacks, and let us bring it to him on a silver platter, or perhaps the gold service which is kept locked in the safe built into the wall of the master’s bedroom. He is of a friendly disposition, so let us smile and say a cheery “Good morning.” He appears to be preoccupied right now, so let us steal about our duties on tiptoe. Now he is frowning—have we done anything to displease him?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is something peculiar about this young master—really quite unprecedented. Mr. Binks, the second footman, declares that he is a Socialist. He takes several papers full of that sort of stuff, and when he throws them into the trash Mr. Binks read them, and now he is talking like a Socialist, too; he says that the rich are a lot of parasites and ought to be put to work like everybody else. For God’s sake, how does one please a young master like that? By being a bad servant instead of a good one? Mr. Binks reads aloud a sentence which Mr. Lanny himself has marked in the paper, quoting a party named Walt Whitman, who says: “Give me neither masters nor servants; give me comrades and friends.” And what does that mean? Would Mr. Lanny like us to come and sit down in his study and be comradely? And what would Miss Irma make of it? The older servants still call her Miss Irma; it is a privilege which marks their rank.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The executive head of this estate is Mrs. Fanny Barnes, "), _c('i', [_vm._v("nee")]), _vm._v(" Vandringham, and she is one of the old sort, with no non-sense about her; the servants have no difficulty in knowing their place when she is around, and that is most of the time. They know everything about her and her family, because in one of the many cottages of the estate there live aged pensioners, one of whom was Mrs. Barnes’s nurse and is now a fountainhead of ancient lore. She can tell how bitterly Mr. J. Paramount Barnes, the utilities king, used to quarrel with his wife, and so he didn’t leave the estate to her but to Miss Irma, or rather to a trusteeship, so that his daughter won’t come into full possession until she is thirty. Meantime, she is away most of the time, and doesn’t care very much about the place, so Mrs. Barnes has everything her own way, and a hard taskmistress she is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The real center of the demesne has come to be little Frances; the twenty-three-million-dollar baby, as the newspapers still call her, though the value of the fortune has been cut in half by the depression. But things are coming back, and dividends are being paid again. That ought to please the well-to-do, but it appears that taxes take most of it—the ladies and gentlemen all worry about them, finding fault with the President and calling him bad names. Mr. Lanny grins, teases them, and sometimes gets into an argument. Evidently that is a part of being a Socialist; you are glad to see the rich taxed, even though you are one of them. A hard thing to imagine!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs. Barnes holds her little granddaughter as the most precious treasure and guards her like an old dragon; has her sleeping in her room, and doesn’t mind being waked up by her; watches her food, sends for the doctor if she sneezes once, and doesn’t like to see her taken off the estate. She is jealous of Mr. Lanny’s mother, who lives in France and has the child the greater part of the time. But Mrs. Barnes does not let Mr. Lanny see this; she humbles her pride, trying her best to please him and make him feel that Shore Acres is his real home. She is all the time taking her brother off and scolding him because he talks too much and bores Mr. Lanny with his opinions, especially about politics and the stock market and that sort of thing. “Shut your fool mouth!” she says, loud enough for her maid to hear, and of course the story is all over the servants’ quarters before the day is done. Poor Mr. Horace Vandringham, nobody feels very sorry, for he is a big domineering fellow who makes a lot of noise and trouble for the help, giving orders when he has no right to; he cannot bring himself to realize that he is a down-and-outer, a charity boarder, and the pride of his sister will not permit her to put him definitely among the pensioners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny and Irma are the privileged ones, the reigning queen and prince consort, whom all serve gladly. Free and easygoing, laughing a lot, good to look at, and always dressed at the peak of fashion—surely there are no people in the world more to be envied than these two! And yet they aren’t always happy, you can see it if you watch them closely. There are stories going the rounds of impatient words and irritated looks. They go out a great deal, and servants don’t always find out what happens, but they can guess, because the friends come to Shore Acres and one gets to know them and sees how they behave. They play cards a lot, and some of them lose money which they can’t afford. You can tell that by their looks, and sometimes you hear husbands and wives fussing as they go out to their cars—oh, yes, there isn’t much kept hidden from servants. A big place like this is a world of its own, and while it doesn’t have a newspaper it has many busy tongues.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These playboys and girls—they are getting to be middle-aged but they don’t want to admit it—are many of them unhappy and they drink too much. Mr. Lanny drinks very little, and he doesn’t like to see Miss Irma take more than a couple of cocktails. The servants know that and don’t take the trays to her, at least not while her husband is near. That is one of the things they have fusses about now and then; not long ago he had to help her up to bed, and next morning they had a real row. Her eyes were red with weeping, and she must have promised, because now she drinks much less; she tries hard to keep him with her, and not have him go off to the city and meet the queer sort of people he likes. Once he took her to some radical meeting, and they had an argument in their room. Her maid heard snatches of it and told it in the upper servants’ dining-room: he said and she said—always when they tell such stories it is “he” and “she,” and they will go on for an hour without mentioning a name. There can be only one he and one she in a feudal community.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Across Long Island Sound lies the small city of Newcastle, known as the home of Budd Gunmakers and soon to be better known as the home of Budd-Erling Aircraft. Budd’s still made machine guns and automatic carbines and pistols, but most of it was now a hardware plant, which meant that it had lost its social status in the eyes of the old-timers. Lawford Budd, Robbie’s eldest brother, was still vice-president in charge of production, but the president now was a Wall Street man, and the board of directors consisted for the most part of dummies representing a syndicate of financial men. Robbie looked upon it with contempt, and his two sons had withdrawn, and so had several of the executives and plant managers. All had come into the new institution, which was going to be a one-purpose plant, with everything new and shiny, designed and operated according to the latest wrinkles of the scientific management people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As little as a generation ago, if a man had announced that he was going to build a great factory to produce airplanes that would fly faster than two hundred miles an hour, everybody would have known that he was crazy. Indeed, it had been possible for the Wright brothers to stay up in the air over the sand-dunes of North Carolina in their flimsy wood-and-canvas “crate” for many minutes at a time over a period of several months without having the press of the country pay the slightest attention to them. What they were doing was impossible and therefore the stories couldn’t be true. But now it had been possible for Robbie Budd to sell five million dollars’ worth of stock, and to have some of the best engineers in the country design and erect a building where planes and nothing else were to be turned out on an assembly line, and he wasn’t called crazy, but, on the contrary, one of the town’s most progressive citizens. All looked up to him and said they had always known that he had it in him; he walked with new dignity, gave orders with quiet assurance, and saw that they were carried out promptly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny and his wife motored to Newcastle, by way of the ferry to New London, and paid a visit at the Robbie Budd home. Esther, Lanny’s stepmother, welcomed them cordially. His early sins had been forgiven and perhaps forgotten; he, too, was a success, quite apart from his rich wife—so his relatives and old-time friends tried to make him understand. His profession of art expert was impressive, his musical talents were considerable, he was a linguist and a traveler, almost an ex-diplomat and certainly a friend of the great. The members of the country-club set hastened to honor both husband and wife. If he voiced pinkish opinions—well, it was in the Budd tradition to be eccentric and tell the world to go to the devil, and this appeared to be the newest way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sales offices of the new concern were in New York, and here Johannes Robin was in charge. He had got a home for his family half-way between the city and the plant, so that he could commute to either. It was Irma’s duty to go with Lanny for a call, and they chose a Sunday afternoon. Papa and Mama, Rahel and the little one were all together again; they had bought a comfortable old-fashioned New England house of two stories and a dozen rooms, and said they expected to spend the rest of their lives here. Irma thought it was the right way for people of their sort to live—far more sensible than an elaborate marble palace and a yacht. She received graciously their thanks for her kindness in the past, and no great lady could have been less condescending to those who had been reduced in social status. Johannes’s hair had turned gray and there were more lines in his face, but he was the same urbane and subtle person with the flavor of old-worldliness about him.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Robbie escorted the couple to see the new plant, now magically approaching completion. Rows of piling had been driven into the marshes, and great dredges had lifted the mud out of one side and dropped it into the other, so as to make steamship berths and docks. The cow pastures had been covered with concrete, and a skeleton of steel had risen over them, and now it had walls of glass and a roof of some patent material. Out of its floors sprouted innumerable bolts, to which machines large and small were to be attached; the concrete was covered with cabalistic signs in various colored crayons. Overhead were trolleys on which airplane parts would be carried, swinging from steel chains. Everything had been planned to the fraction of an inch, and the blueprints were numerous enough to have covered the floor of the building.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Part of it was a great foundry, and a power plant was already belching black smoke, making electricity for the construction work and the lighting at night. Already some of the machines were arriving, mysterious in their waterproof wrappings. “Come back in another month,” Robbie said, “and you won’t know the place; in six months we’ll be rolling out our first plane, and you can take a ride in it.” He was doing the honors personally, because Irma was his largest single stockholder and was entitled to know just what her money was buying. She was greatly impressed and asked many questions, showing that she was thinking not merely about her money but about the work it was going to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny was content to look and let the others talk. He believed in machinery and the power it gave to humankind, but he was ill satisfied with the uses to which it was being put. He dreamed of seeing it collectively owned and serving collective purposes; but there was no use saying a word about this to either his father or his wife. These two belonged together, for they understood and supplemented each other. Irma had the “stuff,” and Robbie put it to use for her; they would share the profits, and expect the rest of the world to work for them and do what it was told. For those who were dissatisfied with the arrangement there would be a company police force—already it was being organized and taught its duties by that dependable ex-cowboy Bub Smith, who had taught Lanny how to shoot guns, and had pretended to be a Socialist while acting as bodyguard to Baby Frances at Bienvenu.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("The consequences of Robbie’s social theories became apparent to Lanny while passing through the district surrounding the plant. Robbie expected to have a thousand skilled men at work in a month or two, but it hadn’t occurred to him to make arrangements to get them here or provide them with places to live. All that, according to the master’s philosophy, was a matter for private enterprise. The men would be skilled workers, getting good pay and having their own cars; and Robbie did his part by setting aside a tract of the company’s land on which their cars could be parked. Where the men were going to have their homes was up to them, and the matter was being settled by a swarm of speculators who had got wind of the new project and had come rushing to buy up the adjoining land. Now there were “subdivisions,” and busy salesmen marking out lots with little colored flags, and bringing people in busses from the cities to look at the land and eat free lunches of hot dogs and coffee. Already scores of workers’ homes were arising; they would be jerry-built, with silly little pretenses at elegance but nothing substantial, and as a result the workers would soon be putting in their spare time mending leaky roofs and cracked plaster and windows and doors that got stuck. But all that was their look-out, not the company’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was the thought of starry-eyed New Dealers that housing-projects might be constructed at the same time as new factories; that parks and schools and playgrounds might be provided for workers’ families from the very outset. That was done as a matter of course in the Soviet Union, and that fact was enough to damn it for the rugged individualists of New England. Lanny knew there wouldn’t be any use mentioning the idea now; he had been mentioning it for the past eighteen years—ever since he had met the first Pink while a pupil at St. Thomas’s Academy in Connecticut.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He knew in advance every word his father would say; Robbie intended to institute what was called “welfare work” in the new plant, as soon as things got going and he had time to think about it; but he didn’t ask Lanny to help, and Lanny knew why—because from the first moment the question of labor unions would come up, and Robbie was going to run an open-shop plant or die in the effort. “Free labor,” he called it, and meant by the phrase that the men were free to do what he told them or move elsewhere and do the same for some other hard-headed industrialist. The men who had charge of the providing of rest places and recreation for the workers wouldn’t be “cranks” picked out by Lanny, but sensible fellows who knew where their salaries came from. They would organize baseball teams and bowling-tournaments and run a company organ full of pep talks and production slogans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So Robbie Budd was in triumphant course of producing another center of industrial feudalism in a land which preached democracy and government by popular consent. Robbie’s new town wouldn’t be called a company town, and it wouldn’t be company-owned, but would be company-run by devices which Robbie didn’t have to invent, for they were standard practice in this sweet land of liberty. The workers had come swarming from nobody knew or cared where; they wouldn’t know one another and would have no ties or loyalties. They would be free to vote for political candidates every year or two, and they would assume that these candidates were crooks, and for the most part they would be right. Robbie or one of his agents would appoint a political boss to run the town, and at election time would put up campaign funds to elect the candidates whom the boss had chosen. If anywhere active in opposing the company’s wishes, whether as to policies, unionism, or anything else, those men would be “let out” and would move elsewhere. Such was the system, and Lanny knew that he wanted no part in it. If he was planning to denounce it, good taste required him to begin somewhere else but the place where his wife’s money and his father’s time, energy, and reputation were being thrown into the pot.")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("From a safe distance of three thousand miles the amateur publicist watched events in the unhappy Continent on which he had been born. He saw them through the medium of newspaper dispatches written by men whom he knew; also of letters from Rick, and Raoul Palma, and one to his father from Denis de Bruyne. At the beginning of May the French signed a treaty of mutual defense with the Soviet Union, and Denis said that it represented an effort to bluff Germany. But in order to bluff successfully you have to look as if you meant it, and France didn’t mean it. Hitler knew it well, and took the treaty as a basis of propaganda attacks. Pierre Laval meant the treaty so little that it wasn’t even presented to the Chamber for ratification, nor was it implemented by any military arrangements. Marianne wouldn’t trust her new ally with any of her defense secrets—and what sort of ally was that?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of the month the "), _c('i', [_vm._v("fripon mongol")]), _vm._v(" became Premier—a sort of booby prize, Rick said, for having proved himself the most inept of living French statesmen. Early in June, Ramsay MacDonald was replaced as Prime Minister of Britain; poor old packhorse for the Tories, he had carried them as far as he could, and now they set him down to rest and dream in a pasture called the Lord Presidency of the Council. His place was taken by a steel manufacturer named Baldwin, whose specialties were pipe-smoking and pig-raising. “England also has her two hundred families,” wrote Rick, “and they don’t have to hide themselves behind the mask of an innkeeper’s son.” The first act of this new “jumped-up blacksmith” was the treaty for naval parity with Germany, which had been so incredible that insiders had laughed at Lanny when he talked about it. Now John Bull kindly gave the Germans permission to build up to thirty-five per cent of his own sea-power and actually included the right to parity in submarine building. The tiger that had been let out of his cage was now invited into the family dining-room—though of course seated near the foot of the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Benito Mussolini, Blessed Little Pouter Pigeon, was bound by no less than nine treaties to respect the independence and territorial integrity of that ancient land called Abyssinia and sometimes Ethiopia; but he was going right ahead with his propaganda against it, and shipping soldiers and supplies to his Red Sea bases. This was an excellent thing for the British, who owned most of the stock of the Suez Canal Company and collected goodly sums for every ton of shipping and every soldier traveling through that long sandy ditch. It was also excellent for the New England-Arabian Oil Company which Robbie Budd had founded and recently sold out to Zaharoff and his associates; they were right there with the fuel which Mussolini couldn’t do without, and in return they would take the food and wine and oil of the Italian people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lord Wickthorpe went with a British mission to negotiate with “the blighter,” and when he came back he told Rick about it, and Rick wrote it to Lanny on his old battered typewriter. Bit by bit, like careful traders, the British had offered Il Duce everything he could hope to get, asking only that he should proceed under the forms of legality and let the League hand it to him on a golden platter; but no, he was determined to take it by force, for the sake of the effect on his domestic situation. Some forty years ago these black fighting-men—a mysterious race supposed to be descended from wandering Jews—had given invading Italian troops an awful licking, and Il Duce wanted the glory of wiping out that disgrace. He saw himself going out there and receiving the submission of the “Lion of Judah,” then coming home in a triumphal procession and building a monument to himself in the Forum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only real obstacle in his path was British public opinion. Four years previously the Tories had got into power in a snap election, in which, polling fifty-five per cent of the vote, they had got ninety-one per cent of the House of Commons. Now the British people had proceeded to organize independently and take a poll of eleven and a half millions of themselves, and they had voted something like thirty to one in favor of staying in the League. They had voted thirteen to one in favor of prohibiting the manufacture and sale of armaments for private profit—imagine the feelings of Robbie Budd when he opened his paper and read that item of news! With Mussolini’s African adventure before them, these amateur voters had been asked if a nation which insisted upon attacking another nation should be stopped by economic and non-military measures, and they had answered Yes by fifteen to one. Asked whether such an aggressor nation should be stopped by military measures, they had answered Yes by nearly three to one. In the face of such a vote Mussolini brought to completion his plans to march into Abyssinia; and what was the League of Nations going to do about it? What was the Tory government of Britain going to do about it?")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Soon after his arrival at Shore Acres, Lanny had received a note from Trudi Schultz, forwarded from Bienvenu; a duplicate of the one he had so nearly missed in Berlin. After that, nothing for a couple of months; he had to accustom himself to thinking in a special way about these people who were “death’s own.” Their owner might have claimed them or they might be on the way to him by the route of dungeons and concentration camps. A letter might come, or it might not; and there was no good fearing or worrying in the meantime.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One came in the middle of July; a real letter, the longest he had ever received from Trudi: “I am very busy, illustrating a work of fiction dealing with the time of the Emperor Diocletian. The heroine is a persecuted Christian who has to flee; there are several scenes of vigorous action, and these are difficult for me, because, as you know, my drawings have so far dealt with still life. I should value your opinion of my work highly, and hope you will be visiting Berlin. I am expecting to move and not sure of my address but will get in touch with you when I hear of your arrival. It is convenient that you are a famous person whose comings and goings are reported in the press. By the way, my clerical friend has been ill for some time and is confined to his bed. I do not know just what is the matter with him; he does not talk about his ailments. Hoping that this finds you and your family well and the picture business thriving, I am, respectfully, Kornmahler.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny didn’t need to spend much effort interpreting this elaborate parable. Trudi was being sought by the Gestapo and was in hiding; she couldn’t give an address, but wished him to come to Berlin and find some way to get himself and his picture business into the newspapers; then she would get word to him. The clerical friend, of course, was Monck, and she was telling the tragic news that he was in a concentration camp but was not betraying his friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Serious news indeed for the grandson of Budd’s. Maybe the man hadn’t talked yet, but he might talk tomorrow, and his first statement would be that the money for the criminal activities of his group was being put up by an American playboy who posed as a friend of the Gestapo General, and, indeed, was getting his money by acting as an art broker for the Nazi second-in-command. That would be of genuine interest to the Secret State Police; and what would they do about it? The question called for no little guessing. An art lover of imaginative temperament could spend hours, especially the wee small ones in the morning, picturing scenes with the fat General, and with the acting head of his Gestapo, a former schoolteacher named Himmler who had managed to make himself the most dreaded individual on the continent of Europe. Lanny’s first thought was: “That settles me for Germany!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But very soon he began having second thoughts. Trudi hadn’t been obliged to tell him about Monck; she had taken a risk doing it—and why? Obviously, in order to be fair. She was saying: “The danger is greater; perhaps you won’t want to come.” And what was his answer to be? Should he say: “The danger is too great, and I give up”? If he said that, what would Trudi think of him? What would he think of himself? For more than half a year he had been maintaining his self-respect on the basis that now he was really doing something worth while. He had won new regard from Rick on the basis of being no longer an idler and parasite. Should he now say: “The job was too risky, and I had to quit”? Or should he merely keep quiet, and let Rick go on thinking of him as something he didn’t dare to be?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A gnawing began in his conscience and did not stop. He had been justifying his life of luxury by the fact that he met his clients that way, kept up his prestige, and so made his picture deals. Clients would repose confidence in a social equal, but hardly in a subordinate, a professional no matter how truly qualified: such was the world of snobbery. So Lanny made money easily and abundantly; but what did he want it for? So that he could buy new suits of clothes whenever his wife or his mother cast a critical glance at one he was wearing? Or whenever those public enemies, the fashion creators, decided that coats must have three buttons instead of two, or that lapels should be an inch longer and have an angle somewhat more acute?")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Lanny’s thoughts were continually occupied with those comrades in Germany; not only Trudi, but all who were helping her. They were not vague abstractions to him; he had met a score of them, and their names, faces, and personalities haunted him. In the happy days before Hitler they had sat in one another’s homes, or in the reception room of the school, drinking coffee and eating "), _c('i', [_vm._v("Leibnitz Keks")]), _vm._v("—a modest proletarian form of celebration—and talking about their cause, what it meant to them and how they hoped to make it prevail. They had used large and noble words: "), _c('i', [_vm._v("Freiheit")]), _vm._v(" and "), _c('i', [_vm._v("Gerechtigkeit Bruderlichkeit")]), _vm._v(" and "), _c('i', [_vm._v("Kameradschaft")]), _vm._v(". They had quarreled over points of doctrine and tactics, they had been irritated with one another, they had displayed petty jealousies; but it had always been understood that deeper than all such things was the powerful bond between them. They were comrades in a sacred cause, human beings in a world of wolves, civilized men surrounded by barbarians, producers in a society of exploiters, plunderers, and parasites.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And now, did all that mean anything? Was it a real moral force, or had it been only fine phrases, a form of self-indulgence, a system of pretenses, a means of self-advancement for the intellectuals and a whim or diversion for the idle rich? Lanny couldn’t get out of it by saying that he had gone among them as an investigator, that he had wished to understand their movement among many others. No, he had told them that he was a “comrade”; he had encouraged them to fight Nazism, assuring them of his own democratic sentiments and of the moral support of all decent and right thinking men. They had acted on those promises and those hopes. They had done what they could—not all of them, of course, for no movement is perfect. For their weaknesses of character and errors of judgment they had paid frightful penalties and would pay more. The weaklings had dropped out, and a little group, perhaps a mere handful, was carrying on the fight trying to keep the spark alive, to save the soul of the future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trudi hadn’t told Lanny what they were doing. She had assumed that there was no need to do so. Lanny had been in the movement for years and had known some of its great leaders. She and Ludi had poured out their hearts to him and Freddi; they had set forth their ideas in detail, and Lanny had agreed with them. He had said to himself: “Here are two people who understand not merely the economic forces which move society, but the moral forces which move the souls of men.” That combination of understanding was rare, and these four young idealists, three men and one woman, had merged their souls and their labors. They had forged weapons for the future—and now it appeared that only two of them were left alive to put the weapons to use.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny didn’t have to guess what was going on, for the underground movement against Hitler had been pretty well written up in the neighboring lands; even the capitalist press had now and then printed news of it. There was a “flash-sender,” as the Germans call it, a secret radio transmitter, hidden somewhere in the country, and every now and then it would start up, revealing forbidden news, exposing official falsehoods, tormenting the Nazis with jeering comments. If it had stayed in one place, it could have been quickly located, but it kept moving; it must be carried in a van or covered car, and the powers of the Gestapo had been set to hunting it—so far without success.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also there were secret printing-presses; leaflets were printed or mimeographed, and would be found on the benches of workers when they came in the morning, or perhaps in their dinner-pails at noon. Very often it would be the Socialists attacking the Communists, or vice versa—they still kept up their factional disputes, even in the concentration camps. But Lanny could be sure that Trudi was not taking any part in that, because she had agreed with him in deploring the blunder. She would be exposing the fraudulent Socialism of the Nazis and pointing out to the workers how they were being led into the path of war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These heroic people were depending upon Lanny for their funds. He knew enough about left-wing movements to understand that they would have dropped efforts to get funds elsewhere and be devoting themselves to spending what he sent them. And now their supply would stop. There would be no way for him to notify them not to expect more; they would wait and go on waiting—in the same unhappy state of mind which he had known in Berlin, waiting for word from Trudi. The flash-sender would fall silent because they had no money for new batteries or gasoline for the car; the leaflets would no longer be distributed because there was no paper. Trudi might write to him—or more likely, she would give him up in disgust, and he would never hear from her again, never know whether she was alive or dead. But he, the young lord of Shore Acres, would be safe and comfortable, and if there was anything in the world that money could buy, he could have it for the asking. Everything, save his peace of mind!")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("He had managed to find purchasers for a couple more of Goring’s paintings; and after a week or two of wrestling within himself he said to his wife: “How would you like to take another run over to Berlin?” He would have preferred to go alone, but tact required that he invite her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As it happened, Irma had just received a letter from Margy, the very sporty Dowager Lady Eversham-Watson. Being nearly sixty, she ought to have known that she was “on the shelf,” but she refused to. With the proceeds of the rapidly reviving business of whisky-distilling she had got herself a yacht, and instead of being content to invite Beauty and Sophie and other ladies of her own age she craved the society of the young. So, wouldn’t Irma and Lanny be her guests for the regatta week at Cowes? It was a great show, which Lanny had seen but Irma hadn’t. Irma said: “Poor old Margy’s a bore, but I imagine it will be rather swank—what do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What Lanny thought was: “O.K., let’s go!” And so began one of those periods of agreeable confusion in which you make plans and decisions. They would leave Frances here with her grandmother, for they were coming back, having accepted an invitation for a couple of weeks’ hunting on one of the estates of the South Carolina tidelands. Irma would take her maid, because you couldn’t participate in regatta festivities without a personal maid. But not too many clothes, because they would have several days in London to get yachting-togs. Lanny would look kind of cute in such an outfit; his wife would order one and order him to have it fitted. As a reward for his being so sweet, she would accompany him to Berlin and let him look at pictures for as long as he needed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They had to choose a steamer, and engage accommodations, and send cablegrams to friends. Lanny called his father and told him; he called Johannes, and found that he had just had a cablegram from Hansi and Bess. The two musicians had left South America for a tour around the world and had got as far as Japan. Now they had learned of a Congress of the Comintern to be held in Moscow, the first in seven years, and they were leaving by way of Vladivostok to take in this show.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny, too, had heard about this coming event. The Third International had summoned its parties all over the world to send delegates, to consult concerning the new emergency which confronted them in the upsurge of Fascism-Nazism. Rumor had it that a change in the party line was contemplated; some sort of united front was to be set up with the Socialists and other liberal forces. This was what Lanny had been urging for many years; he could say that the Comintern was about to adopt his party line! Having attended a dozen conferences of “bourgeois” statesmen, he would have greatly enjoyed attending one of revolutionists. But, alas, nobody could go from the Kremlin to Karinhall, or from Karinhall to the Kremlin! He said to Irma: “We’ll meet Hansi and Bess when they come out, and hear all about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irma said: “"), _c('i', [_vm._v("You")]), _vm._v(" can!”")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Early one morning a procession set out from Shore Acres: two cars and a station-wagon, the first with Irma, driven by her husband, with their five-year-old darling between them, and Miss Addington, the elderly English governess, in the back seat; in the second car, Mrs. Barnes and Uncle Horace, driven by their chauffeur, and with one of their favored pensioners beside him. In the station-wagon rode Celeste, Irma’s Breton maid, and a load of trunks. They drove to the pier where the great Cunard liner was already rumbling her whistle. Lanny’s car had steel chains put under it and was lifted into the hold; the trunks were piled into a heavy rope net and thus let down into another hold; the three passengers and their guests went up by the gangplank, preceded by stewards carrying armfuls of their bags. Moving the rich about the world is a task involving a lot of labor for other people, but the rich themselves maintain a calm and unhurried aspect. “The sons of Mary seldom bother, for they have inherited that good part.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To go away is to die a little, the French say; but the sons and daughters of Mary do their dying in private, and in this case only little Frances shed any tears. She liked steamships and wanted to go along. When the call came: “All ashore that’s going ashore!” she wanted violently to remain, and it wasn’t complimentary to her grandmother and her great-uncle. Irma had to promise to throw her a red paper ribbon, and for that she went eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This pleasant custom had grown up in recent years. The steamship people furnished rolls of thin paper ribbon of bright colors; the passenger held one end and tossed the roll to a friend on the pier, and he or she caught it, and so they were connected by symbolical bonds until the vessel began to move and all ties were severed. Irma tossed a red one, and it was caught and handed to the twenty-three-million-dollar child. Lanny tossed a blue one, and she wanted that also, and stood with a ribbon in each fist, carrying on with both parents a conversation of which they heard no word. However, she heard her father’s voice: “I’ll be back soon!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lanny said this because it was the proper thing; but inside him a voice whispered: “Oh, yeah?” This voice had taken to speaking at intervals by day and night, and was pretty well spoiling Lanny’s enjoyment of the agreeable life which fate had assigned him. Irma noticed it, and would say: “What makes you so glum, Lanny?” He would answer: “I’m just thinking.” Irma was thinking, too, and guessing that her strange husband wasn’t entirely cured of his Pink vice, and was brooding because the world didn’t behave according to his formulas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pressing against Lanny’s chest on his right side was a wad which he had wrapped in a handkerchief and kept pinned in his inside coat pocket. It contained a large number of hundred-mark notes, which he had acquired by visiting different money-changing agencies in New York, using care to attract no attention. One of the results of his meditations on the problem of what might be happening in Berlin: he had decided that he had taken a serious chance by going to his regular bank, drawing out a large sum, and passing it on to Trudi Schultz. Doubtless the bank had kept a record of the serial numbers of those notes. In Naziland, a record was kept of everything; the hairs of your head were numbered, and if too many sparrows fell to the ground in your garden the fact would be reported to the "), _c('i', [_vm._v("Polizei")]), _vm._v(". Suppose one or more of those notes had been found on Comrade Monck or some other arrested person and the source of the funds had been traced! This was just one of a great number of imaginations which were trying to ruin a yachting-regatta for Lanny Budd.")])])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(198),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(204),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(210),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(216),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(240),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(243),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(246),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(258),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(261),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(264),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(267),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(273),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(276),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(279),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(282),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(285),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(288),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(291),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(294),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(297),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(300),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(303),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(306),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(315),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(321),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(324),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(327),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(330),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(342),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(345),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(348),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(351),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(354),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(357),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(360),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(363),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(366),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(369),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(372),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(375),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(378),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(381),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(387),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(393),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(399),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(402),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(405),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(411),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(414),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(417),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(420),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(423),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(435),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(441),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(447),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(450),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(453),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(459),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(468),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(471),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(474),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(477),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(480),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(483),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(486),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781504052757',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(490)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(492);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 492 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.397820b84ed1cfff7c72.js